import { mainURL, prodURL } from "./common";

export const wrongFile = true;
export const UiThemeBlueColor = "#302ba0";

export const kmcMarketList = [
  {
    slNo: 1,
    name: "164A, A.J.C BOSE ROAD",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal1",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 2,
    name: "AKRA FATAK HAWKERS MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal2",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 3,
    name: "BAGHAJATIN MARKET COMPLEX (UNIT IV)",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal3",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 4,
    name: "BAGHAJATIN MARKET UNIT- I",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal4",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 5,
    name: "BAGHAJATIN MARKET UNIT- II",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal5",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 6,
    name: "BAGHAJATIN MARKET UNIT- III",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal6",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 7,
    name: "BAKUL TALA (SSU)",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal7",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 8,
    name: "BANSDRONI MPL. MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal8",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 9,
    name: "BARTALA HAWKERS MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal9",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 10,
    name: "COLLEGE SQUARE HAWKERS CORNER",
    address: "",
    pinCode: "700073",
    phone: "",
    modalId: "exampleModal10",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 11,
    name: "COLLEGE STREET MARKET",
    address: "COLLEGE STREET",
    pinCode: "",
    phone: "",
    modalId: "exampleModal11",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 12,
    name: "DESHAPRIYA PARK HAWKERS CORNER",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal12",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 13,
    name: "DESHBANDHU MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal13",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 14,
    name: "DHAKURIA MARKET COMPLEX",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal14",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 15,
    name: "DR. A P J ABDUL KALAM FOOD COURT",
    address: "WARD-118, 38/2, S.N.ROY ROAD, KOLKATA",
    pinCode: "",
    phone: "",
    modalId: "exampleModal15",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 16,
    name: "ENTALLY MARKET",
    address: "ENTALLY",
    pinCode: "",
    phone: "",
    modalId: "exampleModal16",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 17,
    name: "FUTNANI CHAMBER",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal17",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 18,
    name: "G.R HAWKERS MARKET(BICHALIGHAT)",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal18",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 19,
    name: "GARIAHAT MARKET",
    address: "GARIAHAT MARKET",
    pinCode: "",
    phone: "",
    modalId: "exampleModal19",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 20,
    name: "GOBRA MUNICIPAL MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal20",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 21,
    name: "JADAVGARH MPL MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal21",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 22,
    name: "KALIGHAT PARK HAWKERS CORNER",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal22",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 23,
    name: "KALITALA MPL BR XI",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal23",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 24,
    name: "LAKE ROAD MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal24",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 25,
    name: "LALAR MATH MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal25",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 26,
    name: "LANSDOWN MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal26",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 27,
    name: "Late Bholanath Mukherjee and Debapriya Bose Bazar",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal27",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 28,
    name: "MANICKTALA - KANKURGACHI MPL. MKT.",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal28",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 29,
    name: "MANTON SUPER (S.S.U)",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal29",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 30,
    name: "NEW ALIPORE MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal30",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 31,
    name: "NIMTALA GHAT STREET MARKET COMPLEX",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal31",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 32,
    name: "ORPHANGUNGE MARKET",
    address: "WARD-074, 38/2, KHIDDERPORE, BR- IX, KOLKATA",
    pinCode: "",
    phone: "",
    modalId: "exampleModal32",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 33,
    name: "PAM PLAZA GARIAHAT",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal33",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 34,
    name: "PARK CIRCUS",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal34",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 35,
    name: "PAURA PAUNYA BITHIKA",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal35",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 36,
    name: "PURBA PUTIARY MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal36",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 37,
    name: "RAMLAL MUNICIPAL MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal37",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 38,
    name: "REGENT PARK MKT.",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal38",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 39,
    name: "ROXY BUILDING",
    address: "4A & 4B, Chowringhee Place, Kolkata",
    pinCode: "",
    phone: "",
    modalId: "exampleModal39",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 40,
    name: "S C ALLEN MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal40",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 41,
    name: "S. S. HOGG MARKET",
    address: "NEW MARKET KOLKATA",
    pinCode: "",
    phone: "",
    modalId: "exampleModal41",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 42,
    name: "S.N.ROY RD. SUPER MARKET (SSU)",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal42",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 43,
    name: "SAKHER BAZAR SUPER MARKET",
    address: "SAKHER BAZAR SUPER MARKET",
    pinCode: "",
    phone: "",
    modalId: "exampleModal43",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 44,
    name: "SANTOSHPUR MUNICIPAL",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal44",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 45,
    name: "SATYANARAYAN PARK MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal45",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 46,
    name: "SHIBRAMPUR MUNICIPAL MARKET",
    address: "KASTHADANGA ROAD, SHIBRAMPUR",
    pinCode: "700061",
    phone: "",
    modalId: "exampleModal46",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 47,
    name: "SIR GURUDAS MPL MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal47",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 48,
    name: "SISIR MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal48",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 49,
    name: "SUNIL NAGAR MARKET",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal49",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 50,
    name: "ULTADANGA MPL. MARKET",
    address: "20, ULTADANGA MAIN ROAD, KOL-67",
    pinCode: "700067",
    phone: "",
    modalId: "exampleModal50",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 51,
    name: "ULTADANGA VIP ROAD CROSSING MARKET",
    address: "ULTADANGA VIP ROAD",
    pinCode: "700067",
    phone: "",
    modalId: "exampleModal51",
    title: "Title",
    header: "Header",
    para: "Para",
  },
  {
    slNo: 52,
    name: "VIDYASAGAR MANCHA",
    address: "",
    pinCode: "",
    phone: "",
    modalId: "exampleModal52",
    title: "Title",
    header: "Header",
    para: "Para",
  },
];

export const waterForFireFightersFilterWaterList = [
  {
    waterSupplyInstallations: "Tallah Pumping Station",
    location: "The low level road of Tallah bridge",
    fileStoreId: "0a8deec3-d158-41b1-ab00-a54e9fdfff83",
  },
  {
    waterSupplyInstallations: "Jorabagan Pumping Station",
    location: "Inside the pumping station beside Baishnab Sett Street",
    fileStoreId: "8c1e4d8e-f115-4a94-bcba-aeb66d7e688d ",
  },
  {
    waterSupplyInstallations: "Raja Subodh Mullick Sq. BPS",
    location: "At the junction of Creek Row & Raja Subodh Mullick Sq.",
    fileStoreId: "32ea2489-84ce-4116-8696-20677d75dd7d",
  },
  {
    waterSupplyInstallations: "Auckland Sq. BPS",
    location:
      "At the junction of A.J.C. Bose Road & Auckland Place, near 'Mouchak'.",
    fileStoreId: "cd341049-53ed-498a-a9f6-a88f84d8a8cb",
  },
  {
    waterSupplyInstallations: "Park Circus BPS",
    location: "At the junction of Orient Row & New Park Street.",
    fileStoreId: "f2d3a26e-9a8f-4535-b865-4628bcd8bfdd",
  },
  {
    waterSupplyInstallations: "Kalighat BPS",
    location: "Near Kalighat Tram Depot",
    fileStoreId: "1f890a4b-07df-432d-8c19-3645f8d0e341",
  },
  {
    waterSupplyInstallations: "Kasba BPS",
    location: "At the junction of Rashbehari Connector & Bose Pukur Road",
    fileStoreId: "26db161d-6afc-4c2e-a832-8e6f8a755cba",
  },
  {
    waterSupplyInstallations: "Ranikuthi BPS",
    location: "Near Ranikuthi Telephone Exchange",
    fileStoreId: "ba91fe65-e7a2-4241-8b52-60e6cce9a597",
  },
  {
    waterSupplyInstallations: "Behala BPS",
    location: "At the junction of Behala Chowrasta on Ho-Chi-Minh Sarani",
    fileStoreId: "54473c7a-3828-488a-b5ae-f2a864394625",
  },
  {
    waterSupplyInstallations: "Garden Reach Water Works",
    location: "Within the GRWW campus near Nature Park",
    fileStoreId: "e7e3ddf-e7a1-4bee-9bdf-984386ed37e1",
  },
];

export const waterForFireFightersUnfilterWaterList = [
  {
    waterSupplyInstallations: "Mullick Ghat Pumping Station",
    location: "Adjacent to Brabourne Road fly-over",
    fileStoreId: "ccec559d-501a-4146-aecc-d318ba35097a",
  },
];

export const waterForFireFightersTubewellWaterList = [
  {
    waterSupplyInstallations: "Prince Anwar Shah Road",
    location: "Near South City",
    fileStoreId: "0d93cd6e-b3a7-4c04-9df5-ec855e12b2ec",
  },
  {
    waterSupplyInstallations:
      "Big Dia Meter Tubewell Spout Arupota, Dhapa, South Sealdh",
    location: "South Part of EM Bypass (Ward 57,58)",
    fileStoreId: "18022926-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations:
      "Big Dia Meter Tubewell Spout CREMATORIUM STREET, SHARIF LANE CROSSING",
    location: "Park Circus Tram Depo. (Ward 61,62)",
    fileStoreId: "18004526-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations:
      "Big Dia Meter Tubewell Spout TILJALA, TOPSIA, G J KHAN RD, CHOWBHAGA, KUSTIA",
    location: "7 Point Park Circus-EM By Pass Connector (Ward 66)",
    fileStoreId: "18004626-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations:
      "Big Dia Meter Tubewell Spout PICNIC Garden, KASHBA BPS",
    location: "Rash Behari Bypass Connector (Ward 67)",
    fileStoreId: "18004726-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations: "Big Dia Meter Tubewell Spout EKDALIA, KAKULIA",
    location: "Gariahat Area (Ward 68)",
    fileStoreId: "18004826-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations:
      "Big Dia Meter Tubewell Spout St. Lawrence High School",
    location: "Ballygunge Phari Area (Ward 69)",
    fileStoreId: "18004926-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations:
      "Big Dia Meter Tubewell Spout Harish Chatterjee St., Kalighat",
    location: "Bhowanipur Area (Ward 73)",
    fileStoreId: "18005026-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations:
      "Big Dia Meter Tubewell Spout DURGAPUR LANE, BELVEDERE ROAD",
    location: "Alipore Area (Ward 74)",
    fileStoreId: "18005126-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations: "Big Dia Meter Tubewell Spout EKBALPORE",
    location: "EKBALPORE Area (Ward 78)",
    fileStoreId: "18005226-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations:
      "Big Dia Meter Tubewell Spout JHALDAR MATH, CHETLA, KALIGHAT",
    location: "Chtla, Kalighat Area (Ward 81,82,83,88)",
    fileStoreId: "18005326-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations:
      "Big Dia Meter Tubewell Spout Charu Avenue, Swiss Park",
    location: "Charu Avenue, Swiss Park Area (Ward 89)",
    fileStoreId: "18005426-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations:
      "Big Dia Meter Tubewell Spout Kolupara, Bose Pukur",
    location: "Rash Behari Bypass Connector (Ward 91)",
    fileStoreId: "18005526-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations:
      "Big Dia Meter Tubewell Spout SAHID NAGAR, New Land, Nashkar Para",
    location: "Dhakuria Area (Ward 92)",
    fileStoreId: "18005626-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations:
      "Big Dia Meter Tubewell Spout Katjunagar, Lake Gardens",
    location: "Jodhpur Park Area (Ward 93)",
    fileStoreId: "18005726-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations: "Tubewell Fire Spout",
    location: "NEW MARKET (Ward 46)",
    fileStoreId: "18005826-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations: "Tubewell Fire Spout",
    location: "CHAPLIN SQUARE (Ward 46)",
    fileStoreId: "18005826-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations: "Tubewell Fire Spout",
    location: "NANDARAM MARKET (Ward 45)",
    fileStoreId: "18005926-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations: "Tubewell Fire Spout",
    location: "PARTUGUESE CHURCH STREET (Ward 45)",
    fileStoreId: "18006026-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations: "Tubewell Fire Spout",
    location: "18-RABINDRA SARANI (Ward 43)",
    fileStoreId: "18006126-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations: "Tubewell Fire Spout",
    location: "TARACHAND DUTTA STREET (Ward 44)",
    fileStoreId: "18006226-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations: "Tubewell Fire Spout",
    location: "ORPHANGUNGE MARKET (Ward 77)",
    fileStoreId: "18006326-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations: "Tubewell Fire Spout",
    location: "RAJABAZAR CROSSING (Ward 36)",
    fileStoreId: "18006426-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations: "Tubewell Fire Spout",
    location: "HATIBAGAN (Ward 11)",
    fileStoreId: "18006526-2a59-4f3c-8a94-891f18042026",
  },
  {
    waterSupplyInstallations: "Tubewell Fire Spout",
    location: "AKHIL MISTRY LANE (Ward 49)",
    fileStoreId: "18006626-2a59-4f3c-8a94-891f18042026",
  },
];

export const MapsOfMarketDocList = [
  {
    fileStoreId: "18004526-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-61,62_Final",
  },
  {
    fileStoreId: "18004626-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-66_Final",
  },
  {
    fileStoreId: "18004726-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-67_Final",
  },
  {
    fileStoreId: "18004826-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-68_Final",
  },
  {
    fileStoreId: "18004926-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-69_Final",
  },
  {
    fileStoreId: "18005026-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-73_Final",
  },
  {
    fileStoreId: "18005126-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-74_Final",
  },
  {
    fileStoreId: "18005226-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-78_Final",
  },
  {
    fileStoreId: "18005326-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-81,82,83,88_Final",
  },
  {
    fileStoreId: "18005426-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-89_Final",
  },
  {
    fileStoreId: "18005526-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-91_Final",
  },
  {
    fileStoreId: "18005626-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-92_Final",
  },
  {
    fileStoreId: "18005726-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD-93_Final",
  },
  {
    fileStoreId: "18022926-2a59-4f3c-8a94-891f18042026",
    label: "Spout_WD_57_58_Final",
  },
];

export const TenderDocumentList = [
  {
    fileStoreId: "18023026-2a59-4f3c-8a94-891f18042026",
    label:
      "Tender Document for Allotment of Stall at Sir Stuart Hogg Market (New Market)",
  },
  {
    fileStoreId: "18023126-2a59-4f3c-8a94-891f18042026",
    label: "Tender Document for Allotment of Stalls at Gariahat Market",
  },
  {
    fileStoreId: "18023226-2a59-4f3c-8a94-891f18042026",
    label:
      "Tender Document for Allotment of Vacant Stalls at Maniktala Kankurgachi (VIP) Municipal Market",
  },
  {
    fileStoreId: "18023326-2a59-4f3c-8a94-891f18042026",
    label: "Tender Document for allotment of stalls at Jadavgarh Market",
  },
  {
    fileStoreId: "18023426-2a59-4f3c-8a94-891f18042026",
    label: "Tender Document for Allotment of Stalls at Manton Super Market",
  },
];

export const IssuesWithTheARVSystem = [
  "There is scope for subjectivity in ARV system which may lead to arbitrariness causing real or perceived unfairness in the eyes of the property taxpayer",
  "It becomes difficult to establish reasonable rent for various types of properties since it is subjective in nature and often varies from person to person",
  "As the methodology for determining Annual Valuation depends on received-rent, there is a tendency to misrepresent the actual rent",
  "Citizens' support to the ARV system is scarce and that leads to poor compliance",
  "To seek relief, the assessee often resorts to litigation causing wastage of time and resource",
  "There is no scope for self assessment by the assessee",
];

export const SexualHarassmentRedressalCellSubMEnuList = [
  {
    fileStoreId: "b5a58351-96f7-445b-b6db-a4b0e2bd7dd4",
    label: "Important Points for making Complaints",
  },
  {
    fileStoreId: "d4d540c3-ab1c-48a4-9a0f-77a3e0293874",
    label:
      "Sexual Harassment of Women at Work place(Prevention,Prohibition and Redressal)Act,2013",
  },
  {
    fileStoreId: "a21d501f-187c-4127-95d2-00affc6e5dda",
    label: "Ch.Manager(P)'s Circular No.20/SHC of 2018-19 dated 19.06.2018",
  },
  {
    fileStoreId: "29ba3c8a-1a37-4862-a509-e09467b40420",
    label:
      "Chief Manager(Personal)'s Circular No.26/SHRC of 2021-22 dated 27.07.2021",
  },
  {
    fileStoreId: "08337512-be9a-4905-9e64-b9c5a0bd6517",
    label:
      "Chief Manager(Personal)'s Circular No.19/SHRC of 2024-25 dated 06.08.2024",
  },
];

export const COMPENDIUMSubMEnuList = [
  {
    fileStoreId: "bee1ed2c-73d7-4236-8fe6-2588d0bc9e68 ",
    label: "FY 2010-11",
  },
  {
    fileStoreId: "28f380a9-80c0-43b2-beaf-2593d5ffcd5e",
    label: "FY 2011-12",
  },
  {
    fileStoreId: "6ebdc025-9c3c-4c3c-8f9c-21cfb544a042",
    label: "FY 2012-13",
  },
  {
    fileStoreId: "cd1513aa-8d2b-49eb-960d-1e9effefb978",
    label: "FY 2013-14",
  },
];

export const ImportantInformationSliderList = [

  {
    imgSrc: "assets/img/Banner/about.png",
    navLink: "https://kmc.wb.gov.in/contact-us/mmic",
    navName: "home_sliding_logo_text5",
    linkType: "external",
  },

  // {
  //   imgSrc: "assets/img/Banner/about.png",
  //   navLink: "/Overview",
  //   navName: "home_sliding_logo_text5",
  //   linkType: "internal",
  // },
  {
    imgSrc: "assets/img/imp-pic/Malaria Clinics.jpg",
    navLink: "/Health_Malaria_CLinics",
    navName: "home_sliding_logo_text2",
    linkType: "internal",
  },
  {
    imgSrc: "assets/img/imp-pic/Maternity-Homes.jpg",
    navLink: "/Health_Maternity_Homes",
    navName: "home_sliding_logo_text3",
    linkType: "internal",
  },
  {
    imgSrc: "assets/img/imp-pic/KMC_monitor_water_wastage_3.jpg",
    navLink: "/WaterStations",
    navName: "home_sliding_logo_text4",
    linkType: "internal",
  },

  {
    imgSrc: "assets/img/Banner/about.png",
    navLink: "https://kmc.wb.gov.in/contact-us/councillors",
    navName: "home_sliding_logo_text6",
    linkType: "external",
  },

  {
    imgSrc: "assets/img/imp-pic/chest-clinic.PNG",
    navLink: "/Health_Chest_Clinincs",
    navName: "home_sliding_logo_text8",
    linkType: "internal",
  },

  {
    imgSrc: "assets/img/imp-pic/Birth Registration Centers.jpg",
    navLink: "/Birth_Ragistration_center",
    navName: "home_sliding_logo_text10",
    linkType: "internal",
  },

  {
    imgSrc: "assets/img/imp-pic/Drainage Pumping Stations.jpg",
    navLink: "/Drainage_Drainage_Pumping_station",
    navName: "home_sliding_logo_text12",
    linkType: "internal",
  },

  {
    imgSrc: "assets/img/Banner/Councillors.jfif",
    navLink: "https://kmc.wb.gov.in/contact-us/mmic",
    navName: "home_sliding_logo_text7",
    linkType: "external",
  },

  {
    imgSrc: "assets/img/Banner/Dispensaries.jpg",
    navLink: "/Health_KMC_Dispensaries",
    navName: "home_sliding_logo_text9",
    linkType: "internal",
  },

  {
    imgSrc: "assets/img/Banner/Crematoriums.PNG",
    navLink: "/KMCCrematorium",
    navName: "home_sliding_logo_text11",
    linkType: "internal",
  },

  {
    imgSrc: "assets/img/Banner/e_kolkata_Citizen_Service_6.jpg",
    navLink: "/EKolkataCenter",
    navName: "home_sliding_logo_text13",
    linkType: "internal",
  },
];

export const getNavClass = ({ isActive }) =>
  `nav-link fontSizeClass ${isActive ? "active1" : ""}`;

export const stickyHeaderStyle = {
  position: "sticky",
  top: 0,
  backgroundColor: UiThemeBlueColor,
  zIndex: 2,
};

export const pages = [
  { name: "Portal", path: "/portal" },
  {
    name: "WB Thika Tenancy Act Amendments",
    path: "/WBThikaTenancyActAmendments",
  },
  { name: "KMC Portal", path: "/kmc-portal" },
  { name: "Adminstration", path: "/Adminstration" },
  { name: "About Us", path: "/AboutUs" },
  { name: "Mayors Of Kolkata", path: "/MayorsOfKolkata" },
  { name: "Municipal History", path: "/MunicipalHistory" },
  { name: "Overview", path: "/Overview" },
  { name: "Power", path: "/Power" },
  { name: "E Kolkata Center", path: "/EKolkataCenter" },
  { name: "Functions", path: "/Functions" },
  { name: "KMC Functions", path: "/KMCFunctions" },
  { name: "Revenue", path: "/Revenue" },
  { name: "Emblem", path: "/Emblem" },
  { name: "KMC Budget", path: "/KMCBudget" },
  { name: "Office Order Circular", path: "/OfficeOrderCircular" },
  { name: "Basic Statestics", path: "/Basic_statestics" },
  { name: "Basic Statistic", path: "/Basic_Statistic" },
  { name: "Citizen Login", path: "/CitizenLogin" },
  {
    name: "Advertisement Download Forms",
    path: "/Advertisement_download_forms",
  },
  { name: "Advertisement Dept", path: "/Advertisement_Dept" },
  {
    name: "Advertisement List Of Hoarding",
    path: "/Advertisement_ListOf_Hoarding",
  },
  { name: "Advertisement Rates", path: "/Advertisement_rates" },
  { name: "Amusement Download Forms", path: "/Amusement_download_forms" },
  { name: "Amusement", path: "/Amusement" },
  {
    name: "Amusement Important Officials",
    path: "/Amusement_important_officials",
  },
  { name: "Birth Ragistration Center", path: "/Birth_Ragistration_center" },
  { name: "Birth Death Ragistration", path: "/Birth_Death_Ragistration" },
  { name: "Death Record", path: "/Death_Record" },
  { name: "Death Ragistration Center", path: "/Death_Ragistration_center" },
  { name: "About Kolkata", path: "/About_Kolkata" },
  { name: "Amusement Parks", path: "/Amusement_Parks" },
  { name: "History Of Kolkata", path: "/History_Of_Kolkata" },
  { name: "KMC Department", path: "/KMC_Department" },
  { name: "List Of Counters", path: "/List_Of_Counters" },
  { name: "Map", path: "/Map" },
  { name: "Architecture", path: "/Architecture" },
  { name: "Art Galleries", path: "/Art_Galleries" },
  { name: "Other Noteable Place", path: "/Other_Noteable_place" },
  { name: "Places Of Interest", path: "/Places_Of_Interest" },
  { name: "KMC Central Records Home", path: "/KMC_Central_records_Home" },
  { name: "KMC Central Records Fees", path: "/KMC_Central_records_Fees" },
  { name: "Nagarbandhu", path: "/Nagarbandhu" },
  {
    name: "KMC Bustee Service Contact Details",
    path: "/KMC_Bustee_service_contact_details",
  },
  { name: "KMC Bustee Services", path: "/KMC_Bustee_services" },
  { name: "Check Demands Payable", path: "/Check_Demands_Payable" },
  { name: "Check Demands Status", path: "/Check_Demands_Status" },
  { name: "Download Forms", path: "/Download_Forms" },
  { name: "Find Plumbers", path: "/Find_Plumbers" },
  { name: "List Of Tenders", path: "/List_Of_Tenders" },
  { name: "Make Online Payment", path: "/Make_Online_Payment" },
  { name: "Print Unpaid Bill", path: "/Print_Unpaid_Bill" },
  { name: "Reprint Eprint", path: "/Reprint_Eprint" },
  { name: "Tender Batra", path: "/Tender_Batra" },
  { name: "Water For Fire Fighter", path: "/Water_For_Fire_Fighter" },
  { name: "Water Supply", path: "/Water_Supply" },
  { name: "Water Supply Fee Charges", path: "/Water_Supply_Fee_Charges" },
  { name: "Water Stations", path: "/WaterStations" },
  { name: "BSUP", path: "/BSUP" },
  { name: "Mom Tvc", path: "/Mom_tvc" },
  {
    name: "KMC Bustee Services Check Demands Payable",
    path: "/KMC_Bustee_Services_Check_Demands_Payable",
  },
  {
    name: "Bustee Services Make Online Payment",
    path: "/Bustee_Services_Make_Online_Payment",
  },
  { name: "Central Records Fees", path: "/Central_Records_Fees" },
  { name: "Drainage Contact Details", path: "/Drainage_Contact_Details" },
  { name: "KMC Drainage Activity", path: "/KMC_Drainage_Activity" },
  {
    name: "Drainage Make Online Payment",
    path: "/Drainage_Make_Online_Payment",
  },
  { name: "Drainage Reprint E Receipt", path: "/Drainage_Reprint_e_Receipt" },
  {
    name: "Drainage Sewerage Treatment Plants",
    path: "/Drainage_Sewerage_Treatment_Plants",
  },
  { name: "Citizen Services", path: "/Citizen_services" },
  { name: "KMC Advertisement", path: "/KMC_Advertisement" },
  {
    name: "KMC Advertisement Unpaid Advertisement Fee Search",
    path: "/KMC_Advertisement_unpaid_advertisement_fee_search",
  },
  {
    name: "KMC Advertisement Reprint E Receipts",
    path: "/KMC_Advertisement_reprint_e_receipts",
  },
  {
    name: "KMC Advertisement Make Online Payment",
    path: "/KMC_Advertisement_make_Online_Payment",
  },
  {
    name: "KMC Advertisement Know Your Agent Code",
    path: "/KMC_Advertisement_know_your_agent_code",
  },
  {
    name: "KMC Advertisement Indicative Tax Calculator",
    path: "/KMC_Advertisement_Indicative_tax_calculator",
  },
  { name: "Advertisement Citizen Login", path: "/Advertisement_citizen_login" },
  { name: "CH VS Dept Contact Details", path: "/CH_VS_Dept_Contact_Details" },
  { name: "CH VS Dept Download Forms", path: "/CH_VS_Dept_Download_Forms" },
  {
    name: "CH VS Dept Make Online Payment",
    path: "/CH_VS_Dept_Make_online_payment",
  },
  {
    name: "CH VS Dept Print Unpaid Bill",
    path: "/CH_VS_Dept_Print_Unpaid_Bill",
  },
  { name: "CH VS Dept Rates Charges", path: "/Ch_VS_Dept_Rates_Charges" },
  {
    name: "CH VS Dept Reprint E Receipt Development Fee",
    path: "/CH_VS_Dept_Reprint_e_Receipt_Development_Fee",
  },
  {
    name: "CH VS Dept Reprint E Receipt GIS Map",
    path: "/CH_VS_Dept_Reprint_e_Receipt_GIS_Map",
  },
  {
    name: "CH VS Dept Reprint E Receipt SOR",
    path: "/CH_VS_Dept_Reprint_e_Receipt_SOR",
  },
  {
    name: "Drainage Check Demands Payable",
    path: "/Drainage_Check_Demands_Payable",
  },
  { name: "Drainage Fees Charges", path: "/Drainage_Fees_Charges" },
  { name: "Drainage Print Unpaid Bill", path: "/Drainage_Print_Unpaid_Bill" },
  {
    name: "Drainage Ward Wise Drainage Map",
    path: "/Drainage_Ward_wise_drainage_map",
  },
  {
    name: "Education Dept Contact Details",
    path: "/Education_Dept_Contact_Details",
  },
  { name: "Engineering Contact Details", path: "/Engineering_Contact_Details" },
  { name: "Engineering Home", path: "/Engineering_Home" },
  { name: "Engineering Rates Charges", path: "/Engineering_Rates_Charges" },
  {
    name: "Engineering Manhole Desilting Programme",
    path: "/Engineering_Manhole_Desilting_Programme",
  },
  {
    name: "Engi Man Desil Prog Civil Bro 30 6 2024",
    path: "/Engi_Man_Desil_Prog_civil_Bro_30_6_2024",
  },
  { name: "Schedule Of Fees", path: "/Schedule_Of_Fees" },
  { name: "Solid Waste Management Faqs", path: "/Solid_waste_management_faqs" },
  { name: "Solid Wastes Home", path: "/Solid_wastes_home" },
  {
    name: "Solid Waste Water Supply Faqs",
    path: "/Solid_Waste_water_supply_faqs",
  },
  {
    name: "Heritage Conservation Architect",
    path: "/Heritage_Conservation_Architect",
  },
  { name: "Heritage Contact Details", path: "/Heritage_Contact_Details" },
  { name: "Heritage Exemption Of Tax", path: "/Heritage_Exemption_of_Tax" },
  { name: "Heritage Building Home", path: "/HeritageBuildingHome" },
  { name: "Heritage Building Home2", path: "/HeritageBuildingHome2" },
  { name: "Heritage Building Home3", path: "/HeritageBuildingHome3" },
  { name: "Heritage Building Home4", path: "/HeritageBuildingHome4" },
  { name: "Heritage Heritage Buildings", path: "/Heritage_Heritage_Buildings" },
  { name: "Heritage Proceedings Of HCC", path: "/Heritage_Proceedings_of_HCC" },
  {
    name: "Heritage Wardwise Heritage Buildings",
    path: "/Heritage_Wardwise_Heritage_Buildings",
  },
  { name: "Heritage Wardwise Pond", path: "/Heritage_Wardwise_Pond" },
  {
    name: "Market Check Demands Payable",
    path: "/Market_Check_demands_payable",
  },
  // {
  //   name: "Download Market Fire Fighting Video",
  //   path: "/Download_market_fire_fighting_video",
  // },
  { name: "KMC Market List", path: "/KMC_market_list" },
  { name: "Market Stall Search", path: "/Market_stall_search" },
  { name: "Market List Of E Receipts", path: "/Market_list_of_e_receipts" },
  { name: "Maps Of Market", path: "/Maps_of_market" },
  { name: "Misclennious Demand", path: "/Misclennious_demand" },
  { name: "Regular Demand", path: "/Regular_Demand" },
  { name: "Tender", path: "/Tender" },
  { name: "Office Order", path: "/Office_Order" },
  { name: "Parks And Gardens", path: "/Parks_and_gardens" },
  {
    name: "Social Welfare Download Forms",
    path: "/Social_welfare_Download_Forms",
  },
  { name: "Govt Sponsored Schemes", path: "/Govt_Sponsored_Schemes" },
  { name: "GR Recipients", path: "/GR_Recipients" },
  { name: "Ward Wise BPL List", path: "/Ward_Wise_BPL_List" },
  {
    name: "Housing Urban Poor Form And Site Plan",
    path: "/Housing_Urban_Poor_Form_and_Site_Plan",
  },
  { name: "Drainage Home", path: "/Drainage_Home" },
  { name: "Drainage Faqs", path: "/Drainage_Faqs" },
  {
    name: "List Of KMC Drainage Activity",
    path: "/List_of_KMC_Drainage_Activity",
  },
  {
    name: "List Of Sewage Treatment Plants",
    path: "/List_of_Sewage_Treatment_Plants",
  },
  { name: "Health Ambulances", path: "/Health_Ambulances" },
  { name: "Health Chest Clinincs", path: "/Health_Chest_Clinincs" },
  { name: "Health Maternity Homes", path: "/Health_Maternity_Homes" },
  { name: "Health KMC Dispensaries", path: "/Health_KMC_Dispensaries" },
  { name: "Health Malaria C Linics", path: "/Health_Malaria_CLinics" },
  { name: "Health MTMTB Hospital", path: "/Health_MTMTB_Hospital" },
  { name: "Health Services Health Home", path: "/Health_services_Health_Home" },
  {
    name: "Health Antirabies VACCINATION Center",
    path: "/Health_Antirabies_VACCINATION_Center",
  },
  { name: "Health Burning Ghat Status", path: "/Health_Burning_Ghat_Status" },
  { name: "Health Desease Control", path: "/Health_Desease_control" },
  {
    name: "Health Designation Activities",
    path: "/Health_Designation_Activities",
  },
  { name: "Health Fees Charges", path: "/Health_Fees_Charges" },
  { name: "Health KMDA Health Projects", path: "/Health_KMDA_Health_Projects" },
  { name: "Health Slaughter House", path: "/Health_Slaughter_House" },
  { name: "Health Water Test E Receipt", path: "/Health_Water_Test_e_Receipt" },
  { name: "Lighting Fees", path: "/Lighting_Fees" },
  { name: "Lighting Home", path: "/Lighting_Home" },
  {
    name: "Assessment Collection Download Forms",
    path: "/Assessment_collection_download_forms",
  },
  {
    name: "Assessment Collection Message Board",
    path: "/Assessment_collection_Message_Board",
  },
  {
    name: "Assessment Collection Notice",
    path: "/Assessment_collection_Notice",
  },
  {
    name: "Assessment Collection Process Muation",
    path: "/Assessment_collection_Process_Muation",
  },
  { name: "Land Records Burial Grounds", path: "/Land_Records_Burial_Grounds" },
  {
    name: "Assessment Collection Assessment Home",
    path: "/Assessment_Collection_Assessment_Home",
  },
  {
    name: "Assessment Collection Unit Area Assessment",
    path: "/Assessment_Collection_Unit_Area_Assessment",
  },
  { name: "Certificate Of Enlistment", path: "/Certificate_of_Enlistment" },
  { name: "Licence Download Form", path: "/Licence_download_form" },
  {
    name: "Current Circular Notes Guidelines",
    path: "/Current_Circular_Notes_Guidelines",
  },
  {
    name: "Duplicate Demand Issuing Offices",
    path: "/Duplicate_Demand_Issuing_Offices",
  },
  { name: "List Of Unit Offices", path: "/List_of_unit_offices" },
  {
    name: "Requirements For Obtaining CE",
    path: "/Requirements_For_Obtaining_CE",
  },
  {
    name: "Licence Chec Demands Payable",
    path: "/Licence_Chec_Demands_Payable",
  },
  { name: "Licence Make Online Payment", path: "/Licence_Make_Online_Payment" },
  { name: "Licence E Receipt Cum CE", path: "/Licence_E_Receipt_cum_CE" },
  {
    name: "User Login Online Application For Change",
    path: "/User_login_Online_Application_For_Change",
  },
  { name: "Licence View CE Information", path: "/Licence_View_CE_Information" },
  { name: "Car Parking Home", path: "/Car_Parking_Home" },
  { name: "Car Parking Rate Chart", path: "/Car_Parking_Rate_Chart" },
  { name: "Car Parking FAQ", path: "/Car_Parking_FAQ" },
  {
    name: "Building Sanction Building Home",
    path: "/Building_Sanction_Building_Home",
  },
  {
    name: "Building Sanction Circular 2013 14",
    path: "/Building_Sanction_Circular_2013_14",
  },
  {
    name: "Building Sanction Circular 2014 15",
    path: "/Building_Sanction_Circular_2014_15",
  },
  {
    name: "Building Sanction Circular 2015 16",
    path: "/Building_Sanction_Circular_2015_16",
  },
  {
    name: "Building Sanction Circular 2016 17",
    path: "/Building_Sanction_Circular_2016_17",
  },
  {
    name: "Building Sanction Circular 2017 18",
    path: "/Building_Sanction_Circular_2017_18",
  },
  {
    name: "Building Sanction Circular 2019 20",
    path: "/Building_Sanction_Circular_2019_20",
  },
  {
    name: "Building Sanction Circular 2021 22",
    path: "/Building_Sanction_Circular_2021_22",
  },
  {
    name: "Building Sanction Circular 2022 23",
    path: "/Building_Sanction_Circular_2022_23",
  },
  {
    name: "Building Sanction Circular 2020 21",
    path: "/Building_Sanction_Circular_2020_21",
  },
  {
    name: "Building Sanction Borough Offices",
    path: "/Building_Sanction_Borough_Offices",
  },
  {
    name: "Building Sanction Circular 2010 11",
    path: "/Building_Sanction_Circular_2010_11",
  },
  {
    name: "Building Sanction Circular 2011 12",
    path: "/Building_Sanction_Circular_2011_12",
  },
  { name: "Govt Memo", path: "/Govt_memo" },
  { name: "Building Dept Fees", path: "/BuildingDeptFees" },
  {
    name: "Building Sanction Floor Area Ratio",
    path: "/Building_Sanction_Floor_Area_Ratio",
  },
  {
    name: "Building Sanction Ground Covergae",
    path: "/Building_Sanction_Ground_Covergae",
  },
  {
    name: "Building Sanction Download Forms",
    path: "/Building_Sanction_Download_Forms",
  },
  {
    name: "Building Sanction Important EODB Circulars",
    path: "/Building_Sanction_Important_EODB_circulars",
  },
  {
    name: "Building Sanction Communique",
    path: "/Building_Sanction_Communique",
  },
  { name: "Officer Order", path: "/Officer_Order" },
  { name: "Building Office Oreder 2020", path: "/Building_OfficeOreder_2020" },
  { name: "Building Office Oreder 2019", path: "/Building_OfficeOreder_2019" },
  { name: "Building Office Oreder 2018", path: "/Building_OfficeOreder_2018" },
  { name: "Building Office Oreder 2017", path: "/Building_OfficeOreder_2017" },
  { name: "Building Office Oreder 2016", path: "/Building_OfficeOreder_2016" },
  { name: "Building Office Oreder 2015", path: "/Building_OfficeOreder_2015" },
  { name: "Building Office Oreder 2014", path: "/Building_OfficeOreder_2014" },
  { name: "Building Office Oreder 2013", path: "/Building_OfficeOreder_2013" },
  { name: "Building Office Oreder 2012", path: "/Building_OfficeOreder_2012" },
  { name: "Building Office Oreder 2011", path: "/Building_OfficeOreder_2011" },
  { name: "Building Office Oreder 2010", path: "/Building_OfficeOreder_2010" },
  { name: "Central Records Home", path: "/Central_records_home" },
  { name: "Central Records Fee", path: "/Central_records_fee" },
  { name: "Education Part", path: "/Education_part" },
  { name: "Vigilance", path: "/Vigilance" },
  { name: "KMC School Home", path: "/Kmc_school_home" },
  { name: "List Of School", path: "/List_of_school" },
  { name: "Urgent Notice", path: "/Urgent_Notice" },
  { name: "KMC School FAQ", path: "/KMC_School_Faq" },
  { name: "Auction", path: "/Auction" },
  { name: "Download Form", path: "/Download_Form" },
  { name: "KMC Recruitments", path: "/KMC_Recruitments" },
  { name: "Borough Committee", path: "/Borough_Committee" },
  { name: "Councillors", path: "/Councillors" },
  { name: "KMC Crematorium", path: "/KMCCrematorium" },
  { name: "KMC Results", path: "/KMC_Results" },
  { name: "KMC Training", path: "/KMC_Training" },
  { name: "Amusement Dept", path: "/Amusement_Dept" },
  { name: "Assessment Dept", path: "/Assessment_Dept" },
  { name: "Bustee Dept", path: "/Bustee_Dept" },
  { name: "Car Parking Dept", path: "/Car_Parking_Dept" },
  { name: "Chief Eng Dept", path: "/Chief_Eng_Dept" },
  { name: "CH VS Dept", path: "/Ch_VS_Dept" },
  { name: "Contact Us Home", path: "/Contact_Us_Home" },
  { name: "E Waste", path: "/EWaste" },
  { name: "Education Dept", path: "/Education_Dept" },
  { name: "Mpl Secretary Dept", path: "/Mpl_Secretary_Dept" },
  { name: "Parks Square Dept", path: "/Parks_Square_Dept" },
  { name: "Social Welfare Urban Dept", path: "/Social_Welfare_Urban_Dept" },
  {
    name: "Town Planning Development Dept",
    path: "/Town_Planning_Development_Dept",
  },
  { name: "Treasury Dept", path: "/Treasury_Dept" },
  {
    name: "Drainage Drainage Pumping Station",
    path: "/Drainage_Drainage_Pumping_station",
  },
  { name: "Sewerage Drainage Dept", path: "/Sewerage_Drainage_Dept" },
  { name: "Electricity Dept", path: "/Electricity_Dept" },
  { name: "Environment Heritage Dept", path: "/Environment_Heritage_Dept" },
  { name: "Finance Dept", path: "/Finance_Dept" },
  { name: "Health Dept", path: "/Health_Dept" },
  { name: "IT Dept", path: "/IT_Dept" },
  { name: "Internal Audit Dept", path: "/Internal_Audit_Dept" },
  { name: "Law Dept", path: "/Law_Dept" },
  { name: "Licence Dept", path: "/Licence_Dept" },
  { name: "Lighting Dept", path: "/Lighting_Dept" },
  { name: "Market Dept", path: "/Market_Dept" },
  { name: "Personnel Dept", path: "/Personnel_Dept" },
  { name: "Roads Dept", path: "/Roads_Dept" },
  { name: "Solid Waste Dept", path: "/Solid_Waste_Dept" },
  { name: "Water Supply Dept", path: "/Water_Supply_Dept" },
  { name: "CMF Communique 2022 23", path: "/CMF_Communique_2022_23" },
  { name: "CMF Communique 2023 24", path: "/CMF_Communique_2023_24" },
  { name: "CMF Communique 2024 25", path: "/CMF_Communique_2024_25" },
  { name: "Chief Manager Circular", path: "/Chief_Manager_Circular" },
  {
    name: "Municipal Secretary Circular",
    path: "/Municipal_secretary_circular",
  },
  { name: "Procedure", path: "/Procedure" },
  { name: "TERM Cell", path: "/TERM_Cell" },
  { name: "Pollution Control Board", path: "/Pollution_Control_Board" },
  { name: "CBP Home", path: "/CBP_Home" },
  { name: "Vision Strategy", path: "/Vision_Strategy" },
  { name: "Project Faqs", path: "/Project_Faqs" },
  { name: "Citizen Charter Home", path: "/Citizen_charter_Home" },
  { name: "Citizen Charter Ads", path: "/Citizen_Charter_Ads" },
  { name: "President With Charters", path: "/President_with_Charters" },
  { name: "Contact Us Homes", path: "/Contact_Us_Homes" },
  { name: "Controlling Officers", path: "/Controlling_Officers" },
  { name: "MMIC", path: "/MMIC" },
  { name: "Mpnld", path: "/Mpnld" },
  { name: "Beup", path: "/Beup" },
  { name: "Downloadable Forms", path: "/DownloadableForms" },
  { name: "Important Contacts", path: "/Important_Contacts" },
  { name: "Know Your Ward", path: "/Know_Your_Ward" },
  { name: "Building Faqs", path: "/Building_Faqs" },
  { name: "Licence FAQ", path: "/Licence_Faq" },
  { name: "Faqs", path: "/Faqs" },
  { name: "Disclaimer", path: "/Disclaimer" },
  { name: "Quick Links", path: "/Quick_Links" },
  { name: "Water Supply Faqs", path: "/Water_Supply_Faqs" },
  { name: "E News Letter", path: "/E_News_Letter" },
  { name: "E Purashree", path: "/E_Purashree" },
  { name: "E Purashree Slider", path: "/EPurashree_slider" },
  { name: "Archive", path: "/Archive" },
  { name: "Monsoon Book", path: "/Monsoon_Book" },
  { name: "Disaster Mgmt", path: "/Disaster_Mgmt" },
  { name: "Concept Note", path: "/Concept_Note" },
  { name: "Guidelines For Safety", path: "/Guidelines_for_Safety" },
  { name: "Form For Inventory", path: "/Form_For_Inventory" },
  { name: "School Safety Booklet", path: "/School_Safety_Booklet" },
  { name: "Colouring Activity Book", path: "/Colouring_Activity_Book" },
  { name: "UEVRP Home", path: "/UEVRP_Home" },
  { name: "UEVRP Status", path: "/UEVRP_Status" },
  { name: "Earthquake Leaflet", path: "/Earthquake_Leaflet" },
  { name: "EQ Pocket Guide", path: "/EQ_Pocket_Guide" },
  { name: "Dashboard", path: "/Dashboard" },
  { name: "Dashboard2", path: "/Dashboard2" },
  { name: "Whatsapp", path: "/Wathsapp" },
  { name: "Gallery", path: "/Gallery" },
];

export const KMCLeftMenuKMCFinancialStatementsList = [
  {
    btnLabel: "2012- 2013",
    fileList: [
      {
        label: "Receipt and Payment Statement 2012-13",
        fileStoreId: "2606ce4c-c7a3-4be5-abc2-a5051d00681e",
      },
      {
        label: "Income & Expenditure 2012-13",
        fileStoreId: "18009326-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Balance Sheet 2012-13",
        fileStoreId: "18009426-2a59-4f3c-8a94-891f18042026",
      },
    ],
  },
  {
    btnLabel: "2013- 2014",
    fileList: [
      {
        label: "Annual Financial Statement 2013-14",
        fileStoreId: "18009526-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Audit Certificate for ELA 2013-14",
        fileStoreId: "18009626-2a59-4f3c-8a94-891f18042026",
      },
    ],
  },
  {
    btnLabel: "2014- 2015",
    fileList: [
      {
        label: "Receipt and Payment Statement 2014-15",
        fileStoreId: "b5f4b169-9e6a-4c13-a001-0f0631bb0c05",
      },
      {
        label: "Income & Expenditure 2014-15",
        fileStoreId: "18009826-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Balance Sheet 2014-15",
        fileStoreId: "ef66fb43-3b7f-4372-b7e7-2169d1499643",
      },
      {
        label: "Audit Report 2014-15",
        fileStoreId: "b8569f82-5b4e-440d-9943-5e0447887668",
      },
    ],
  },
  {
    btnLabel: "2015- 2016",
    fileList: [
      {
        label: "Receipt and Payment Statement 2015-16",
        fileStoreId: "18010126-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Income & Expenditure 2015-16",
        fileStoreId: "18010226-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Balance Sheet 2015-16",
        fileStoreId: "18010326-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Audit Report 2015-16",
        fileStoreId: "38a11ee9-ba19-4221-b976-d8930eac0eee",
      },
    ],
  },
  {
    btnLabel: "2016- 2017",
    fileList: [
      {
        label: "Receipt and Payment Statement 2016-17",
        fileStoreId: "18010526-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Income & Expenditure 2016-17",
        fileStoreId: "18010626-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Balance Sheet 2016-17",
        fileStoreId: "18010726-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Audit Report 2016-17",
        fileStoreId: "70b11665-c233-40a6-acfc-05b8b3025117",
      },
    ],
  },
  {
    btnLabel: "2017-2018",
    fileList: [
      {
        label: "Receipt and Payment Statement 2017-18",
        fileStoreId: "18010926-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Income & Expenditure 2017-18",
        fileStoreId: "18011026-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Balance Sheet 2017-18",
        fileStoreId: "b757af0c-1c19-4553-8f8f-23e30c57e9b0",
      },
      {
        label: "Letter of MC to Examiner of Local Accounts, WB",
        fileStoreId: "18011226-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Audit Report 2017-18",
        fileStoreId: "18011326-2a59-4f3c-8a94-891f18042026",
      },
    ],
  },
  {
    btnLabel: "2018-2019",
    fileList: [
      {
        label: "Receipt and Payment Statement 2018-19",
        fileStoreId: "18011426-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Income & Expenditure 2018-19",
        fileStoreId: "18011526-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Balance Sheet 2018-19",
        fileStoreId: "18011626-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Audit Report 2018-19",
        fileStoreId: "795e6089-f963-428b-9efc-d24f93027d46",
      },
    ],
  },
  {
    btnLabel: "2019-2020",
    fileList: [
      {
        label: "Receipt and Payment Statement 2019-20",
        fileStoreId: "18011826-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Income & Expenditure 2019-20",
        fileStoreId: "18011926-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Balance Sheet 2019-20",
        fileStoreId: "18012026-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Audit Report 2019-20",
        fileStoreId: "18012126-2a59-4f3c-8a94-891f18042026",
      },
    ],
  },
  {
    btnLabel: "2020-2021",
    fileList: [
      {
        label: "Receipt and Payment Statement 2020-21",
        fileStoreId: "e66e1f7a-4526-4d3e-be13-d44e12bce048",
      },
      {
        label: "Income & Expenditure 2020-21",
        fileStoreId: "18012326-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Balance Sheet 2020-21",
        fileStoreId: "18012426-2a59-4f3c-8a94-891f18042026",
      },
    ],
  },
  {
    btnLabel: "2021-2022",
    fileList: [
      {
        label: "Receipt and Payment Statement 2021-22",
        fileStoreId: "3c85b971-8e82-4e1d-9b2c-97ba57b1c4b1",
      },
      {
        label: "Income & Expenditure 2021-22",
        fileStoreId: "18012626-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Balance Sheet 2021-22",
        fileStoreId: "8503e28b-fce4-4dc9-bada-2adaaa56cb58",
      },
      {
        label: "Audit Report 2021-22",
        fileStoreId: "18012826-2a59-4f3c-8a94-891f18042026",
      },
    ],
  },
  {
    btnLabel: "2022-2023",
    fileList: [
      {
        label: "Receipt and Payment Statement 2022-23",
        fileStoreId: "66bb82a2-cbec-4b85-99c9-ffbe47b1955a",
      },
      {
        label: "Income & Expenditure 2022-23",
        fileStoreId: "4b14b339-acc5-4c16-b758-d60ef858fd33",
      },
      {
        label: "Balance Sheet 2022-23",
        fileStoreId: "18013126-2a59-4f3c-8a94-891f18042026",
      },
    ],
  },
  {
    btnLabel: "2023-2024",
    fileList: [
      {
        label: "Receipt and Payment Statement 2023-24",
        fileStoreId: "18013226-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Income & Expenditure 2023-24",
        fileStoreId: "18013326-2a59-4f3c-8a94-891f18042026",
      },
      {
        label: "Balance Sheet 2023-24",
        fileStoreId: "18013426-2a59-4f3c-8a94-891f18042026",
      },
    ],
  },
  {
    btnLabel: "2024-2025",
    fileList: [
      {
        label: "Receipt and Payment Statement 2024-25",
        fileStoreId: "63a45465-b1cc-4d46-b4a3-ff0bbce94ec2",
      },
      {
        label: "Income & Expenditure 2024-25",
        fileStoreId: "c26be648-09af-4439-a5d8-8eca461c0d39",
      },
      {
        label: "Balance Sheet 2024-25",
        fileStoreId: "18013726-2a59-4f3c-8a94-891f18042026",
      },
    ],
  },
];

export const MessageBoardList = [
  {
    month: "May",
    date: "07.05.2026",
    fileStoreId: "e8d9e3af-2cad-4e4b-ac74-f20b460cba39",
    text: "Vacancy Circular for appointment of Sr. Architect in Andaman Public Works Department, A&N Administration on deputation (ISTC) basis for a period of 03 years. dated 07.05.2026",
  },
  {
    month: "Nov",
    date: "17.11.2025",
    fileStoreId: "fba1184e-1cc3-414a-ac84-b192e094302e",
    text: "Interview Schedules in the post of Staff Nurse on contractual basis against Adv. No . 03/Kolkata City NUHM Society/2025 – 26. dated 17.11.2025",
  },
  {
    month: "Nov",
    date: "22.11.2023",
    fileStoreId: "067607da-e8ce-4ca2-bf52-9c08297dddc3",
    text: "Interview Schedules in the post of Honorary Health Work (HHW) on contractual basis against Adv. No .H/07/KMC/2023 – 24. dated 22.11.2023",
  },
  {
    month: "Nov",
    date: "17.11.2025",
    fileStoreId: "affedaa1-e57c-428e-b792-ddf8183fb25f",
    text: "List of eligible candidates for Document Verification and Interview post of Staff Nurse on contractual basis against Adv. No . 03/Kolkata City NUHM Society/2025 – 26. dated 17.11.2025",
  },
  {
    month: "Nov",
    date: "22.11.2023",
    fileStoreId: "f663fdf0-f6c5-4985-b914-1f625023b844",
    text: "List of eligible candidates for Document Verification and Interview post of Honorary Health Work (HHW) on contractual basis against Adv. No . H/07/KMC/2023 – 24. dated 22.11.2023",
  },
  {
    month: "Jan",
    date: "16.01.2026",
    fileStoreId: "2568adca-ca11-4b65-b698-2e5cde4da967",
    text: "List of selected candidates for the post of Specialist Medical Officer for Polyclinics under XV Finance Commission Health Grant under Health Department of KMC on contractual basis Ref: Adv. No . H/06/KMC/2025 – 26. dated 16.01.2026",
  },
  {
    month: "Oct",
    date: "18.10.2025",
    fileStoreId: "b71715ef-5e67-4195-acf3-b7a0a3fcc3b9",
    text: "Further notice for document verification in the post of Accountant-I on contractual basis against Adv. No .02/Kolkata City NUHM Society/2025 – 26. dated 18.10.2025",
  },
  {
    month: "Feb",
    date: "27.02.2026",
    fileStoreId: "a7427a4d-a2be-4343-9231-97bcfb907e1e",
    text: "Engagement of 86 nos. Staff Nurse contractual for Khidderpure U-CHC in the Kolkata City NUHM Society under Health Department of KMC Advt. No. 08/Kolkata City NUHM Society/2025 – 26. dated: 27.02.2026",
  },
  {
    month: "Feb",
    date: "26.02.2026",
    fileStoreId: "733245ef-1db7-43e0-bd7e-18d5a4476cf8",
    text: "Engagement of 13 nos. Laboratory Technicians contractual for its Urban Primary Health Centers in Kolkata City NUHM Society under Health Department of KMC Advt. No. 07/Kolkata City NUHM Society/2025 – 26. dated: 26.02.2026",
  },
  {
    month: "Jul",
    date: "15.07.2023",
    fileStoreId: "2cc7eae2-59c3-4bbd-aaa3-4faae464b6d8",
    text: "Cancellation of Advertisement no 05/Kolkata City NUHM Society/2023-24 dated 15.07.2023. for the post of Laboratory Technicians",
  },
  {
    month: "Nov",
    date: "25.11.2023",
    fileStoreId: "e3609c01-fc3b-4728-97af-7722fa4197cd",
    text: "Cancellation of Advertisement no 08/Kolkata City NUHM Society/2023-24 dated 25.11.2023. for the post of Pharmacist",
  },
  {
    month: "Feb",
    date: "23.02.2026",
    fileStoreId: "c75fd66d-1272-461f-a23c-930e31f89716",
    text: "Engagement of 33 nos. Counsellor contractual for Polyclinics under XV Finance Commission under Health Department of KMC Advt. No. H/07/KMC/2025-26. dated: 23.02.2026",
  },
  {
    month: "Aug",
    date: "30.08.2025",
    fileStoreId: "61791aac-39ed-4fb1-b213-3eafe860e384",
    text: "List of selected candidates for Document Verification and Interview post of Operator for LCMSMS, GCMSMS and ICPMS on contractual basis against Adv. No .H/01/KMC/2025 – 26. dated 30.08.2025",
  },
  {
    month: "Oct",
    date: "18.10.2025",
    fileStoreId: "5f8472cf-85bb-4010-a2f4-fa518a985e81",
    text: "List of selected candidates for the Document Verification post of Accountant-I on contractual basis against Adv. No .02/Kolkata City NUHM Society/2025 – 26. dated 18.10.2025",
  },
  {
    month: "Jan",
    date: "06.01.2026",
    fileStoreId: "52d9d918-f613-46db-8138-eed2471d4994",
    text: "list of selected candidate for the post of Medical Officer for Khidderpore U-CHC under Kolkata City NUHM Society on contractual basis against Adv. No - 05/Kolkata City NUHM Society/2025 – 26. dated 06.01.2026",
  },
  {
    month: "Dec",
    date: "09.12.2025",
    fileStoreId: "df88bab6-689a-40a5-8496-2c0aeb181bca",
    text: "List of selected candidate for the post of Senior Entomologist for Vector Control under Health Department of KMC on contractual basis against Adv. No . H/04/KMC/2025 – 26. dated 09.12.2025",
  },
  {
    month: "Jan",
    date: "06.01.2026",
    fileStoreId: "36d89878-374c-4016-8915-224721ca24da",
    text: "List of selected candidates for the post of Lab Assistant for Central Lab (Food) under Health Department of KMC on contractual basis against Adv. No H/05/KMC/2025 – 26. dated 06.01.2026",
  },
  {
    month: "Jan",
    date: "16.01.2026",
    fileStoreId: "41834d3b-c3f0-45bd-9dc9-5d6cfc0e84a7",
    text: "Walk-in Interview on 30.01.2026, for the post of Medical Officer Specialist (G&O, Medicine, Paediatrics, Ophthalmologist, Cardiology, Radiology, ENT, and Orthopaedics) on contractual basis for UHWC under XV Finance Commission under the Health Department of Kolkata Municipal Corporation. Adv. No . H/06/KMC/2025–26. dated 16.01.2026",
  },
  {
    month: "Jan",
    date: "06.01.2026",
    fileStoreId: "e56920f3-2aad-420c-b74a-c142ad070ffe",
    text: "List of selected candidates Names and Post for Kolkata District TB Control Society under Health Department of KMC on contractual basis against Memo. No KDTCS/Officer/226/25. dated 06.01.2026",
  },
  {
    month: "Nov",
    date: "24.11.2025",
    fileStoreId: "ef0cf52d-0991-4fac-99fb-84d95a6193c6",
    text: "Result with respect to the Adv. No H/03/KMC/2025 – 26. dated 24.11.2025 for the post of Assistant Analyst and Lab Assistant",
  },
  {
    month: "Jan",
    date: "06.01.2026",
    fileStoreId: "16532b52-b922-4b4a-9193-7fccd39fedd0",
    text: "Walk-in Interview on 21.01.2026, 03 no. of Lab Assistant for Central Lab (food) on contractual basis under the Health Department of Kolkata Municipal Corporation against Adv. No . H/05/KMC/2025-26 dated. 06.01.2026.",
  },
  {
    month: "Jan",
    date: "06.01.2026",
    fileStoreId: "649b1f1c-71b6-4a35-8fbb-45384750b173",
    text: "Walk-in Interview on 20.01.2026, for the post of Medical for U-CHC at Khidderpore under Kolkata City NUHM Society. Adv. No . 05/Kolkata City NUHM Society/2025–26. dated 06.01.2026",
  },
  {
    month: "Dec",
    date: "02.12.2025",
    fileStoreId: "9898a387-cb54-4c9a-8433-19fa51f2d3c9",
    text: "List of selected candidates for the post of Medical Officer Specialist for Khiddrpore (U-CHC) under Kolkata City NUHM Society on contractual basis against Adv. No . 04/Kolkata City NUHM Society/2025 – 26. dated 02.12.2025",
  },
  {
    month: "Nov",
    date: "19.11.2025",
    fileStoreId: "7cfe366b-4730-4777-8a8b-2dd93ca6ef6b",
    text: "List of selected candidates for the post of Medical Officer for U-HWC under XV Finance Commission under Health Department of KMC on contractual basis against Adv. No H/02/KMC/2025 – 26. dated 19.11.2025",
  },
  {
    month: "Oct",
    date: "13.10.2025",
    fileStoreId: "c95b88f6-d3bb-46b3-bd18-70406502593b",
    text: "List of selected candidates Names and Post for Kolkata District TB Control Society under Health Department of KMC on contractual basis against Memo. No KDTCS/Officer/198/25. dated 13.10.2025",
  },
  {
    month: "Dec",
    date: "09.12.2025",
    fileStoreId: "e58d6635-4270-4ed5-ba8c-252ae73d7758",
    text: "Walk-in Interview on 19.12.2025, 01 no. Senior Entomologist on contractual basis for Vector Control against Adv. No . H/04/KMC/2025-26. dated 09.12.2025",
  },
  {
    month: "Dec",
    date: "09.12.2025",
    fileStoreId: "6e71f365-f813-428f-9d31-72773c6af9f7",
    text: "NOTICE INVITING APPLICATION for Certificate Course on Net Zero Emission and Carbon Credit",
  },
  {
    month: "Sep",
    date: "11.09.2025",
    fileStoreId: "79275d1d-227d-426b-8745-a0010e0faed7",
    text: "The 2nd list of selected candidate's names for the post of Medical Officer on contractual basis under Kolkata City NUHM Society under Health Department of KMC against Adv. No - 01/Kolkata City NUHM Society/2025 – 26. dated 11.09.2025",
  },
  {
    month: "Dec",
    date: "02.12.2025",
    fileStoreId: "e5afb1be-858a-4353-95f7-9a593b3af3bb",
    text: "Walk-in Interview on 12.12.2025, for the post of Medical Officer Specialist (G&O), Peadiatric and Anesthetist for U-CHC at Khidderpore under Kolkata City NUHM Society. Adv. No . 04/Kolkata City NUHM Society/2025-26. dated 02.12.2025.",
  },
  {
    month: "Dec",
    date: "09.12.2023",
    fileStoreId: "dd771e7e-3db8-48cf-8072-a9d5e154dea1",
    text: "Cancellation of Advertisement no H/09/KMC/2023-24. dated 09.12.2023. for the post of Assistant Analyst and Lab Assistant.",
  },
  {
    month: "Nov",
    date: "24.11.2025",
    fileStoreId: "a2a6384b-b888-427f-a588-d2f9d3d09836",
    text: "Walk-in Interview on 10.12.2025 And 11.12.2025, 04no. of Assistant Analyst And 03 no. of Lab Assistant contractual basis under the Health Department of Kolkata Municipal Corporation against Adv. No . H/03/KMC/2025-26 dated. 24.11.2025.",
  },
  {
    month: "Nov",
    date: "19.11.2025",
    fileStoreId: "39221757-22ee-434a-b88a-32c65971454c",
    text: "Walk-in Interview on 28.11.2025 for the post of  Medical Officer on contractual basis for UHWC under XV Finance Commission under the Health Department  of Kolkata Municipal Corporation.  Adv. No . H/02/KMC/2025â€“26. dated 19.11.2025",
  },
  {
    month: "Sep",
    date: "11.09.2025",
    fileStoreId: "63b58e3e-08a7-4c14-b272-a0d7d024a5f2",
    text: "List of selected candidates for the post of Medical Officer on contractual basis under Kolkata City NUHM Society under Health Department of  KMC against Adv. No - 01/Kolkata City NUHM Society/2025 â€“ 26. dated  11.09.2025",
  },
  {
    month: "Nov",
    date: "17.11.2025",
    fileStoreId: "5e2bd784-339e-45e6-8a90-17ee4b2ca545",
    text: "Engagement of 139 nos. Staff Nurse contractual for Urban Primary Health Centers under Kolkata City NUHM Society under Health Department of KMC Advt. No. 03/Kolkata City NUHM Society/2025 - 26. dated 17.11.2025",
  },
  {
    month: "Oct",
    date: "18.10.2025",
    fileStoreId: "531efac6-978e-40f7-bbc7-af38f4f22c75",
    text: "Engagement of 17 nos. Accountant-I vide Advt. No. 02/Kolkata City NUHM Society/2025-26 dated 18.10.2025",
  },
  {
    month: "Aug",
    date: "05.08.2023",
    fileStoreId: "62fe16b5-dc16-4ae2-929c-c79df8be0268",
    text: "Cancellation of Advertisement No. 06/Kolkata City NUHM Society/2023-24 dated 05.08.2023. for the post of Accountant-I",
  },
  {
    month: "Oct",
    date: "17.10.2025",
    fileStoreId: "55db466d-b8ce-42da-a929-620a95ae9142",
    text: "Engagement of superannuated government employees in various posts at Kolkata Municipal Corporation Sustainability, Hygiene and Resilience Project (KMC-SHARP) on purely contract basis",
  },
  {
    month: "Oct",
    date: "13.10.2025",
    fileStoreId: "4dba56a7-5775-4aaf-8558-b93612127057",
    text: "Engagement of  STS, PMDT HIV Coordinator, LT, TBHV and MO(NTEP) under National Tuberculosis Elimination Programme on contractual basis against Memo. No . KDTCS/Office/198/25. dated 13.10.2025",
  },
  {
    month: "Oct",
    date: "09.10.2025",
    fileStoreId: "5b3c7a0a-2b01-4871-8bfc-c4ed520eabb0",
    text: "Removal of unauthorized advertisement structures and compliance with Advertisement policy Regulations, 2025",
  },
  {
    month: "Sep",
    date: "11.09.2025",
    fileStoreId: "c4712eec-d9f4-4007-8cc1-94169bf12cff",
    text: "Walk-in Interview on 19.09.2025, 37 nos. Medical Officer on contractual basis for Kolkata City NUHM Society against Adv. No . 01/Kolkata City NUHM Society/2025-26. dated 11.09.2025",
  },
  {
    month: "Oct",
    date: "13.10.2024",
    fileStoreId: "84894353-26ec-426d-ab0b-17476c69e10b",
    text: "Cancellation of Advertisement for the post of Driver for Modified Food Safety on Wheels",
  },
  {
    month: "Jun",
    date: "08.06.2024",
    fileStoreId: "196522cb-b3c3-4d75-acf7-9e4019aea100",
    text: "List of selected candidates for the post of Specialist Medical Officer  for Polyclinic under XV Finance Commission Health Grant under Health Department of KMC on contractual basis Ref: Adv. No . H/01/KMC/2024   25. dated  08.06.2024",
  },
  {
    month: "Jul",
    date: "10.07.2024",
    fileStoreId: "36d5de6d-eee5-41ad-8903-cb8014d62cdf",
    text: "Walk-in Interview on 16.07.2024, 2 nos. Medical officer  Specialist  for Khidderpore U-CHC under the Kolkata City NUHM Society on contractual basis,  Adv. No . 02/Kolkata City NUHM Society/2024  25. dated 10.07.2024",
  },
  {
    month: "mar",
    date: "14.03.2024",
    fileStoreId: "7faacc8b-cb40-4fae-a8b1-0421487cb0c5",
    text: "List of selected candidates for the post of Specialist Medical Officer  for Maternity Home  under Health Department of KMC on contractual basis Ref: Adv. No . H/10/KMC/2023   24. dated  14.03.2024",
  },
  {
    month: "Jun",
    date: "08.06.2024",
    fileStoreId: "4b97b883-c083-4511-9201-aa2a5c585855",
    text: "Walk-in Interview on 21.06.2024, for the post of  Specialist (G&O, Medicine, Paediatrics, Ophthalmologist, Cardiology, ENT, and Orthopaedics) on contractual basis under the Health Department  of Kolkata Municipal Corporation.  Adv. No . H/01/KMC/2024 25. dated 08.06.2024",
  },
  {
    month: "Jun",
    date: "19.06.2024",
    fileStoreId: "1efb356c-46b1-4191-94ab-488b07092530",
    text: "Locations of Slaughtering of Animals on the Occasion of EID-UL-ZOHA (Bakri-EID) on 17.06.2024,18.06.2024 and 19.06.2024.",
  },
  {
    month: "Mar",
    date: "07.03.2024",
    fileStoreId: "fb4af76d-015e-442c-bb24-76064b193987",
    text: "Walk-in Interview held on 14.06.2024, 67 nos. Medical officer (part time) contractual basis under the Kolkata City NUHM Society.   Adv. No . 01/Kolkata City NUHM Society/2024   25. dated 07.03.2024",
  },
  {
    month: "Apr",
    date: "07.04.2023",
    fileStoreId: "e113d148-c70f-4c20-96bc-6adfa18a2ffc",
    text: "NOTICE REGARDING PARKING RATE No. Con/Com/03/2023-24 Dated 07.04.2023",
  },
  {
    month: "Dec",
    date: "14.12.2023",
    fileStoreId: "d2fb384e-43c0-4fdd-8aec-97927c9ec0b0",
    text: "NOTIFICATION for fixing up QR codes on advertisements",
  },
  {
    month: "Oct",
    date: "31.10.2023",
    fileStoreId: "ab4e1d7d-98a0-47ca-bbdc-d90ae5f47555",
    text: "Notice to all Advertisers & Advertising Agencies regarding temporary flexes, banner, cut-outs etc. put up during the Durga Puja, 2023",
  },
  {
    month: "Sep",
    date: "30.09.2023",
    fileStoreId: "ebe9e9f7-0d5f-4738-b64a-e03fba1a0ab9",
    text: "Continuation of work by the existing Licensees at the existing Licence Fee at the respective lots being allotted to them except the lots being allotted to the successful three H1 bidders in the e-tender NIT No. KMC/CP/MAIN/e-TENDER(01)/2023-24",
  },
  {
    month: "Apr",
    date: "12.04.2023",
    fileStoreId: "e1ef1702-a95a-45fe-8d09-32f063090a8d",
    text: "Corrigendum to Advertisement No. 01/Kolkata City NUHM Society/2023-24. Dated 12.04.2023",
  },
  {
    month: "may",
    date: "10.05.2023",
    fileStoreId: "79826b16-b31f-4b09-ac5a-f15628e4c4f5",
    text: "Dismantling of hoarding structure from the different premises within the jurisdiction of KMC",
  },
  {
    month: "Feb",
    date: "23.10.2023",
    fileStoreId: "5d11fa80-7bb0-4116-b396-f9795a10e46d",
    text: "Corrigendum to Advertisement No. H/04/KMC/2022-23. dated 23.02.2023.",
  },
  {
    month: "Jun",
    date: "16.06.2022",
    fileStoreId: "2416ec82-1400-4731-b76e-5b060446cebc",
    text: "Micro planning to mitigate air pollution in connection with selected Hot Spots",
  },
  {
    month: "Jan",
    date: "02.01.2022",
    fileStoreId: "c1f87279-892b-4742-859d-778fdce83606",
    text: "Notification regarding Hookah Bar / Cafe / Parlour etc.",
  },
  {
    month: "Dec",
    date: "14.12.2024",
    fileStoreId: "fc2ed59e-df09-4aac-ba36-db5f12bc8e8f",
    text: "NOTICE TO ALL ADVERTISERS AND ADVERTISING AGENCIES",
  },
  {
    month: "Nov",
    date: "12.11.2022",
    fileStoreId: "04cbe53a-6ba3-4c19-8f9e-8e151a1c613f",
    text: "Corrigendum to Advertisement No. 07/Kolkata City NUHM Society/2022-23. Dated 12.11.2022",
  },
  {
    month: "Aug",
    date: "16.08.2022",
    fileStoreId: "c80c8c9c-7cce-42b7-8c8d-db1bdab391f8",
    text: "Paper notification regarding Self Declaration of advertisement hoardings located within the jurisdiction of the  KMC",
  },
  {
    month: "",
    date: "",
    link: "/WBThikaTenancyActAmendments",
    text: "WB Thika Tenancy Act,Amendments",
    type: "link",
  },
  {
    month: "Jun",
    date: "07.06.2021",
    fileStoreId: "ab593411-c5c6-41d2-8446-9c8eae6c1ffe",
    text: "Monsoon Book",
  },
  {
    month: "Aug",
    date: "27.08.2020",
    fileStoreId: "8bb545c9-157e-4d0b-95ff-97389fa0474a",
    text: "Gazette notification for KMC SWM Bye Laws 2020",
  },
  {
    month: "Jun",
    date: "26.06.2018",
    fileStoreId: "cdfe6b6e-469d-45bf-b9c7-894371700e7c",
    text: "BUILDING NOTIFICATION NO 445/MA/O/C-4/3R-3/2014",
  },
  {
    month: "Jan",
    date: "01.01.2021",
    fileStoreId: "b2be9370-ff85-4353-9cdb-eb574d9aadd9",
    text: "District Environment Plan KMC 2021",
  },
  {
    month: "Jun",
    date: "30.06.2021",
    fileStoreId: "73a1bb13-2995-461a-be9e-45234aabae17",
    text: "EX-GRATIA RELATED TO COVID-19 DEATH",
  },
  {
    month: "May",
    date: "18.05.2022",
    fileStoreId: "5a7463bb-df4a-4fc4-9def-d67690b27aaa",
    text: "MONER ALO Mental Health Program of KMC",
  },
  {
    month: "",
    date: "",
    link: `${mainURL}/citizen/language-selection`,
    text: "List of KMC Drainage Activity",
    type: "anchor",
  },
  {
    month: "May",
    date: "31.05.2022",
    link: "/Engi_Man_Desil_Prog_civil_Bro_30_6_2024",
    text: "Manhole Desilting Programme of Borough-I to XVI under Civil Dept. upto 31.05.2022",
    type: "link",
  },
  {
    month: "Mar",
    date: "29.03.2022",
    fileStoreId: "3b5fbd42-601d-437f-8c71-390eac43cf02",
    text: "KMC PARTICIPATION AND EXPERIENCES AT ECHO INDIA'S IPC DISSEMINATION EVENT : MUMBAI",
  },
  {
    month: "Mar",
    date: "31.03.2022",
    fileStoreId: "e7f62c38-4966-438f-9612-ce7708afa5f1",
    text: "ACTIVITY CHART FOR DESILTING WORK APRIL TO JUNE 2022",
  },
  {
    month: "Apr",
    date: "07.04.2022",
    fileStoreId: "913164c1-782b-4985-9e93-8210eb372aec",
    text: "NOTIFICATION for resumption of Night Parking within KMC area",
  },
  {
    month: "May",
    date: "26.05.2022",
    fileStoreId: "43208393-1243-4626-916e-b837f7af1554",
    text: "Kolkata Municipal Corporation (Advertisement Policy) Regulation 2022",
  },
  {
    month: "May",
    date: "17.05.2022",
    fileStoreId: "e507e068-4612-4038-a544-2e00588b8f0a",
    text: "List of unauthorized/illegal/dilapidated hoardings to be dismantled by KMC",
  },
  {
    month: "",
    date: "2021-22",
    fileStoreId: "d890a063-5593-435e-a1b8-3e4ee9f73e47",
    text: "Arrangement of Dignified cremation/burrial of Covid bodies",
  },

  {
    month: "Mar",
    date: "29.03.2022",
    fileStoreId: "3b5fbd42-601d-437f-8c71-390eac43cf02",
    text: "KMC PARTICIPATION AND EXPERIENCES AT ECHO INDIA'S IPC DISSEMINATION EVENT : MUMBAI",
  },

  {
    month: "Dec",
    date: "09.12.2021",
    fileStoreId: "fe6bd6ec-9a2b-4591-9815-2948d330ebf7",
    text: "The CCZM of Kolkata is not currently available on NOCAS due to revition process and the same will be available shortly as par notificition available in http:// nocas2.aai.aero/nocas/ Therefore for application made through EoDB, if your proposal attracts CCZM, you are required to approach directly to Airport Authority of India to obtain NOC for height clearance from AAI. This mechanism will continue till the issue is resolved.",
  },

  {
    month: "Dec",
    date: "09.12.2021",
    fileStoreId: "fe6bd6ec-9a2b-4591-9815-2948d330ebf7",
    text: "Immersion training by ECHO India for KMC Health staff.",
  },

  {
    month: "Sep",
    date: "20.09.2021",
    fileStoreId: "39816631-41e8-4201-90a8-f71438fe0158",
    text: "Notice inviting information regarding various tenders floated by Advertisement Department, KMC",
  },

  {
    month: "Jun",
    date: "14.06.2021",
    fileStoreId: "bf5deace-f2f4-42c9-a81d-340114ba66e9",
    text: "Urgent Notice to Cable Operators, BB & Internet Service Providers of Harish Mukherjee Road Dated 12-June-2021",
  },

  {
    month: "Nov",
    date: "13.11.2020",
    fileStoreId: "ac4a64a7-2da3-463b-bc5b-24bdb9540aaa",
    text: "Policy for use of pet Coke and Furnace Oil as a Fuel in the State of West Bengal",
  },

  {
    month: "May",
    date: "28.05.2020",
    fileStoreId: "981e1dd6-3449-42c8-a0d9-3c1c222da3b7",
    text: "Building Demand Notice",
  },

  {
    month: "",
    date: "",
    fileStoreId: "f354e65e-b7fc-44a6-858d-07012b004a13",
    text: "All traders/businessmen may take notice that use of plastic carry bags below 120 (one hundred twenty) microns is strictly prohibited and punishable under law",
  },

  {
    month: "Dec",
    date: "15.12.2018",
    fileStoreId: "535c80ee-d170-4167-940b-8f1b9275a3c0",
    text: "Gazette Notification under West Bengal Escheats and Forfeitures Act, 2012 in respect of premises no. 14, Kyd Street, Kolkata - 16",
  },

  {
    month: "Oct",
    date: "13.10.2018",
    fileStoreId: "293a2628-146f-496e-9f34-de42019a7573",
    text: "Proposed enhancement of night fee car parking spaces in KMC area",
  },
  {
    month: "Oct",
    date: "03.10.2018",
    fileStoreId: "293a2628-146f-496e-9f34-de42019a7573",
    text: "Online Survey for Industry Sector Key Performance Indicators under Vision, Mission Exercise.",
  },
  {
    month: "Sep",
    date: "01.09.2018",
    fileStoreId: "b02746d3-1e98-43ae-b515-de709457285f",
    text: "FREE HOLD TRANSFER OF LAND",
  },
  {
    month: "Oct",
    date: "10.10.2015",
    fileStoreId: "b36404be-fcbc-4d26-803e-981298fca166",
    text: "City Sanitaion Plan",
  },
  {
    month: "Jul",
    date: "11.07.2018",
    fileStoreId: "bc9cdb7c-12fd-41ac-a659-2493a0fc0948",
    text: "Usage of mobile apps(Bandhu)",
  },
  {
    month: "Feb",
    date: "24.02.2018",
    fileStoreId: "e9d5568a-d41b-4850-b642-df69cbc13cea",
    text: "IMPORTANT NOTICE",
  },
  {
    month: "May",
    date: "12.05.2017",
    fileStoreId: "7cde4556-77e7-4cda-b747-23566449f0c1",
    text: "Enlistment of Structural  Reviewer",
  },
  {
    month: "Jun",
    date: "09.06.2017",
    fileStoreId: "e7c53693-9f18-4832-87e0-cb12bad6e267",
    text: "Handbook for action plan to mitigate flood,cyclone & water logging-2017",
  },
  {
    month: "",
    date: "",
    anchor: "http://www.kolkatapolice.gov.in/",
    text: "Kolkata Police",
    type: "anchor",
  },
  {
    month: "Aug",
    date: "10.08.2015",
    fileStoreId: "2374563e-9e68-4e20-a4e3-1105441961dc",
    text: "Notification From  Licence Department",
  },

  {
    month: "Jul",
    date: "27.07.2013",
    fileStoreId: "b84b4954-6740-44be-a15f-588de91c27ea",
    text: "This is for you kindly read this..",
  },

  {
    month: "Jul",
    date: "27.07.2013",
    fileStoreId: "3848033c-6f25-4516-9ef1-e753d6f7be5d",
    text: "Don't be cheated into the market..",
  },
  {
    month: "Mar",
    date: "2009",
    fileStoreId: "702e85a5-9fc5-4020-8f56-cc8d24ec1020",
    text: "Advertisement Policy",
  },

  // {====================
  //   month: "Mar",
  //   date: "14.03.2024",
  //   fileStoreId: "f5d1ab42-fe27-4016-9d77-e5f85392c8b5",
  //   text: "Walk-in Interview on 22.03.2024, for the post of Specialist Medical Officer (G&O) on contractual basis under the Health Department of Kolkata Municipal Corporation. Adv. No . H/010/KMC/2023–24. dated 14.03.2024",
  // },
  // {
  //   month: "Mar",
  //   date: "14.03.2024",
  //   fileStoreId: "526cffb0-2fc5-4b69-8190-abd7751b7376",
  //   text: "List of selected candidates for the post of Specialist Medical Officer for Polyclinic under XV Finance Commission and for Khiddrpore (U-CHC) under Kolkata City NUHM Society",
  // },
  // {
  //   month: "Jan",
  //   date: "27.01.2024",
  //   fileStoreId: "9296e3ee-c337-4062-828b-123acb0b7312",
  //   text: "List of selected candidates for the post of Medical Officer (Part time) for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No - 11/Kolkata City NUHM Society/2023 – 24. dated 27.01.2024",
  // },
  // {
  //   month: "Dec",
  //   date: "09.12.2023",
  //   fileStoreId: "cc5ae5bc-079a-49fa-8fa4-b1aae6ae1e73",
  //   text: "Engagement of 4 nos. Assistant Analyst and 3 nos. Lab Assistant on contractual basis for Central Lab (Food) under the Health Department of Kolkata Municipal Corporation. Adv. No . H/09/KMC/2023–24. dated 09.12.2023",
  // },
  // {
  //   month: "Nov",
  //   date: "24.11.2023",
  //   fileStoreId: "1fc23a0b-f6d6-474d-92f7-318bd8b1b942",
  //   text: "Engagement of 1no. Nursing–in-charge for Khidderpore (U-CHC) under Kolkata City NUHM Society on contractual basis, Adv. No . 14/Kolkata City NUHM Society/2023 – 24. dated 24.11.2023",
  // },
  // {
  //   month: "Nov",
  //   date: "24.11.2023",
  //   fileStoreId: "d5726bcc-9bf6-48f4-9aa2-47150d261fa6",
  //   text: "Engagement of 1no. Medical officer–in-charge for Khidderpore (U-CHC) under Kolkata City NUHM Society on contractual basis, Adv. No . 13/Kolkata City NUHM Society/2023 – 24. dated 24.11.2023",
  // },
  // {
  //   month: "Dec",
  //   date: "07.12.2023",
  //   fileStoreId: "0d5c8a24-2d87-40a8-85b3-208dc494792c",
  //   text: "Walk-in Interview on 27.02.2024, for the post of Specialist (Medicine and Pathologist) for U-CHC Khidderpore under Kolkata City NUHM Society. Adv. No . 09/Kolkata City NUHM Society/2023–24. dated 07.12.2023",
  // },
  // {
  //   month: "Jan",
  //   date: "10.01.2024",
  //   fileStoreId: "3e6772c7-9d61-4e2e-b9cf-0384d6788540",
  //   text: "Walk-in Interview on 23.02.2024, for the post of Specialist (Medicine, Ophthalmologist, Cardiology, ENT, Endocrinology and Orthopaedics) on contractual basis under XV FC under the Health Department of Kolkata Municipal Corporation. Adv. No . H/08/KMC/2023–24. dated 10.01.2024",
  // },
  // {
  //   month: "Jan",
  //   date: "27.01.2024",
  //   fileStoreId: "2fae22ee-f895-41e8-9b50-2b93a13311ff",
  //   text: "Walk-in Interview held on 20.02.2024, 75nos. Medical officer (part time) contractual basis under the Kolkata City NUHM Society. Adv. No . 11/Kolkata City NUHM Society/2023 – 24. dated 27.01.2024",
  // },
  // {
  //   month: "Nov",
  //   date: "22.11.2023",
  //   fileStoreId: "b0c2cf43-1a0b-467c-8f18-a46fc776e87c",
  //   text: "Engagement of 118 nos. Honorary Health Workers (HHW) under Health Department of KMC vide Advt. No. H/07/KMC/2023-24. dated 22.11.2023",
  // },
  // {
  //   month: "Dec",
  //   date: "07.12.2023",
  //   fileStoreId: "e41dad2f-cb9f-42db-aac5-ec754ff584bf",
  //   text: "List of selected candidates for the post of Medical Officer (Part time) for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No - 10/Kolkata City NUHM Society/2023 – 24. dated 07.12.2023",
  // },
  // {
  //   month: "Dec",
  //   date: "07.12.2023",
  //   fileStoreId: "de881085-6e7d-407d-9330-e1303e0c7804",
  //   text: "List of selected candidates for the post of Specialist Medical Officer for Polyclinic under Health Department KMC on contractual basis against on contractual basis against Adv. No . H/06/KMC/2023 – 24. dated 07.12.2023",
  // },
  // {
  //   month: "Dec",
  //   date: "07.12.2024",
  //   fileStoreId: "b226d2dc-c8a5-4595-bdf7-fcd0219c9fee",
  //   text: "List of selected candidate for the post of Specialist Medical Officer for Khiddrpore (U-CHC) under Kolkata City NUHM Society Adv. No . 09/Kolkata City NUHM Society/2023 – 24. dated 07.12.2023",
  // },
  // {
  //   month: "Jan",
  //   date: "18.01.2024",
  //   fileStoreId: "d69d7b21-2ec9-40bf-9a7b-ae0464fb2704",
  //   text: "Notice for cancellation of Advertisement for appointment to the Special Officer(Building)",
  // },
  // {
  //   month: "Dec",
  //   date: "07.12.2023",
  //   fileStoreId: "3eb4a01d-5ce2-4cd1-b5f4-a110dec65b90",
  //   text: "Walk-in Interview held on 09.01.2024, 68nos. Medical Officer (part time) contractual basis under the Kolkata City NUHM Society against Adv. No . 10/Kolkata City NUHM Society/2023 – 24. dated 07.12.2023",
  // },
  // {
  //   month: "Dec",
  //   date: "28.12.2023",
  //   fileStoreId: "d50206ec-5bc1-4d40-b7eb-b474eb599cd1",
  //   text: "Recruitment Regulations for the posts Sub-Registrar under Health Department, KMC. dated 28.12.2022",
  // },
  // {
  //   month: "Oct",
  //   date: "20.10.2022",
  //   fileStoreId: "0d7269ca-a14f-4442-a9bc-c340d4b15a97",
  //   text: "2nd List and 6th List of selected candidates for the post of Medical Officer under XV Finance Commission under Health Department of KMC on contractual basis against Adv. No H/03/KMC/2023 – 24. dated 07.08.2023 and Adv. No H/01/KMC/2022 – 23. dated 20.10.2022",
  // },
  // {
  //   month: "Dec",
  //   date: "20.12.2022",
  //   fileStoreId: "f8744baa-0133-422c-8586-86444ddbb541",
  //   text: "2nd List of selected candidates for the post of Staff Nurse for Polyclinics and Urban Health and Wellness Centers under XV Finance Commission under Health Department of KMC with respect to Adv. No . H/05/KMC/2022-23 dt. 20.12.2022. and Adv. No . H/06/KMC/2022-23 dt. 20.12.2022.",
  // },
  // {
  //   month: "Dec",
  //   date: "07.12.2023",
  //   fileStoreId: "5a077063-9ad1-4103-88a8-1e9f7d69a97a",
  //   text: "Walk-in Interview on 22.12.2023, for the post of Specialist (G&O, Medicine, Paediatrics, Ophthalmologist, Cardiology, ENT, Endocrinology and Orthopaedics) on contractual basis under XV FC of Kolkata Municipal Corporation. Adv. No . H/06/KMC/2023–24. dated 07.12.2023",
  // },
  // {
  //   month: "Dec",
  //   date: "07.12.2023",
  //   fileStoreId: "80a04102-dbdb-42e9-b3fc-f06a5cd2ea37",
  //   text: "Walk-in Interview on 21.12.2023, for the post of Specialist (Medicine, Pathologist and Paediatrics) for U-CHC at Khidderpore under Kolkata City NUHM Society. Adv. No . 09/Kolkata City NUHM Society/2023–24. dated 07.12.2023",
  // },
  // {
  //   month: "Oct",
  //   date: "07.10.2023",
  //   fileStoreId: "6e5020be-0c0d-4e89-8140-fa226690a3c1",
  //   text: "List of selected candidates for the post of Medical Officer (Part time) for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No - 08/Kolkata City NUHM Society/2023 – 24. dated 07.10.2023",
  // },
  // {
  //   month: "Sep",
  //   date: "06.09.2022",
  //   fileStoreId: "b4197ca2-a7a4-4dd2-8d24-8b54d6afa7dd",
  //   text: "6th list of selected candidates for the post of Staff Nurse (contractual) for urban primary health centers in Kolkata City NUHM Society areas against Adv. No . 04/Kolkata City NUHM Society/2022 – 23. dated 06.09.2022",
  // },
  // {
  //   month: "Dec",
  //   date: "14.12.2023",
  //   fileStoreId: "e493d625-35a9-4608-bf38-82b582872530",
  //   text: "NOTIFICATION for fixing up QR codes on advertisements",
  // },
  // {
  //   month: "Nov",
  //   date: "25.11.2023",
  //   fileStoreId: "f2e6f223-88f8-4c82-a034-a665f2f8b5b4",
  //   text: "Engagement of 19 nos. Pharmacist (contractual) for Urban Primary Health Centers under Kolkata City NUHM Society. Advt. No. 08/Kolkata City NUHM Society/2023 – 24, dated: 25.11.2023",
  // },
  // {
  //   month: "Oct",
  //   date: "13.10.2023",
  //   fileStoreId: "c309e4f3-28f5-4e4a-a0e0-8ff04b4d8288",
  //   text: "Engagement of 07 nos. Staff Nurse for Polyclinic on contractual basis under XV Finance Commission. Advt. No. H/05/KMC/2023-24. dated 13.10.2023",
  // },
  // {
  //   month: "Dec",
  //   date: "13.10.2023",
  //   fileStoreId: "b52fa677-1806-4316-b5c4-01d3601019b7",
  //   text: "Engagement of 29 nos. Staff Nurse for UHWC on contractual basis under XV Finance Commission. Advt. No. H/04/KMC/2023-24. dated 13.10.2023",
  // },
  // {
  //   month: "Dec",
  //   date: "02.12.2023",
  //   fileStoreId: "90244665-0994-41e5-afef-b7ad157ba41c",
  //   text: "6th list of selected candidates for the post of Medical Officer for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No - 13/Kolkata City NUHM Society/2022 – 23. dated 28.01.2023",
  // },
  // {
  //   month: "Nov",
  //   date: "06.11.2023",
  //   fileStoreId: "efd09ade-00ac-4fa8-abcf-85cbf2f2439a",
  //   text: "Walk-in Interview on 22.11.2023, 24nos. Medical officer (part time) on contractual basis under the Kolkata City NUHM Society , Adv. No . 08/Kolkata City NUHM Society/2023 – 24. dated 07.10.2023",
  // },
  // {
  //   month: "Oct",
  //   date: "31.10.2023",
  //   fileStoreId: "2aa338da-cd6c-4179-bde0-2343309b945e",
  //   text: "Notice to all Advertisers & Advertising Agencies regarding temporary flexes, banner, cut-outs etc. put up during the Durga Puja, 2023",
  // },
  // {
  //   month: "Oct",
  //   date: "16.10.2023",
  //   fileStoreId: "74f80696-b713-4af2-a49b-a651abe49d9c",
  //   text: "List of selected candidates for the post of Staff Nurse for Polyclinics under XV Finance Commission on contractual basis, Health Department, KMC with respect to Adv. No . H/6/KMC/2022-23 dt. 20.12.20223",
  // },
  // {
  //   month: "Oct",
  //   date: "16.10.2023",
  //   fileStoreId: "ada6afcf-598d-4bdf-94be-1a8ebe236d09",
  //   text: "List of selected candidates for the post of Staff Nurse for Urban Health and Wellness Centres under XV Finance Commission on contractual basis, Health Department, KMC with respect to Adv. No . H/05/KMC/2022-23 dt. 20.12.2022",
  // },
  // {
  //   month: "Aug",
  //   date: "21.08.2023",
  //   fileStoreId: "6ad1dc99-76cf-4b77-a713-6f5e25a72d79",
  //   text: "List of selected candidates for the post of Medical Officer (Part time) for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No - 07/Kolkata City NUHM Society/2023 – 24. dated 21.08.2023",
  // },
  // {
  //   month: "Jan",
  //   date: "28.01.2023",
  //   fileStoreId: "ce054567-a91a-4cef-8624-8ab659fbd1ec",
  //   text: "5th list of selected candidates for the post of Medical Officer for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No - 13/Kolkata City NUHM Society/2022 – 23. Dated 28.01.2023",
  // },
  // {
  //   month: "Sep",
  //   date: "06.09.2023",
  //   fileStoreId: "78deaabf-99d5-4f7b-99bb-e0b49b57fc9e",
  //   text: "5th list of selected candidates for the post of Staff Nurse (contractual) for urban primary health centers in Kolkata City NUHM Society areas against Adv. No . 04/Kolkata City NUHM Society/2022 – 23. Dated 06.09.2022",
  // },
  // {
  //   month: "Sep",
  //   date: "30.09.2023",
  //   fileStoreId: "21a2799e-0d92-4bbe-9012-e5d42adab3cf",
  //   text: "Continuation of work by the existing Licensees at the existing Licence Fee at the respective lots being allotted to them except the lots being allotted to the successful three H1 bidders in the e-tender NIT No. KMC/CP/MAIN/e-TENDER (01)/2023-24",
  // },
  // {
  //   month: "Sep",
  //   date: "27.09.2023",
  //   fileStoreId: "4104f464-8347-4304-a3f4-5ba6c7dfad71",
  //   text: "List of selected candidates for the post of Medical Officer (contractual) under XV Finance Commission under Health Department of KMC. Ref: Adv. No H/03/KMC/2023 – 24. dated 07.08.2023",
  // },
  // {
  //   month: "Sep",
  //   date: "22.09.2023",
  //   fileStoreId: "bba2cc36-2ca4-4a59-9ec7-45a652ec938d",
  //   text: "4th list of selected candidates for the post of Staff Nurse (contractual) for urban primary health centers in Kolkata City NUHM Society areas against Adv. No . 04/Kolkata City NUHM Society/2022 – 23. Dated 06.09.2022",
  // },
  // {
  //   month: "Sep",
  //   date: "20.09.2023",
  //   fileStoreId: "61b275bb-2466-4449-a7b7-6b631f67e4eb",
  //   text: "List of selected candidates for the post of Specialist Medical Officer for Polyclinic under Health Department KMC on contractual basis Ref: Adv. No . H/02/KMC/2023 – 24. dated 15.07.2023",
  // },
  // {
  //   month: "Sep",
  //   date: "12.09.2023",
  //   fileStoreId: "c1aed38a-ce3c-4162-97f2-9aaa9e387fbe",
  //   text: "4th list of selected candidates for the post of Medical Officer for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No - 13/Kolkata City NUHM Society/2022 – 23. dated 28.01.2023",
  // },
  // {
  //   month: "Sep",
  //   date: "12.09.2023",
  //   fileStoreId: "1db4f556-aa31-499c-b83d-c92dab68f10c",
  //   text: "Walk-in Interview held on 22.09.2023, 29nos. of Medical officer (part time) contractual basis under the Kolkata City NUHM Society, Adv. No . 07/Kolkata City NUHM Society/2023 – 24. dated 21.08.2023",
  // },
  // {
  //   month: "Sep",
  //   date: "05.09.2023",
  //   fileStoreId: "6ae9e120-e2e5-4e4f-b435-b3b3fa01edaf",
  //   text: "2nd list of selected candidates for the post of Staff Nurse for Khidderpore U-CHC, under Kolkata City NUHM Society on contractual basis against Adv. No . 10 /Kolkata City NUHM Society/2022 – 23. Dated 12.11.2022",
  // },
  // {
  //   month: "Sep",
  //   date: "05.09.2023",
  //   fileStoreId: "f1aa7ecf-dc03-4aa8-a7eb-3b97ebce2957",
  //   text: "5th list of selected candidates for the post of Medical Officer for Urban Health & Wellness Centers under XV Finance Commission Health-Grant under Health Department of Kolkata Municipal Corporation Ref: Adv. No H/01/KMC/2022 – 23. Dated 20.10.2022",
  // },
  // {
  //   month: "Aug",
  //   date: "26.08.2023",
  //   fileStoreId: "fadf18c5-bac9-4e11-a38b-0e869a42bd38",
  //   text: "3rd list of selected candidates for the post of Staff Nurse for urban primary health centers under Kolkata City NUHM Society on contractual basis Ref: Adv. No . 04/Kolkata City NUHM Society/2022 – 23. Dated 06.09.2022",
  // },
  // {
  //   month: "Aug",
  //   date: "24.08.2023",
  //   fileStoreId: "fcd67edb-28f7-46e0-ae58-4a3053914593",
  //   text: "List of selected candidates for the post of Medical Officer (Part time) for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No - 04/Kolkata City NUHM Society/2023 – 24. dated 15.08.2023",
  // },
  // {
  //   month: "Aug",
  //   date: "18.08.2023",
  //   fileStoreId: "dfa21497-d632-4769-8322-ea39099ec048",
  //   text: "Walk-in Interview on 29.08.2023 26nos. of Medical Officer on contractual basis for Urban Health & Wellness Centre under the Health Department of Kolkata Municipal Corporation Advertisement No . H/03/KMC/2023-24 dated. 07.08.2023",
  // },
  // {
  //   month: "Aug",
  //   date: "16.08.2023",
  //   fileStoreId: "a07efb58-3efc-4c3a-8a99-41ce3b11a6c4",
  //   text: "2nd list of selected candidate for the post of Medical Officer for Khidderpore U-CHC under Kolkata City NUHM Society on contractual basis against Adv. No - 3/Kolkata City NUHM Society/2023 – 24. Dated 19.06.2023",
  // },
  // {
  //   month: "Aug",
  //   date: "07.08.2023",
  //   fileStoreId: "2102caa0-d772-4755-9092-902fbcfaddba",
  //   text: "2nd list of selected candidate for the post of Medical Officer for Khidderpore U-CHC under Kolkata City NUHM Society on contractual basis against Adv. No - 3/Kolkata City NUHM Society/2023 – 24. Dated 19.06.2023",
  // },
  // {
  //   month: "Aug",
  //   date: "04.08.2023",
  //   fileStoreId: "316f3592-effb-48a2-a7eb-346619f23f7d",
  //   text: "Contractual Appointment",
  // },
  // {
  //   month: "Aug",
  //   date: "03.08.2023",
  //   fileStoreId: "852a8c09-b19b-4888-8395-6f20ac14178b",
  //   text: "Interview on 11.08.2023,16.08.2023, 18.08.2023, 21.08.2023 to 23.08.2023, against Adv. No . No. H/05/KMC/2022-23 dated 20.10.2022. for the post of Staff Nurse (contractual) for Urban Health and Wellness Centres under the XVth Finance Commission Health Grant under the Health Department of Kolkata Municipal Corporation",
  // },
  // {
  //   month: "Aug",
  //   date: "03.08.2023",
  //   fileStoreId: "585e92d6-2b71-479b-a025-d24db3b6fbb7",
  //   text: "Interview on 07.08.2023 & 09.08.2023, against Adv. No . No. H/06/KMC/2022-23 dated 20.10.2022. for the post of Staff Nurse (contractual) for Polyclinic under the XVth Finance Commission Health Grant under the Health Department of Kolkata Municipal Corporation",
  // },
  // {
  //   month: "Aug",
  //   date: "02.08.2023",
  //   fileStoreId: "dfc296b2-5eb0-451b-b0c4-8861ad8afe06",
  //   text: "2nd list of selected candidate for the post of Laboratory Technician for Khidderpore U-CHC under Kolkata City NUHM Society on contractual basis against Adv. No - 8/Kolkata City NUHM Society/2022 – 23. Dated 12.11.2022",
  // },
  // {
  //   month: "Aug",
  //   date: "02.08.2023",
  //   fileStoreId: "624bfa34-ad9a-41b6-9577-b5d2aaaaf0ef",
  //   text: "3rd List of selected candidates for the post of Pharmacist for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 01/Kolkata City NUHM Society/2022 – 23. dated 05.04.2022",
  // },
  // {
  //   month: "Aug",
  //   date: "01.08.2023",
  //   fileStoreId: "4acd060c-b95e-48c6-b9d8-6014388729b3",
  //   text: "Walk-in Interview on 19.08.2023, for the post of Specialist (G&O, Medicine, Paediatrics, Ophthalmologist, Cardiology, ENT, Endocrinology and Orthopaedics) on contractual basis under the Health Department of Kolkata Municipal Corporation against Adv. No . H/02/KMC/2023–24. dated 15.07.2023",
  // },
  // {
  //   month: "Jul",
  //   date: "28.07.2023",
  //   fileStoreId: "b939f371-2361-4210-87cb-ceb96fc39faa",
  //   text: "List of selected candidates for difference post, against Adv. No – KDTCS/Office/37/23 dated 03.06.2023",
  // },
  // {
  //   month: "Jul",
  //   date: "25.07.2023",
  //   fileStoreId: "a2809ea6-a919-4c16-87af-f451a55befa3",
  //   text: "List of selected candidates for the post of Medical Officer & Specialist Medical Officer for Khiddrpore (U-CHC) under Kolkata City NUHM Society on contractual basis against Adv. No . 03/Kolkata City NUHM Society/2023 – 24. dated 19.06.2023 and 02/Kolkata City NUHM Society/2023 – 24. dated 06.06.2023",
  // },
  // {
  //   month: "Jul",
  //   date: "24.07.2023",
  //   fileStoreId: "e5fc4844-ec78-44b9-bf65-1e1e65989a50",
  //   text: "Engagement of 8 nos. Laboratory Technicians on contractual basis under the Kolkata City NUHM Society against Adv. No . 05/Kolkata City NUHM Society/2023–24. dated 15.07.2023",
  // },
  // {
  //   month: "Jul",
  //   date: "19.07.2023",
  //   fileStoreId: "8ef21aae-fc4b-4b68-a5ec-e5abc1d073b0",
  //   text: "Walk-in Interview on 04.08.2023, 59nos. Medical officer (part time) contractual basis under the Kolkata City NUHM Society against Adv. No . 04/Kolkata City NUHM Society/2023 – 24. dated 15.07.2023",
  // },
  // {
  //   month: "Jul",
  //   date: "19.07.2023",
  //   fileStoreId: "614277cc-7b94-44f2-b73e-c860e495135e",
  //   text: "2nd List of selected candidates for the post of Pharmacist for its urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No. 01/Kolkata City NUHM Society/2022 – 23",
  // },
  // {
  //   month: "Jul",
  //   date: "14.07.2023",
  //   fileStoreId: "dbc0a037-35fa-4067-8265-e6996624b21e",
  //   text: "List of selected candidate for the post of Quality Manager on contractual basis against Adv. No - 12/Kolkata City NUHM Society/2022 – 23. dated 15.12.2022",
  // },
  // {
  //   month: "Jul",
  //   date: "11.07.2023",
  //   fileStoreId: "24f286f2-c9ba-40e5-81c2-912ac7895f6d",
  //   text: "List of selected candidate for the post of Analyst for Modified Food Safety on Wheels on Contractual Basis, Under Health Department, Kolkata Municipal Corporation against Adv. No H/04/KMC/2022-23 dt. 23.02.2023",
  // },
  // {
  //   month: "Jul",
  //   date: "11.07.2023",
  //   fileStoreId: "e4b6297e-259d-4f10-9d8e-b43d3d9b5e65",
  //   text: "List of selected candidates for the post of Community Health Assistants (Urban) under XV Finance Commission Health Grant, Health Department of Kolkata Municipal Corporation on contractual basis against Adv. No. H/07/KMC/2022–23. Dated 20.10.2022",
  // },
  // {
  //   month: "Jul",
  //   date: "01.07.2023",
  //   fileStoreId: "582324c2-9ed6-41ea-a853-509267e88cbf",
  //   text: "List of selected candidates for the post of Specialist Medical Officer for Polyclinic under Health Department KMC on contractual basis against on contractual basis against Ref. Adv. No . H/01/KMC/2023 – 24. dated 06.06.2023",
  // },
  // {
  //   month: "Jul",
  //   date: "01.07.2023",
  //   fileStoreId: "d1a3a737-8a0f-4413-a20f-e0029c58837d",
  //   text: "3rd list of selected candidates for the post of Medical Officer for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No - 13/Kolkata City NUHM Society/2022 – 23. Dated 28.01.2023",
  // },
  // {
  //   month: "Jul",
  //   date: "01.07.2023",
  //   fileStoreId: "7f7b7354-a134-40b4-931f-d4008e5dd98f",
  //   text: "4th list of selected candidates for the post of Medical Officer for Khidderpore U-CHC under Kolkata City NUHM Society on contractual basis against Adv. No - 7/Kolkata City NUHM Society/2022 – 23. Dated 12.11.2022",
  // },
  // {
  //   month: "Jul",
  //   date: "01.07.2023",
  //   fileStoreId: "df51cb13-a8e0-4321-b3d0-d1c14ffe1854",
  //   text: "4th list of selected candidates for the post of Medical Officer under Health Department KMC on contractual basis against Adv. No H/01/KMC/2022 – 23. Dated 20.10.2022",
  // },
  // {
  //   month: "Jun",
  //   date: "28.06.2023",
  //   fileStoreId: "51146e7b-a1f8-45d5-8323-94e3bd288372",
  //   text: "Walk-in Interview on 06.07.2023, 04 nos. Medical Officer on contractual basis for Kidderpore U-CHC under Kolkata City NUHM Society against Adv. No . 03/Kolkata City NUHM Society/2023–24. dated 19.06.2023",
  // },
  // {
  //   month: "Jun",
  //   date: "27.06.2023",
  //   fileStoreId: "73e57f36-4ecd-4d3a-a698-6e0a85d628f5",
  //   text: "List of selected candidates for the Computer Test and Interview post of Laboratory Technician, STS, STLS and TBHV against Memo. No. KDTCS/Office/37/23. dated 03.06.2023.",
  // 07=08=2026================================},
  // {
  //   month: "Jun",
  //   date: "23.06.2023",
  //   fileStoreId: "4dfdf2bd-52aa-48be-965b-da8344035997",
  //   text: "LOCATIONS OF SLAUGHTERING OF ANIMALS ON THE OCCASION OF ID-UD-ZOHA (BAKRI-EID) ON 29/06/2023, 30/06/2023 AND 01/07/2023.",
  // },
  // {
  //   month: "Jun",
  //   date: "14.06.2023",
  //   fileStoreId: "7b612d42-c5f8-4312-9865-9195fcf1b8eb",
  //   text: "List of selected candidates for the post of Medical Officer (Part time) for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No - 01/Kolkata City NUHM Society/2023 – 24. Dated 12.04.2023",
  // },
  // {
  //   month: "Jun",
  //   date: "13.06.2023",
  //   fileStoreId: "b0406746-aef7-4ccd-afe3-23e85f152969",
  //   text: "3rd list of selected candidates for the post of Medical Officer under Health Department KMC on contractual basis against Adv. No H/01/KMC/2022 – 23. Dated 20.10.2022",
  // },
  // {
  //   month: "Jun",
  //   date: "09.06.2023",
  //   fileStoreId: "6bc38046-5478-4bc3-97b7-cc86a08cbf5a",
  //   text: "The Computer Test & Interview for the post of Quality Manager against Adv. No . 12/Kolkata City NUHM Society/2022 – 23. dated 15.12.2022 under Kolkata City NUHM Society",
  // },
  // {
  //   month: "Jun",
  //   date: "07.06.2023",
  //   fileStoreId: "a206401d-0c1c-43cd-b616-4592b1f297d1",
  //   text: "Walk-in Interview on 12.06.2023, 05 nos. Specialist (Surgeon, Orthopedics, Medicine and Anesthetist) on contractual basis for Kidderpore U-CHC under Kolkata City NUHM Society against Adv. No . 02/Kolkata City NUHM Society/2023–24. dated 06.06.2023",
  // },
  // {
  //   month: "Jun",
  //   date: "06.06.2023",
  //   fileStoreId: "3eed311f-af29-4a57-9e9d-95b214035280",
  //   text: "Walk-in Interview on 12.06.2023, 90 nos. Specialist (G&O, Medicine, Paediatrics, Ophthalmologist, Cardiology, ENT, Endocrinology and Orthopendics) on contractual basis under the Health Department of Kolkata Municipal Corporation against Adv. No . H/01/KMC/2023–24. dated 31.05.2023",
  // },
  // {
  //   month: "Jun",
  //   date: "05.06.2023",
  //   fileStoreId: "1857d717-d7be-4a99-bb34-0d7273932a50",
  //   text: "Engagement of STS, STLS, LT, TBHV and MO(NTEP) under National Tuberculosis Elimination Programme on contractual basis against Adv. No . KDTCS/Office/37/23. dated 03.06.2023",
  // },
  // {
  //   month: "Jun",
  //   date: "03.06.2023",
  //   fileStoreId: "97b8b016-e4d6-4057-8fe2-627fccea0e84",
  //   text: "List of selected candidates for the post of Laboratory Technician, Pharmacist, Staff Nurse & Ophthalmic Assistant for Khidderpore U-CHC, under Kolkata City NUHM Society on contractual basis against Adv. No . 08,9,10 & 11/Kolkata City NUHM Society/2022 – 23. Dated 12.11.2022",
  // },
  // {
  //   month: "May",
  //   date: "29.05.2023",
  //   fileStoreId: "f2aa73c9-0fd9-4a22-80eb-f26d28f20a72",
  //   text: "2nd list of selected candidates for the post of Medical Officer under XVth Finance Commission, Health Department KMC on contractual basis against Adv. No H/01/KMC/2022 – 23. Dated 20.10.2022",
  // },
  // {
  //   month: "May",
  //   date: "26.05.2023",
  //   fileStoreId: "88457449-9e5a-4f97-afb1-2bd4cf091226",
  //   text: "Written Test, Computer Skill Test & Interview against Adv. No . 12/Kolkata City NUHM Society/2022 – 23. dated 15.12.2022 for the post of Quality Manager (contractual) under the Kolkata City NUHM Society",
  // },
  // {
  //   month: "May",
  //   date: "26.05.2023",
  //   fileStoreId: "787a25c0-2d1d-48fe-afa2-8b96c3894127",
  //   text: "3rd List of selected candidates for the post of Medical Officer for Khidderpore U-CHC under Kolkata City NUHM Society on contractual basis against Adv. No - 7/Kolkata City NUHM Society/2022 – 23. Dated 12.11.2022",
  // },
  // {
  //   month: "Apr",
  //   date: "12.04.2023",
  //   fileStoreId: "5a5c73e1-4179-4f0f-a0f7-63e13114f4fc",
  //   text: "Corrigendum to Advertisement No. 01/Kolkata City NUHM Society/2023-24. Dated 12.04.2023",
  // },
  // {
  //   month: "May",
  //   date: "11.05.2023",
  //   fileStoreId: "d893f99d-c0bc-468d-a3a5-566c63f4dc6d",
  //   text: "List of selected candidates for the Computer Test on 18.05.2023 post of Pharmacist and Laboratory Technician on contractual basis against Adv. No. 08/Kolkata City NUHM Society/2022 – 23. and 09/Kolkata City NUHM Society/2022 – 23. Dated 12.11.2023",
  // },
  // {
  //   month: "May",
  //   date: "11.05.2023",
  //   fileStoreId: "8d657ad5-e76a-473f-854f-8c384351d446",
  //   text: "Walk-in Interview on 22.05.2023, 89nos. Medical officer (part time) contractual basis under the Kolkata City NUHM Society against Adv. No . 01/Kolkata City NUHM Society/2023 – 24. Dated 12.04.2023",
  // },
  // {
  //   month: "May",
  //   date: "10.05.2023",
  //   fileStoreId: "1e051db6-93bc-4180-9d0b-30aa09f4054f",
  //   text: "Dismantling of hoarding structure from the different premises within the jurisdiction of KMC",
  // },
  // {
  //   month: "May",
  //   date: "04.05.2023",
  //   fileStoreId: "43fff7d1-342e-4cf9-94dc-3b5966f000c4",
  //   text: "2nd list of selected candidates for the post of Medical Officer for Khidderpore U-CHC under Kolkata City NUHM Society on contractual basis against Adv. No - 7/Kolkata City NUHM Society/2022 – 23. Dated 12.11.2022",
  // },
  // {
  //   month: "Apr",
  //   date: "28.04.2023",
  //   fileStoreId: "321f62c8-3172-4077-ac88-40ae60f183d4",
  //   text: "Interview on 04.05.2023 against Adv. No . 11/Kolkata City NUHM Society/2022 – 23. for the post of Ophthalmic Assistant contractual for Khidderpore U-CHC under the Kolkata City NUHM Society",
  // },
  // {
  //   month: "Apr",
  //   date: "28.04.2023",
  //   fileStoreId: "5c832e45-2691-46a2-8431-2f7eda47b7eb",
  //   text: "Interview on 12.05.2023 & 15.05.2023, against Adv. No . 10/Kolkata City NUHM Society/2022 – 23. for the post of Staff Nurse contractual for Khidderpore U-CHC under the Kolkata City NUHM Society",
  // },

  // {
  //   month: "Apr",
  //   date: "18.04.2023",
  //   fileStoreId: "d8da1269-86cc-437d-ab98-aaf2d989ea26",
  //   text: "2nd List of selected candidates for the post of Staff Nurse for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 04/Kolkata City NUHM Society/2022 – 23. Dated 06.09.2022",
  // },
  // {
  //   month: "Mar",
  //   date: "27.03.2023",
  //   fileStoreId: "98b1d5e9-d6ad-4b62-8cb1-6deaac074ad7",
  //   text: "Engagement of 30nos. of Community Health Assistant (Urban) contractual basis under XV Finance Commission. Advt. No. H/07/KMC/2022-23. Dated 20.10.2022",
  // },
  // {
  //   month: "Mar",
  //   date: "24.03.2023",
  //   fileStoreId: "2f36a192-8386-4fd9-881f-5b86518ace19",
  //   text: "Engagement of 17nos. Staff Nurse for Polyclinic on contractual basis under XV Finance Commission. Advt. No. H/06/KMC/2022-23. Dated 20.10.2022",
  // },
  // {
  //   month: "Feb",
  //   date: "23.02.2023",
  //   fileStoreId: "403ba9c7-0da3-4c3c-88a8-dc25bdc32121",
  //   text: "Corrigendum to Advertisement No. H/04/KMC/2022-23. dated 23.02.2023.",
  // },
  // {
  //   month: "Oct",
  //   date: "20.10.2022",
  //   fileStoreId: "371accac-db4e-48ed-b69e-048e6102fdfa",
  //   text: "List of selected candidates for the post of Medical Officer for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No.13/Kolkata City NUHM Society/2022 – 23. Dated 28.01.2023.",
  // },
  // {
  //   month: "Oct",
  //   date: "01.10.2022",
  //   fileStoreId: "371accac-db4e-48ed-b69e-048e6102fdfa",
  //   text: "Walk-in Interview on 20.03.2023 & 21.03.2023, 01no. of Analyst & 01 no. of Driver contractual basis under the Health Department of Kolkata Municipal Corporation against Adv. No . H/04/KMC/2022-23 dated. 23.02.2023.",
  // },
  // {
  //   month: "Oct",
  //   date: "20.10.2022",
  //   fileStoreId: "b39b018d-6306-4c7c-b018-38b0215ebc41",
  //   text: "Engagement of 30 nos. Staff Nurse on contractual basis under XV Finance Commission. Advt. No. H/05/KMC/2022-23.",
  // },
  // {
  //   month: "Sep",
  //   date: "06.09.2022",
  //   fileStoreId: "f9f2e91f-516b-4cf7-a1e8-aa7da1b939f3",
  //   text: "List of selected candidates for the post of Staff Nurse for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No . 04/Kolkata City NUHM Society/2022 – 23.",
  // },
  // {
  //   month: "Jan",
  //   date: "13.01.2023",
  //   fileStoreId: "0a9acfc9-1ae2-4a45-89d6-30da925bf7d2",
  //   text: "List of selected candidates for the post of Medical Officer (Part time) for urban primary health centers in Kolkata City NUHM Society areas on contractual basis against Adv. No - 06/Kolkata City NUHM Society/2022 – 23.",
  // },
  // {
  //   month: "Oct",
  //   date: "20.10.2022",
  //   fileStoreId: "8845d141-45ef-45f6-b680-8c86fff0be6c",
  //   text: "Micro planning to mitigate air pollution in connection with selected Hot Spots",
  // },
  // {
  //   month: "Apr",
  //   date: "26.04.2022",
  //   fileStoreId: "a28f2ba9-91d5-4f42-b476-898f617090bb",
  //   text: "Handbook for action plan to mitigate flood, cyclone & water logging-2017",
  // },
];

export const ImportantLinksList1 = [
  {
    link: "https://wb.gov.in/",
    text: "Official Website of West Bengal Govt",
  },
  {
    link: "https://www.mscwb.org/",
    text: "Municipal Service Commission",
  },
  // {
  //   link: "http://wbarbanservices.gov.in/",
  //   text: "Municipal Affairs Dept",
  // },
  {
    link: "http://www.keiip.in/",
    text: "KEIIP",
  },
];

export const ImportantLinksList2 = [
  {
    link: "https://www.wb.gov.in/",
    text: "Official Website of West Bengal Govt",
  },
];

export const KMCDepartmentList = [
  {
    to: "/KMC_Advertisement",
    department: "Advertisement",
    keyActivities: "Overall monitoring of outdoor advertisement",
    isClickable: true,
  },
  {
    to: "/Amusement",
    department: "Amusement",
    keyActivities:
      "Issue of new amusement license, renewal letter and monitoring functions",
    isClickable: true,
  },
  {
    to: "/Assessment_Collection_Assessment_Home",
    department: "Assessment & Collection",
    keyActivities:
      "Assessment of land and buildings, Mutation and Collection of Property Tax",
    isClickable: true,
  },
  {
    to: "/Building_Sanction_Building_Home",
    department: "Building",
    keyActivities:
      "Scrutinizing building plan, checking unauthorized construction and routine inspection",
    isClickable: true,
  },
  {
    to: "/KMC_Bustee_services",
    department: "Uttaran Services",
    keyActivities:
      "Carry out physical and social infrastructure development in the bustees of the City",
    isClickable: true,
  },
  {
    to: "/Car_Parking_Home",
    department: "Car Parking",
    keyActivities: "Responsible for arranging for parking spaces.",
    isClickable: true,
  },
  {
    to: "/KMC_Central_records_Home",
    department: "Central Records",
    keyActivities:
      "To maintain all old records such as birth and death registration, sanctioned building plans, assessment registers, etc.",
    isClickable: true,
  },
  {
    to: "/CH_VS_Dept_Download_Forms",
    department: "Ch. VS Department",
    keyActivities:
      "Chief Valuer and Surveyor maintains records of all immovable assets of KMC and performs tasks requiring verification or information from those.",
    isClickable: true,
  },
  {
    to: "/Kmc_school_home",
    department: "Education",
    keyActivities:
      'Imparting primary education and interacting with Government agencies and NGO"s.',
    isClickable: true,
  },
  {
    to: "",
    department: "Election Office",
    keyActivities: "Conducts elections of the Corporation.",
    isClickable: false,
  },
  {
    to: `${prodURL}/contact-us/departmentContacts`,
    department: "Electricity",
    keyActivities:
      "Carries out works related to Electricity supply in the Corporation area.",
    isClickable: true,
  },
  {
    to: "/Engineering_Home",
    department: "Engineering (Civil)",
    keyActivities:
      "Building and repairing of roads, removal of chokages, bustee development work, construction of public conveniences, etc.",
    isClickable: true,
  },
  {
    to: "",
    department: "Entally workshop",
    keyActivities:
      "Production, repairing of different products required by various departments of KMC.",
    isClickable: false,
  },
  {
    to: "/HeritageBuildingHome",
    department: "Environment & Heritage Department",
    keyActivities:
      "Looks after issues like Geographical Information System, water bodies conservation, heritage conservation.",
    isClickable: true,
  },
  {
    to: "",
    department: "Estate",
    keyActivities:
      "Survey and maintain records of the land and building owned by the KMC.",
    isClickable: false,
  },
  {
    to: `${prodURL}/contact-us/departmentContacts`,
    department: "Finance and accounts",
    keyActivities:
      "Carry out accounting of the activities of the Corporation and handling of the treasury.",
    isClickable: true,
  },
  {
    to: "/Health_services_Health_Home",
    department: "Health",
    keyActivities:
      "Provide preventive, curative and promotive health facilities like vaccination etc",
    isClickable: true,
  },
  {
    to: "",
    department: "Info. & public relations",
    keyActivities:
      "To maintain public relation, issue Advertisement for print and electronic media, organizing press conferences and coverage of various events",
    isClickable: false,
  },
  // {
  //   to: "/IT_Dept",
  //   department: "Information Technology",
  //   keyActivities:
  //     "IT department is responsible for development and implementation of software across all departments of KMC. This includes specific initiatives like E-Kolkata Centres, Web Portal, ERP, MAS, KMC-NET, Data Centre, Disaster Recovery Centre etc",
  //   isClickable: true,
  // },
  {
    to: `${prodURL}/contact-us/departmentContacts`,
    department: "Information Technology",
    keyActivities:
      "IT department is responsible for development and implementation of software across all departments of KMC. This includes specific initiatives like E-Kolkata Centres, Web Portal, ERP, MAS, KMC-NET, Data Centre, Disaster Recovery Centre etc",
    isClickable: true,
  },
  {
    to: "",
    department: "Institute of Urban Management",
    keyActivities:
      "Impart training on Computer, Administrative and work based training to the employees of KMC.",
    isClickable: false,
  },
  {
    to: "",
    department: "Internal Audit",
    keyActivities:
      "Scrutinize and vet the audit replies given by the functional departments to the statutory auditors and conduct specific audits (i.e. special audit, Investigation, enquiries etc) assigned by the MC, JMC, etc.",
    isClickable: false,
  },
  {
    to: `${prodURL}/contact-us/departmentContacts`,
    department: "Law",
    keyActivities:
      "Deal with legal matters and provide legal opinion to the different departments of KMC.",
    isClickable: true,
  },
  {
    to: "/Certificate_of_Enlistment",
    department: "License",
    keyActivities:
      "Issue of new trade licenses, Renewal of old/expired trade licenses, Issuing temporary licenses, raising Demands for Trade License, etc. in relation to trade licenses.",
    isClickable: true,
  },
  {
    to: "/Lighting_Home",
    department: "Lighting",
    keyActivities:
      "Operation and maintenance of street lights, installation of new street lighting systems, maintain lighting of markets and institutions e.g. Chief Municipal office.",
    isClickable: true,
  },
  {
    to: "/KMC_market_list",
    department: "Market",
    keyActivities: "Construction and maintenance of Municipal Markets.",
    isClickable: true,
  },
  {
    to: "/MatHome",
    department: "MAT",
    keyActivities: "...",
    isClickable: true,
  },

  {
    to: "",
    department: "MPLADS-BEUP Cell",
    keyActivities:
      "Nodal & Implementing District Authority for implementation of works under MPLADS and BEUP with in the jurisdiction of KMC and also to allocate MPLADS and BEUP funds to different Govt. departments.",
    isClickable: false,
  },
  {
    to: "",
    department: "Municipal Commissioner's Office",
    keyActivities:
      "Secretarial functions of the Municipal Commissioner are performed by this Office.",
    isClickable: false,
  },
  // {
  //   to: "/Mpl_Secretary_Dept",
  //   department: "Municipal Secretary’s department",
  //   keyActivities: "Carry out the recruitment for the Corporation.",
  //   isClickable: true,
  // },
  {
    to: `${prodURL}/contact-us/departmentContacts`,
    department: "Municipal Secretary’s department",
    keyActivities: "Carry out secretarial functions of the Corporation.",
    isClickable: true,
  },
  {
    to: "/Parks_and_gardens",
    department: "Parks & Squares",
    keyActivities:
      "Looks after the matters related to parks and squares in the city.",
    isClickable: true,
  },
  {
    to: `${prodURL}/contact-us/departmentContacts`,
    department: "Personnel",
    keyActivities:
      "Initiating promotion, transfer proposal and attend court cases related to personnel matters.",
    isClickable: true,
  },
  {
    to: `${prodURL}/contact-us/departmentContacts`,
    department: "Planning & Development",
    keyActivities: "Takes care of overall planning of the city.",
    isClickable: true,
  },
  {
    to: "",
    department: "Printing",
    keyActivities:
      "Print all types of forms, publications, registers and schedule books of the Corporation",
    isClickable: false,
  },
  {
    to: `${prodURL}/contact-us/departmentContacts`,
    department: "Roads and Asphaltum",
    keyActivities: false,
    fileStoreId:"d5a3bd97-4343-4bfa-8e3c-41ed3241bb25",
    label: "Carrying out construction of new roads, under pass...",
    isClickable: true,
  },
  {
    to: "/Drainage_Home",
    department: "Sewerage & Drainage",
    keyActivities:
      "Manage and maintain the central sewerage and drainage lines under all major / arterial roads.",
    isClickable: true,
  },
  {
    to: "/Social_welfare_Download_Forms",
    department: "Social Welfare & Urban Poverty Alleviation Department",
    keyActivities:
      "Looks after social sector issues like family welfare, women empowerment, employment generation etc.",
    isClickable: true,
  },
  {
    to: "/Solid_wastes_home",
    department: "Solid Waste Management",
    keyActivities:
      "Sweep streets, collect solid waste from households and collection points and transport to the dumping yard.",
    isClickable: true,
  },
  {
    to: "",
    department: "Supply",
    keyActivities: "Material planning, procurement and storage of materials.",
    isClickable: false,
  },
  {
    to: "",
    department: "The Mayor's Secretariat",
    keyActivities:
      "Receiving complaints and grievances through Talk to Mayor, WhatsApp, Show to Mayor, letters, and emails, forwarding complaints to relevant departments, coordination for redressal, and provides feedback to complainants.",
    isClickable: false,
  },
  {
    to: `${prodURL}/contact-us/departmentContacts`,
    department: "Treasury Department",
    keyActivities: "Takes care of treasury of KMC.",
    isClickable: true,
  },
  {
    to: `${prodURL}/contact-us/departmentContacts`,
    department: "Vigilance",
    keyActivities:
      "Investigate cases against employees on receipt of complaints from Councillors, citizens or any other source",
    isClickable: true,
  },
  // {
  //   to: "/Vigilance",
  //   department: "Vigilance",
  //   keyActivities:
  //     "Investigate cases against employees on receipt of complaints from Councillors, citizens or any other source",
  //   isClickable: true,
  // },
  {
    to: "/Water_Supply",
    department: "Water Supply",
    keyActivities:
      "Installation, operation and maintenance of water treatment plants, booster pumping stations and tubewells.",
    isClickable: true,
  },
];

export const KMCBudgetList = [
  {
    leftBudgetStatement: {
      fileStoreId: "18013826-2a59-4f3c-8a94-891f18042026",
      name: "Budget Statement 2026-2027",
    },
    rightBudgetStatement: {
      fileStoreId: "c6effc48-7672-4572-b21e-68ea51cbcbcd",
      name: "Budget Estimates 2026-2027",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "18014026-2a59-4f3c-8a94-891f18042026",
      name: "Budget Statement 2025-2026",
    },
    rightBudgetStatement: {
      fileStoreId: "18014126-2a59-4f3c-8a94-891f18042026",
      name: "Budget Estimates 2025-2026",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "18014226-2a59-4f3c-8a94-891f18042026",
      name: "Budget Statement 2024-2025",
    },
    rightBudgetStatement: {
      fileStoreId: "9b701b46-63ae-4cb6-a8aa-417a2978fe13",
      name: "Budget Estimates 2024-2025",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "c43cedcb-e9f5-4a1d-85e4-6e0cc5c34811",
      name: "Budget Statement 2023-2024",
    },
    rightBudgetStatement: {
      fileStoreId: "a8ccb37e-280a-4c42-92a5-70b50d911ae4",
      name: "Budget Estimates 2023-2024",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "",
      name: "...",
    },
    rightBudgetStatement: {
      fileStoreId: "8a20db60-bb60-4d1b-9ee9-4de8c99f81cc",
      name: "Budget Estimates 2022-2023",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "",
      name: "...",
    },
    rightBudgetStatement: {
      fileStoreId: "55fd4df4-5527-4e83-917e-627c62b25a37",
      name: "Budget Estimates 2021-2022",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "",
      name: "...",
    },
    rightBudgetStatement: {
      fileStoreId: "dec3a9e7-f417-4bec-a51b-d011f0dc6dbd",
      name: "Budget Estimates 2020-2021",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "25eb1f8c-7224-462f-8b1c-72c975656c06",
      name: "Budget Statement 2019-2020",
    },
    rightBudgetStatement: {
      fileStoreId: "71b9e2af-9a95-443b-a0e6-f98f96493291",
      name: "Budget Estimates 2019-2020",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "cadbdee2-a28c-4255-8443-c41edda39ac1",
      name: "Budget Statement 2018-2019",
    },
    rightBudgetStatement: {
      fileStoreId: "62c729ab-495c-4695-8501-0538f5ae63fa",
      name: "Budget Estimates 2018-2019",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "6613cd32-2458-4d7e-b6af-2aae18212857",
      name: "Budget Statement 2017-2018",
    },
    rightBudgetStatement: {
      fileStoreId: "f0334915-f591-4691-9fcf-eb1f63e2b3ad",
      name: "Budget Estimates 2017-2018",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "eb6fa3e7-738e-49c1-9dd2-0736929567cd",
      name: "Budget Statement 2016-2017",
    },
    rightBudgetStatement: {
      fileStoreId: "18015526-2a59-4f3c-8a94-891f18042026",
      name: "Budget Estimates 2016-2017",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "f979a27e-770d-4cdf-8056-26435cb49ab7",
      name: "INTERIM ESTIMATE OF INCOME & EXPENDITURE For the 1st and 2ndQuarters of 2016 -17",
    },
    rightBudgetStatement: {
      fileStoreId: "796ece6f-0b53-433d-8241-e60a55b4f9dc",
      name: "Budget Statement 2015-2016",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "3da587c5-5eaf-45df-b3ee-b1455d522477",
      name: "Budget Estimates 2015-2016",
    },
    rightBudgetStatement: {
      fileStoreId: "f2c8c514-9e4a-46cb-9301-d155400bda7c",
      name: "INTERIM ESTIMATE OF INCOME &amp; EXPENDITURE For Six Months w.e.f. 01.4.2015 to 30.9.2015",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "5f8c27cd-a6ec-4db9-971b-5a8ad3290c34",
      name: "Mayor's Budget Estimate For 2014-2015",
    },
    rightBudgetStatement: {
      fileStoreId: "13917bf6-d5a6-43b6-9d7a-d2639974982e",
      name: "INTERIM ESTIMATE OF INCOME &amp; EXPENDITURE For 1st Quarter of 2014-15",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "b16ae6cd-de16-4cbd-853e-ac095075e5b4",
      name: "Mayor's Budget Statement For 2013-2014",
    },
    rightBudgetStatement: {
      fileStoreId: "930ed98d-480e-48bc-a99f-2ca5caa9740d",
      name: "Mayor's Budget Estimate For 2013-2014",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "0d41a8a6-b4e9-41fa-9c44-5324d8f26c6f",
      name: "Mayor's Budget Statement For 2012-2013",
    },
    rightBudgetStatement: {
      fileStoreId: "aa3525aa-b6d7-4015-9305-022c4bbd7678",
      name: "Mayor's Budget Estimate For 2012-2013",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "1bfce49e-071a-401c-8a84-94f2544bbd3c",
      name: "Mayor's Budget Statement For 2011-2012",
    },
    rightBudgetStatement: {
      fileStoreId: "8ca7737b-4133-4c9f-8b6c-b40537cd6f92",
      name: "Interim Estimate of Income &amp; Expenditure Dated 15.03.2011",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "890326bc-c5c3-43a2-a9a4-4f8f0822a7ee",
      name: "Mayor's Interim Revised Budget Statement For 2010-2011",
    },
    rightBudgetStatement: {
      fileStoreId: "181d4b99-1b70-482e-ade1-e686fa9acf44",
      name: "Mayor's Budget Statement For 2010-2011",
    },
  },
  {
    leftBudgetStatement: {
      fileStoreId: "16c99c18-8044-4fb9-98b4-ec57a5099d75",
      name: "Mayor's Budget Statement For 2009-2010",
    },
    rightBudgetStatement: {
      fileStoreId: "",
      name: "...",
    },
  },
];

export const HealthServicesLeftMenuList = [
  { type: "link", to: "/Health_services_Health_Home", label: "Health Home" },
  // {
  //   type: "filestore",
  //   fileStoreId: "3e50a402-3467-4bba-ae59-23fa4fafe8f9",
  //   label:
  //     "LOCATIONS OF SLAUGHTERING OF ANIMALS ON THE OCCASION OF ID-UD-ZOHA (BAKRI-EID) ON 29/06/2023,30/06/2023 AND 01/07/2023",
  // },
  {
    type: "filestore",
    fileStoreId: "efd4f827-9d78-452f-9825-0063806c8316",
    label: "Dengue - Status- Appeal to Citizens",
  },
  {
    type: "filestore",
    fileStoreId: "2c43cf75-e690-4752-953a-8654b0964aa2",
    label: "Immunisation Centres",
  },
  {
    type: "filestore",
    fileStoreId: "d9ed5ffe-c455-4ef8-9913-6e673e2b6b62",
    label: "Health Units",
  },
  { type: "link", to: "/Health_Malaria_CLinics", label: "Malaria Clinics" },
  { type: "link", to: "/Health_Maternity_Homes", label: "Maternity Homes" },
  { type: "link", to: "/Health_KMC_Dispensaries", label: "KMC Dispensaries" },
  { type: "link", to: "/Health_Chest_Clinincs", label: "KMC Chest Clinics" },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Water Test Reprint e-Receipt",
    target: "_blank",
  },
  { type: "link", to: "/Health_Desease_control", label: "Desease Control" },
  {
    type: "filestore",
    fileStoreId: "9b83ad58-53c5-4ffe-a993-22bd569cc254",
    label: "DETAILS OF HPV VACCINATION CENTRES UNDER KMC AREA",
  },
  {
    type: "filestore",
    fileStoreId: "5b8e5904-0ae8-421c-be33-23b1b1662fb2",
    label: "Fees & Charges",
  },
  { type: "link", to: "/Health_MTMTB_Hospital", label: "MTMTB Hospital" },
  { type: "link", to: "/Health_Slaughter_House", label: "Slaughter House" },
  { type: "link", to: "/Health_Ambulances", label: "Ambulance" },
  {
    type: "link",
    to: "/Health_Antirabies_VACCINATION_Center",
    label: "Antirabies Vaccination Centre",
  },
  {
    type: "link",
    to: "/Health_Designation_Activities",
    label: "Designation Activity",
  },
  {
    type: "anchor",
    href: `${prodURL}/ghats/`,
    label: "Burning Ghat Status",
    target: "_blank",
  },
  {
    type: "link",
    to: "/Land_Records_Burial_Grounds",
    label: "Land Records Of Burial Grounds",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
  },
  {
    type: "filestore",
    fileStoreId: "b700f156-f0df-4e0a-a924-ccafc871380c",
    label: "Information on FSS Act-License / Registration in KMC",
  },
  // {
  //   type: "filestore",
  //   fileStoreId: "3e50a402-3467-4bba-ae59-23fa4fafe8f9",
  //   label:
  //     "LOCATIONS OF SLAUGHTERING OF ANIMALS ON THE OCCASION OF ID-UD-ZOHA(BAKRI-ID) ON 10.07.2022, 11.07.2022 & 12.07.2022",
  // },
  // {
  //   type: "filestore",
  //   fileStoreId: "5ce4e4e2-4499-45bf-a82f-63cd4bc3b99d",
  //   label: "SWASTHYA BANDHAB SHARAD SAMMAN",
  // },
  {
    type: "filestore",
    fileStoreId: "c3735a37-06dd-473b-a495-86cc2463332e",
    label: "List of Functional U-PHC Under NUHM",
  },
  {
    type: "filestore",
    fileStoreId: "a7f03f1b-a233-4617-a98f-8fd7c5779306",
    label: "Details of UPHC",
  },
  // {
  //   type: "filestore",
  //   fileStoreId: "02bb77eb-da38-472c-b4d2-377ae373742b",
  //   label: "LIST OF ENLISTED AGENCIES FOR CARRYING COVID BODIES",
  // },
  {
    type: "filestore",
    fileStoreId: "47cd014e-f783-431f-a49f-8ba483cac252",
    label: "Immersion training by ECHO India for KMC Health staff",
  },
  {
    type: "filestore",
    fileStoreId: "6856a7f2-e621-4b2d-8104-9e54d06e90d2",
    label:
      "KMC Participation and Experiences at ECHO India's IPC Dissemination Event : Mumbai",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Application/Payment for Potable Water Analysis",
    target: "_blank",
  },
  // {
  //   type: "filestore",
  //   fileStoreId: "efd4f827-9d78-452f-9825-0063806c8316",
  //   label: "Dengue - Status-Appeal to Citizens",
  // },
  // {
  //   type: "filestore",
  //   fileStoreId: "2c43cf75-e690-4752-953a-8654b0964aa2",
  //   label: "Immunisation Centers",
  // },
];

export const BurialGroundRecords = [
  {
    fileStoreId: "a9416c7c-019f-429e-bdbc-75e1a30768c1",
    label: "Bagmari Burial Ground",
  },
  {
    fileStoreId: "bdbe4536-8db3-4537-b939-19487c58304b",
    label: "Bagmari Burial Ground 2",
  },
  {
    fileStoreId: "963bdfa6-1db3-4f08-a83a-87ada1d77acc",
    label: "Bagmari Burial Ground 3",
  },
  {
    fileStoreId: "1b03db9e-6517-4243-a5da-914f8ca99820",
    label: "Gobra 24.07.1953 to 18.02.1970",
  },
  {
    fileStoreId: "39737a55-fcf9-43dc-8e49-5b14397dd9a0",
    label: "Gobra 03.04.1918 to 11.02.1949",
  },
  {
    fileStoreId: "3917eb16-eb59-476d-b324-3fb4e977d427",
    label: "Gobra 04.05.1926-06.03.1980",
  },
  {
    fileStoreId: "95d49e62-e3f6-4430-a7bb-84f45330c358",
    label: "Gobra 04.05.1926 - 06.03.1980 (Bagmari)",
  },
  {
    fileStoreId: "4532ddbe-2568-4cf8-99da-f0d355396538",
    label: "Gobra 04.05.1926 - 06.03.1980",
  },
  {
    fileStoreId: "fb697b01-f00b-44b8-bad2-d3d26ec61482",
    label: "Gobra 06.04.1928-21.02.1934",
  },
  {
    fileStoreId: "67c3bb1e-be31-418c-94c3-e7a0670f9764",
    label: "Gobra 06.04.1928-21.02.1934",
  },
  {
    fileStoreId: "d4825632-8da6-47e0-b7b9-dc24daadebf2",
    label: "Gobra 07.02.1969-20.02.1978",
  },
  {
    fileStoreId: "bf3acc8b-fc7e-4480-9645-5ad78c576fad",
    label: "Gobra 08.03.1978-13.08.1979",
  },
  {
    fileStoreId: "53dccc52-f884-4749-83b7-d8018d86b3ad",
    label: "Gobra 08.05.46-16.02.58",
  },
  {
    fileStoreId: "60b05dd8-e56a-4640-b608-af967ae8c21f",
    label: "Gobra 10.01.1926-30.07.1928",
  },
  {
    fileStoreId: "ffc2c33b-73bf-4c1f-b6d3-e4f1b06b4d3f",
    label: "Gobra 15.03.1958-25.10.1980",
  },
  {
    fileStoreId: "64631ac1-7227-48ee-96e4-e1098743f7e1",
    label: "Gobra 16.03.1934-27.04.1946",
  },
  {
    fileStoreId: "c324bf8f-3232-4c5c-9284-faafda371bb8",
    label: "Gobra 21.02.1973-31.12.1987",
  },
  {
    fileStoreId: "5f8dcdb4-1d96-422d-9ae1-380f79723080",
    label: "Gobra 29.11.1980-22.02.1983",
  },
  {
    fileStoreId: "ed6f97e8-49d8-44ff-be8e-ec7fbd1f2bff",
    label: "Gobra 30.01.1966-09.11.1982",
  },
  {
    fileStoreId: "28574b27-9476-4736-8f73-c35d106296f1",
    label: "GORE GARIBAN, 21.10.79-23.06.83",
  },
];

export const HomeLeftMenuList = [
  { type: "link", to: "/KMC_Department", label: "KMC_Departments" },
  { type: "link", to: "/MunicipalHistory", label: "Municipal History" },

  { type: "link", to: "/Contact_Us_Home", label: "KMC Contacts" },

  { type: "link", to: "/Dashboard", label: "EODB_Dashboard_Online_Services" },
  {
    type: "anchor",
    href: `${prodURL}/citizen/withoutAuth/online-payment`,
    label: "Property Tax Quick Pay",
  },
  {
    type: "anchor",
    href: `${mainURL}/KMCPortal/KMCPortalLicensePaymentAction.do`,
    label: "CE (Licence) Pay",
  },

  {
    type: "anchor",
    href: `${mainURL}/citizen/withoutAuth/license-payment?screenType=swm`,
    label: "SWM Pay",
  },
  {
    type: "anchor",
    href: `${mainURL}/KMCPortal/jsp/EncumbranceCertificate.jsp`,
    label: "Encumbrance Certificate",
  },

  { type: "link", to: "/About_Kolkata", label: "About_Kolkata" },

  { type: "link", to: "/Citizen_charter_Home", label: "Citizen Charter" },

  {
    type: "filestore",
    fileStoreId: "b534700d-b98e-4687-bccd-2a9a25863384",
    label: "Tender Form Format",
  },

  {
    type: "anchor",
    href: `${prodURL}/tender-details/tenderbarta`,
    label: "Tender Barta",
  },

  { type: "link", to: "/Auction", label: "eAuction" },

  {
    type: "anchor",
    href: `${prodURL}/employee/language-selection`,
    label: "Employee Dashboard",
  },
  {
    type: "anchor",
    href: `${prodURL}/commonhearing/`,
    label: "Hearing / Case Search",
  },

  {
    type: "anchor",
    href: `${prodURL}/tender-details/workdiaryReport`,
    label: "Building Work Diary Report",
  },

  {
    type: "collapse",
    id: "procurement",
    label: "Procurement Digital Library(Tender & Work Order Details)",
    children: [
      {
        type: "anchor",
        href: `${prodURL}/employee/language-selection`,
        label: "Employee",
      },
      {
        type: "anchor",
        href: `${prodURL}/tender-details/`,
        label: "Citizen",
      },
    ],
  },

  { type: "link", to: "/DownloadableForms", label: "Downloadable_Forms" },
  {
    type: "collapse",
    id: "demo2",
    label: "Statutory Forms",
    children: [
      {
        type: "filestore",
        fileStoreId: "f54f4b8a-40d9-4242-bb8f-81c7675300bc",
        label: "HVC-NCSK/2026",
      },
    ],
  },
  { type: "link", to: "/E_News_Letter", label: "Publications" },
  {
    type: "collapse",
    id: "demo",
    label: "Project",
    children: [
      { type: "link", to: "/CBP_Home", label: "1. CBP" },
      { type: "link", to: "/Mpnld", label: "2. MPLAD / BEUP" },
    ],
  },
  {
    type: "collapse",
    id: "notification",
    label: "HR System",
    children: [
      {
        type: "filestore",
        fileStoreId: "063f9d96-5752-425b-b1a2-38fa823a80a5",
        label: "Notification",
      },
      {
        type: "link",
        to: "/OfficeOrderCircular",
        label: "Office Order/Circular",
      },
    ],
  },

  {
    type: "collapse",
    id: "Sexual_Harassment_Redressal_Cell",
    label: "Sexual_Harassment_Redressal_Cell",
    children: SexualHarassmentRedressalCellSubMEnuList.map((item) => ({
      type: "filestore",
      fileStoreId: item.fileStoreId,
      label: item.label,
    })),
  },

  { type: "redirect", label: "ROW Login" },
  { type: "link", to: "/Procedure", label: "Grievance_Redressal" },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Grievance KMC 2.0",
  },
  {
    type: "link",
    to: "/KMC_Recruitments",
    label: "Recruitment / Result/Training",
  },
  {
    type: "anchor",
    href: `${prodURL}/tender-details/circularnotices`,
    label: "Circular & MIC Resolution",
    target: "_blank",
  },
  { type: "anchor", href: `${prodURL}/rti/`, label: "RTI", target: "_blank" },
  {
    type: "collapse",
    id: "document",
    label: "Document Authentication",
    children: [
      // { type: "link", to: "", label: "Assessment PD/FS" },
      { type: "redirect", label: "Assessment PD/FS" },
      { type: "redirect", label: "Assessment LOI" },
      { type: "redirect", label: "Assessment Suspense" },
      {
        type: "anchor",
        href: `${mainURL}/citizen/withoutAuth/license-payment?screenType=main`,
        label: "License(CE)",
        target: "_blank",
      },
      { type: "redirect", label: "Building" },
      { type: "redirect", label: "Birth Certificate" },
      { type: "redirect", label: "Death Certificate" },
    ],
  },
  {
    type: "collapse",
    id: "COMPENDIUM",
    label: "COMPENDIUM OF IMPORTANT DEPARTMENTAL CIRCULARS / ORDERS",
    children: COMPENDIUMSubMEnuList.map((item) => ({
      type: "filestore",
      fileStoreId: item.fileStoreId,
      label: item.label,
    })),
  },
  {
    type: "filestore",
    fileStoreId: "19250074-7075-4a48-add0-62b8226e8d19",
    label: "West Bengal Right to Public Service Act,2013",
  },
  {
    type: "filestore",
    fileStoreId: "b70563a0-1496-49cf-b607-6cbf8e5ce2d7",
    label: "Guidelines of Section 199(2) of KMC Act,1980 (as amended in 2019)",
  },
];

export const AdvertisementLeftMenuList = [
  {
    type: "link",
    label: "Advertisement Home",
    to: "/KMC_Advertisement",
  },
  {
    type: "collapse",
    id: "demo",
    label: "Online Application",
    children: [
      { type: "redirect", label: "1. Online Advertisement Application" },
      { type: "redirect", label: "2. Online Advertisement Renew Application" },
      {
        type: "redirect",
        label: "3. Online Advertisement Terminate Application",
      },
      { type: "redirect", label: "4. Online Advertisement Application Status" },
      {
        type: "redirect",
        label: "5. Online Advertisement Application Demand Print",
      },
      {
        type: "redirect",
        label: "6. Online Advertisement Application Demand Pay",
      },
      {
        type: "redirect",
        label: "7. Online Advertisement Application NOC Print",
      },
    ],
  },
  {
    type: "collapse",
    id: "demo1",
    label: "Online Declaration",
    children: [
      {
        type: "redirect",
        label: "1. Online Advertisement Declaration",
      },
      {
        type: "redirect",
        label: "2. Online Declaration Status",
      },
    ],
  },
  {
    type: "filestore",
    fileStoreId: "6acafd38-8f31-4452-8e42-868f55b0257c",
    label: "Rates",
  },
  {
    tyep: "redirect",
    label: "Know Your Agent Code",
  },
  {
    type: "link",
    label: "Download Forms",
    to: "/Advertisement_download_forms",
  },
  { type: "redirect", label: "Check Demands Payable" },
  { type: "redirect", label: "Print Unpaid Bill" },
  { type: "redirect", label: "Make Online Payment" },
  { type: "redirect", label: "Reprint e-Receipt" },
  { type: "redirect", label: "Advertisement Tax Calculator" },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
  },
  { type: "redirect", label: "List of Hoardings" },
  {
    type: "filestore",
    fileStoreId: "ce1fea6b-e2ff-4ef5-b30a-69c92446ff35",
    label: "EMPANELEMENT OF ADVERTISING AGENCIES",
  },
  {
    type: "collapse",
    id: "demo2",
    label: "Notice Section",
    children: [
      {
        type: "filestore",
        fileStoreId: "8be9e53e-fcc9-4fe5-ad0d-e33553b022d4",
        label: "1. Notice 1",
      },
      {
        type: "filestore",
        fileStoreId: "83f04710-a68b-4c4e-a14d-9cb50596b5e6",
        label: "2. Notice 2",
      },
      {
        type: "filestore",
        fileStoreId: "12326f2f-2733-45ee-9ae3-0405a31b55b3",
        label: "3. Notice 3",
      },
    ],
  },
  {
    type: "filestore",
    fileStoreId: "b4a56c30-9280-4378-8e8d-16cc96787141",
    label: "NOTIFICATION for fixing up QR codes on advertisements",
  },
  {
    type: "filestore",
    fileStoreId: "30dac2a7-4765-4939-b14d-21908b225510",
    label: "Advertisement Policy",
  },
];

export const CarParkingLeftMenuList = [
  {
    type: "link",
    to: "/Car_Parking_Home",
    label: "Car Parking Home",
  },
  {
    type: "filestore",
    fileStoreId: "3938dc3f-f5c2-4ce9-b811-f7685649a8d0",
    label: "Rate Chart",
  },
  {
    type: "collapse",
    id: "demo",
    label: "Notice",
    children: [
      {
        type: "filestore",
        fileStoreId: "18019226-2a59-4f3c-8a94-891f18042026",
        label: "1. Notice 1",
      },
      {
        type: "filestore",
        fileStoreId: "cd12db74-3590-4e55-9d4b-ada57bd294a8",
        label: "2. Notice 2",
      },
    ],
  },
  {
    type: "anchor",
    href: `${prodURL}/location-details/`,
    label: "List of Parking Lots",
  },
  { type: "redirect", label: "Check Demands Payable" },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Online Services",
  },
  { type: "link", to: "/Car_Parking_FAQ", label: "FAQs" },
  {
    type: "filestore",
    fileStoreId: "18019426-2a59-4f3c-8a94-891f18042026",
    label: "Taxi Parking in KMC's Free Parking Stretches (Yellow boarded area)",
  },
  {
    type: "filestore",
    fileStoreId: "18019526-2a59-4f3c-8a94-891f18042026",
    label: "Car Parking Policy",
  },
  {
    type: "filestore",
    fileStoreId: "02cb24e5-ea98-48f0-a553-7c38e0aecb4b",
    label: "Parking Tender Policy",
  },
  {
    type: "filestore",
    fileStoreId: "18019726-2a59-4f3c-8a94-891f18042026",
    label: "Proposed enhancement of fee car parking space in KMC area",
  },
  {
    type: "filestore",
    fileStoreId: "18019826-2a59-4f3c-8a94-891f18042026",
    label: "Phalpatty area & rates",
  },
  {
    type: "filestore",
    fileStoreId: "18020126-2a59-4f3c-8a94-891f18042026",
    label: "Usage of Mobile apps (Bandhu)",
  },
  {
    type: "filestore",
    fileStoreId: "18020226-2a59-4f3c-8a94-891f18042026",
    label: "Proposed enhancement of night fee car parking spaces in KMC area",
  },
  {
    type: "filestore",
    fileStoreId: "db302c96-8f67-4e3e-ac6d-584b17eced35",
    label: "List of Defaulters",
  },
  {
    type: "filestore",
    fileStoreId: "18019126-2a59-4f3c-8a94-891f18042026",
    label: "List of Defaulters up to 31-10-2023",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
  },
];

export const AmusmentLeftMenuList = [
  { type: "link", to: "/Amusement", label: "Amusement Home" },
  {
    type: "filestore",
    fileStoreId: "b2d63823-3aa5-4c06-9771-688e82be21a8",
    label: "Amusement Fees",
  },
  { type: "link", to: "/Amusement_download_forms", label: "Download Forms" },
  {
    type: "redirect",
    label: "Application for Annual Amusement Permission",
  },
  {
    type: "redirect",
    label: "Application for Casual Amusement Permission",
  },
  {
    type: "redirect",
    label: "Application for Closure of Annual Amusement Permission",
  },
  {
    type: "redirect",
    label: "My Application Status",
  },
  {
    type: "filestore",
    fileStoreId: "98a9d62c-0b46-4fc8-a00b-a797c09a3720",
    label: "Help For Online Application of Amusement Fees",
  },
  {
    type: "anchor",
    href: `${mainURL}/amusement/unpaidDemand`,
    label: "Check Demands Payable",
  },
  {
    type: "anchor",
    href: `${mainURL}/amusement/unpaidDemand`,
    label: "Print Unpaid Bill",
  },
  {
    type: "redirect",
    label: "Make Online Payment",
  },
  {
    type: "anchor",
    href: `${mainURL}/amusement/printEReceipts`,
    label: "Reprint e-Receipt",
  },
  {
    type: "filestore",
    fileStoreId: "18015826-2a59-4f3c-8a94-891f18042026",
    label: "Notice",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact",
  },
];

export const BuildingCircularSiteMenuList = [
  {
    type: "link",
    to: "/Building_Sanction_Circular_2022_23",
    label: "DG(BLDG)'s Circular No.of 2022-23",
  },
  {
    type: "link",
    to: "/Building_Sanction_Circular_2021_22",
    label: "DG(BLDG)'s Circular No.of 2021-22",
  },
  {
    type: "link",
    to: "/Building_Sanction_Circular_2020_21",
    label: "DG(BLDG)'s Circular No.of 2020-21",
  },
  {
    type: "link",
    to: "/Building_Sanction_Circular_2019_20",
    label: "DG(BLDG)'s Circular No.of 2019-20",
  },
  {
    type: "link",
    to: "/Building_Sanction_Circular_2017_18",
    label: "DG(BLDG)'s Circular No.of 2017-18",
  },
  {
    type: "link",
    to: "/Building_Sanction_Circular_2016_17",
    label: "DG(BLDG)'s Circular No.of 2016-17",
  },
  {
    type: "link",
    to: "/Building_Sanction_Circular_2015_16",
    label: "DG(BLDG)'s Circular No.of 2015-16",
  },
  {
    type: "link",
    to: "/Building_Sanction_Circular_2014_15",
    label: "DG(BLDG)'s Circular No.of 2014-15",
  },
  {
    type: "link",
    to: "/Building_Sanction_Circular_2013_14",
    label: "DG(BLDG)'s Circular No.of 2013-14",
  },
  {
    type: "link",
    to: "/Building_Sanction_Circular_2011_12",
    label: "DG(BLDG)'s Circular No.of 2011-12",
  },
  {
    type: "link",
    to: "/Building_Sanction_Circular_2010_11",
    label: "DG(BLDG)'s Circular No.of 2010-11",
  },
];

export const BuildingOfficeOrderSiteMenuList = [
  {
    type: "link",
    to: "/Officer_Order",
    label: "DG(BLDG)'s Office Orde No.of 2021-22",
  },
  {
    type: "link",
    to: "/Building_OfficeOreder_2020",
    label: "DG(BLDG)'s Office Orde No.of 2020-21",
  },
  {
    type: "link",
    to: "/Building_OfficeOreder_2019",
    label: "DG(BLDG)'s Office Orde No.of 2019-20",
  },
  {
    type: "link",
    to: "/Building_OfficeOreder_2018",
    label: "DG(BLDG)'s Office Orde No.of 2018-19",
  },
  {
    type: "link",
    to: "/Building_OfficeOreder_2017",
    label: "DG(BLDG)'s Office Orde No.of 2017-18",
  },
  {
    type: "link",
    to: "/Building_OfficeOreder_2016",
    label: "DG(BLDG)'s Office Orde No.of 2016-17",
  },
  {
    type: "link",
    to: "/Building_OfficeOreder_2015",
    label: "DG(BLDG)'s Office Orde No.of 2015-16",
  },
  {
    type: "link",
    to: "/Building_OfficeOreder_2014",
    label: "DG(BLDG)'s Office Orde No.of 2014-15",
  },
  {
    type: "link",
    to: "/Building_OfficeOreder_2013",
    label: "DG(BLDG)'s Office Orde No.of 2013-14",
  },
  {
    type: "link",
    to: "/Building_OfficeOreder_2012",
    label: "DG(BLDG)'s Office Orde No.of 2012-13",
  },
  {
    type: "link",
    to: "/Building_OfficeOreder_2011",
    label: "DG(BLDG)'s Office Orde No.of 2011-12",
  },
  {
    type: "link",
    to: "/Building_OfficeOreder_2010",
    label: "DG(BLDG)'s Office Orde No.of 2010-11",
  },
];

export const SWMLeftMenuList = [
  { type: "link", to: "/Solid_wastes_home", label: "Solid Wastes Home" },
  {
    type: "filestore",
    fileStoreId: "0eaf87c8-c217-4e4f-b43f-7794dfcc7a53",
    label: "Schedule of Fees",
  },
  { type: "redirect", label: "Print Unpaid Demand" },

  {
    type: "anchor",
    href: `${mainURL}/swm/CEDemandDetailsReport`,
    label: "View All Demand",
  },

  {
    type: "anchor",
    href: `${mainURL}/citizen/withoutAuth/license-payment?screenType=swm`,
    label: "Make Online Payment",
  },
  {
    type: "anchor",
    href: `${mainURL}/swm/printEReceipts`,
    label: "Reprint e-Receipt",
  },
  {
    type: "redirect",
    label: "CD Waste Application for Repair/Renovation/Demolition of Building",
  },
  { type: "redirect", label: "Print CD Waste Unpaid Demand" },
  { type: "redirect", label: "Make CD Waste Payment" },

  { type: "redirect", label: "CD Waste Reprint e-Receipt" },
  { type: "link", to: "/Solid_waste_management_faqs", label: "FAQs" },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
  },
  {
    type: "filestore",
    fileStoreId: "18023526-2a59-4f3c-8a94-891f18042026",
    label: "Status Report SWM Feb 2019",
  },
  {
    type: "filestore",
    fileStoreId: "18023626-2a59-4f3c-8a94-891f18042026",
    label: "Gazette notification for KMC SWM Bye Laws 2020",
  },
];

export const WaterSupplyLeftNavsList = [
  { type: "link", to: "/Water_Supply", label: "Water Supply Home" },
  {
    type: "filestore",
    fileStoreId: "4a8e7847-1d6e-4290-ae7d-9d56c2a93bb8",
    label:
      "Water Supply Booster Pumping Station - JHJP IGWTP GRWW Command zone as on June 2025",
  },
  {
    type: "filestore",
    fileStoreId: "d3b7ea23-aa2f-4914-bb36-ffcc9ae58823",
    label: "Drainage Pumping Station List As on June 2025",
  },
  {
    type: "anchor",
    href: "https://www.kmcgov.in/KMCPortal/jsp/WaterSupplyNetworkMap.jsp",
    target: "_blank",
    label: "Ward wise Water Supply Network Map",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Find Plumbers",
  },
  { type: "link", to: "/Download_Forms", label: "Download Forms" },
  {
    type: "filestore",
    fileStoreId: "c6ae07cc-0711-4cca-9280-7536c2b10769",
    label: "Fees and Charges",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Check Demands Payable",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Print Unpaid Bill",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Make Online Payment",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Reprint e-Receipt",
  },
  { type: "link", to: "/Water_Supply_Faqs", label: "FAQs" },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
  },
  {
    type: "link",
    to: "/Water_For_Fire_Fighter",
    label: "Water For Fire Fighters",
  },
  {
    type: "filestore",
    fileStoreId: "e39509c8-2fd1-4c9e-b92f-c6171819f1ba",
    label: "Action Plan to reduce water losses to less than 20%",
  },
];

export const ProjectCBPLeftManuList = [
  { type: "link", to: "/CBP_Home", label: "CBP Home" },
  { type: "link", to: "/Vision_Strategy", label: "Vision And Strategy" },
  { type: "link", to: "/Project_Faqs", label: "FAQs" },
];

export const OverviewLeftMenuList = [
  { type: "link", to: "/Overview", label: "Overview" },
  { type: "link", to: "/Power", label: "Power" },
  { type: "link", to: "/Functions", label: "Functions" },
  { type: "link", to: "/Revenue", label: "Revenue" },
  { type: "link", to: "/Adminstration", label: "Administration" },
];

export const MarketLeftNavsList = [
  { type: "link", to: "/KMC_market_list", label: "List of KMC Markets" },
  // {
  //   type: "link",
  //   to: "/Download_market_fire_fighting_video",
  //   label: "Download Market Fire-Fighting Video",
  // },
  { type: "redirect", label: "College Street Market" },
  {
    type: "filestore",
    fileStoreId: "24933b3f-9f33-40b0-ba45-5b2d083f6db2",
    label: "Rates & Charges",
  },
  // { type: "redirect", label: "Check Demands Payable" },
  {
    type: "collapse",
    id: "demo1",
    label: "Print Unpaid Bill",
    children: [
      { type: "redirect", label: "Regular Demand" },
      { type: "redirect", label: "Miscellaneous Demand" },
    ],
  },
  {
    type: "collapse",
    id: "demo2",
    label: "Make Online Payment",
    children: [
      { type: "redirect", label: "Regular Demand" },
      { type: "redirect", label: "Miscellaneous Demand" },
    ],
  },
  {
    type: "collapse",
    id: "demo3",
    label: "Reprint e-receipt",
    children: [
      { type: "redirect", label: "Regular Demand" },
      { type: "redirect", label: "Miscellaneous Demand" },
    ],
  },
  {
    type: "filestore",
    fileStoreId: "18022726-2a59-4f3c-8a94-891f18042026",
    label: "Don't be cheated into the market",
  },
  {
    type: "filestore",
    fileStoreId: "1d06a9ea-8bf9-4d8f-a803-c124c2de5eb8",
    label: "This is for you, kindly read this",
  },
  {
    type: "link",
    to: "/Maps_of_market",
    label:
      "Maps of deep tubewells situated in the market area for fire fighting",
  },
  { type: "link", to: "/Tender", label: "Tender" },
  {
    type: "filestore",
    fileStoreId: "18022826-2a59-4f3c-8a94-891f18042026",
    label: "KMC Market Stall Details",
  },
  { type: "redirect", label: "KMC Market Stall Search" },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    target: "_blank",
    label: "Contact Details",
  },
  {
    type: "link",
    to: "/Water_For_Fire_Fighter",
    label: "Water For Fire Fighters",
  },
  {
    type: "filestore",
    fileStoreId: "5fefe794-59b5-4052-9b41-eb30ce10ec35",
    label: "Notice regarding Demolition of Stalls in Marcus Square",
  },
];

export const BuildingLeftMenuList = [

  {
    type: "link",
    to: "/Guest_House_Notice",
    label: "GUEST HOUSE CLOSURE NOTICE",
  },

  {
    type: "anchor",
    href: `https://www.kmcgov.in/KMCPortal/jsp/KMCBuildingNOCGoAhead.jsp`,
    target: "_blank",
    label: "N.O.C / GO AHEAD ORDERS OF BUILDING DEPT. KMC",
  },

  {
    type: "link",
    to: "/Building_Sanction_Building_Home",
    label: "Building Home",
  },
  {
    type: "link",
    to: "/Dashboard2",
    label: "EODB Dashboard For Building Permit",
  },
  {
    type: "link",
    to: "/Building_Sanction_Circular_2022_23",
    label: "Circular",
  },
  // {
  //   type: "filestore",
  //   fileStoreId: "ec26e7d9-657a-40d3-8f39-86186945af7a",
  //   label: "Building Demand Notice",
  // },
  {
    type: "link",
    to: "/Building_Sanction_Floor_Area_Ratio",
    label: "Floor Area Ratio",
  },
  {
    type: "link",
    to: "/Building_Sanction_Ground_Covergae",
    label: "Ground Coverage",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    target: "_blank",
    label: "Borough Offices",
  },
  // {
  //   type: "link",
  //   to: "/Building_Sanction_Borough_Offices",
  //   label: "Borough Offices",
  // },
  {
    type: "filestore",
    fileStoreId: "879a4e97-73a3-4943-a963-ed288d49d6c5",
    label: "Fees and Charges",
  },
  { type: "redirect", label: "Generate QR Code" },
  { type: "redirect", label: "Find LBS" },
  { type: "redirect", label: "Find ESE" },
  { type: "redirect", label: "Find GTE" },
  { type: "redirect", label: "Find ESR" },
  { type: "redirect", label: "Check Hearing Notice" },
  {
    type: "link",
    to: "/Building_Sanction_Download_Forms",
    label: "Download Forms",
  },
  { type: "redirect", label: "Building Plan Proposal Status" },
  { type: "redirect", label: "Check Demands Payable" },
  { type: "redirect", label: "Print Unpaid Bill" },
  { type: "redirect", label: "Make Online Payment" },
  { type: "redirect", label: "Reprint e-Receipt" },
  {
    type: "filestore",
    fileStoreId: "917cb890-c7c1-4a81-a275-0fc5a57c1ce1",
    label: "Instruction Set for Online Submission of Building Plan",
  },
  // { type: "redirect", label: "Online Submission of Building Plan" },
  {
    type: "filestore",
    fileStoreId: "d70d51bf-90e2-4d26-882c-70258cec8693",
    label: "Online CC Circular",
  },
  {
    type: "link",
    to: "/Building_Sanction_Important_EODB_circulars",
    label: "Important EODB Circulars",
  },
  {
    type: "filestore",
    fileStoreId: "e19680d9-9cc1-40a8-bce9-36b2118e0036",
    label:
      "Instruction set for Online Notice of Commencement and Notice of Completion Certificate",
  },
  { type: "redirect", label: "Online Notice of Commencement/CC" },
  {
    type: "filestore",
    fileStoreId: "dd5f504a-f611-4974-a65c-43708333e928",
    label:
      "MC Circular No.44 of 2021-22 Regarding Assessment Data at the time of CC",
  },
  {
    type: "filestore",
    fileStoreId: "8039182a-051b-40c6-9df8-012df3fcfd7d",
    label: "Download Standard(.xls) format for MC Circular No.44 of 2021-22",
  },
  // {
  //   type: "anchor",
  //   href: "https://docs.google.com/forms/d/e/1FAIpQLSfmcCELn86TXflHLGQo4ZbhOiGhbN93TTmulOf15G7O5rVIpw/closedform",
  //   target: "_blank",
  //   label: "Architect Enlistment and Renewal",
  // },
  { type: "redirect", label: "License Renewal for Technical Personnel" },
  {
    type: "filestore",
    fileStoreId: "ed505735-b6c9-47b0-bdea-89e130694166",
    label: "Instruction set for Online Licence Renewal For Technical Personnel",
  },
  {
    type: "filestore",
    fileStoreId: "325b60c1-81e2-410c-8f29-2bf488144968",
    label:
      "Instruction Set for preparation of AutoCAD Drawing for Online Submission",
  },
  { type: "redirect", label: "Sanctioned Plan Search" },
  { type: "redirect", label: "Completion Certificate Search" },
  { type: "redirect", label: "Unauthorised Case Search" },
  { type: "link", to: "/Building_Faqs", label: "FAQs" },
  { type: "link", to: "/Officer_Order", label: "Office Order" },
  { type: "link", to: "/Building_Sanction_Communique", label: "Communique" },
  {
    type: "filestore",
    fileStoreId: "743e7dfd-7c5c-48da-89c6-3dc4912db451",
    label: "DGBuilding Circular No 9(2013-2014)",
  },
  {
    type: "filestore",
    fileStoreId: "bafe4794-5adb-420b-9060-cebfc317bd4e",
    label: "Empanelment of Geo-Technical",
  },
  {
    type: "filestore",
    fileStoreId: "f22e8538-023c-44c0-a5c8-019779a27778",
    label:
      "West Bengal Act XIX of 2014 & The Kolkata Municipal Corporation(Amendment)Act,2014",
  },
  {
    type: "filestore",
    fileStoreId: "11ac9060-7106-44b8-ba47-f17816938ed4",
    label: "Check list for Sanction of Building Plan",
  },
  {
    type: "filestore",
    fileStoreId: "b0179de7-3e25-4241-9fb7-db202548e82a",
    label: "Building Rules 2009 including amendment",
  },
  {
    type: "anchor",
    href: "https://nocas2.aai.aero/nocas/",
    target: "_blank",
    label: "Airport Building Height Clearance",
  },
  {
    type: "filestore",
    fileStoreId: "b1397811-eb8f-471d-aa4a-97a511636523",
    label:
      "Applications are invited from the Civil Engineers of Empanelment of Geo-Technical Engineers",
  },
  {
    type: "filestore",
    fileStoreId: "5ee3d89e-4564-4c7d-bf28-b24e93904294",
    label: "3rd Amendment of KMC Building Rules 2009 Geo Tech and Road width",
  },
  {
    type: "filestore",
    fileStoreId: "6a872e1b-696a-4b28-8b88-7734e07fbec5",
    label:
      "Communique(The Amendment of Building Rules,2009 video notification No 80/MA/O/C-4/3R-7/2017)",
  },
  {
    type: "filestore",
    fileStoreId: "b9b1da9a-77f7-4382-90c4-5f808ba9996e",
    label:
      "Distribution of guideline among Building-owners/Constituted Attorney in different wards of KMC for prevention of mosquito breeding at construction sites on an urgent basis",
  },
  {
    type: "filestore",
    fileStoreId: "ea9fb4b5-6888-446b-8c2b-cfb46c2ca624",
    label: "Notification No 445/MA/O/C-4/3R-3/2014",
  },
  {
    type: "filestore",
    fileStoreId: "4c97c5a6-7cce-4364-8cd3-fc5a1fd9f2b3",
    label: "Building Notice",
  },
  { type: "redirect", label: "LBS/CA/ESE/GTE/ESR WISE SANCTION SEARCH" },
  {
    type: "anchor",
    href: "assets/Notice_LBS_Architect_03_09_2019.rar",
    target: "_blank",
    label: "Notice for LBS/Architect",
  },
  {
    type: "filestore",
    fileStoreId: "6d51514c-94df-4979-8f92-215bc6100f0c",
    label: "EODB Proforma For Appointment of Technical Person",
  },
  {
    type: "filestore",
    fileStoreId: "96e6d088-aab0-4603-aa1a-99e2adb1574d",
    label: "EODB Standard Reasons Of Rejection",
  },
  {
    type: "filestore",
    fileStoreId: "aeddf9b0-2721-45f8-93f8-0a182416ad07",
    label: "EODB IGR Non-insisting of KMCEODB Standard Reasons Of Rejection",
  },
  {
    type: "filestore",
    fileStoreId: "18bfcecc-d3f7-4d9e-8031-6d7744bbc859",
    label: "EODB Workflow",
  },
  {
    type: "filestore",
    fileStoreId: "734238c5-284b-4c01-b4ac-975a580567fd",
    label: "FAQ for EODB",
  },
  {
    type: "filestore",
    fileStoreId: "85999c9c-16ec-4f0a-a9b1-e585c132cc50",
    label: "User Manual for EODB",
  },
  {
    type: "filestore",
    fileStoreId: "e1be8b3a-01ed-4be0-86c7-ce3001413cbd",
    label:
      "Public Notice -- Pollutions at Construction SiteUser Manual for EODB",
  },
  {
    type: "filestore",
    fileStoreId: "0f4c1d7f-7ebf-4b7e-bc4a-9aef639d91dc",
    label:
      "Circulation of Administrative order for regulating sanction of building plan/construction",
  },
  {
    type: "filestore",
    fileStoreId: "7345ba30-6d90-4acc-a340-64ffd30e9eca",
    label: "List of Enemy Properties",
  },
  {
    type: "filestore",
    fileStoreId: "ff8c508b-3880-4c2e-8d0d-12a823227d3d",
    label:
      "Guidelines on Specific Precautionary Measures to Be Taken by Owner/Builder/Lessee During Demolition of Existing Building in a Congested Residential Area",
  },
  {
    type: "filestore",
    fileStoreId: "e429daa0-4dd9-425a-906b-d5a4967b0dc2",
    label: "Empanelment of Valuer",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    target: "_blank",
    label: "Contact Details",
  },
];
export const AssessmentCollectionLeftMenuList = [
  {
    type: "link",
    to: "/Assessment_Collection_Assessment_Home",
    label: "Assessment Home",
  },
  {
    type: "link",
    to: "/Assessment_collection_Process_Muation",
    label: "Process of Mutation",
    active: true,
  },
  {
    type: "link",
    to: "/Assessment_Collection_Unit_Area_Assessment",
    label: "Unit Area Assessment",
  },
  {
    type: "filestore",
    fileStoreId: "05fa2075-e0c5-4d32-b035-df381d6820a7",
    label: "Tax Rates / Fees",
  },
  {
    type: "link",
    to: "/Assessment_collection_download_forms",
    label: "Download Forms",
  },
  {
    type: "link",
    to: "/Assessment_collection_Message_Board",
    label: "Message Board",
  },
  // {
  //   type: "link",
  //   to: "/Assessment_collection_Notice",
  //   label: "Notice",
  // },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Assessment Online Services",
  },
];

export const UttaranServicesLeftMenuList = [
  {
    type: "link",
    to: "/KMC_Bustee_services",
    label: "Uttaran Services",
    active: true,
  },
  { type: "link", to: "/BSUP", label: "BSUP" },
  {
    type: "filestore",
    fileStoreId: "15e952e9-366e-416d-942b-c158b2b55793",
    label: "Result of Lottery held at Nonadanga",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Check Demands Payable",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Print Unpaid Bill",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Make Online Payment",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Reprint e-Receipt",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact",
  },
];

export const CentralRecordsLeftMenuList = [
  {
    type: "link",
    to: "/KMC_Central_records_Home",
    label: "Central Records Home",
    active: true,
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Central Records Apllication",
  },

  // { type: "redirect", label: "Central Records Apllication" },

  {
    type: "filestore",
    fileStoreId: "271d2693-dd0b-48c4-9541-22f52bcf39f4",
    label: "Fees",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Central Records Online Application Entry",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Online Payment",
  },

];

export const EducationLeftMenuList = [
  {
    type: "link",
    to: "/Kmc_school_home",
    label: "KMC Schools Home",
    active: true,
  },
  { type: "link", to: "/List_of_school", label: "List Of Schools" },
  { type: "link", to: "/Urgent_Notice", label: "Urgent Notice" },
  { type: "link", to: "/KMC_School_Faq", label: "FAQs" },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
  },
];
export const ComputerAidedLearningLinks = [
  {
    label:
      "Result of Evaluation of presentations given by bidders : Computer-aided Learning",
    fileStoreId: "3daf042f-08b0-4067-8068-bb8c07d84a64",
  },
  {
    label:
      "Result of Evaluation of Technical Bids : Computer-aided Learning at KMC Primary Schools",
    fileStoreId: "f078ed85-9586-4b0c-ad17-fa136917517c",
  },
  {
    label: "Further Clarifications : Computer Aided Learning",
    fileStoreId: "1f0351f2-8c84-4e66-9df3-7c1d19fe1626",
  },
  {
    label: "Response to Queries : Computer Aided Learning",
    fileStoreId: "c08e7d96-d07c-4bae-a854-5c456a53a134",
  },
  {
    label: "Invitation of EoI for Computer Aided Learning",
    fileStoreId: "aa549008-bf35-4283-b369-7d438d26a7bd",
  },
];
export const ListOfSchoolOfEducationList = [
  {
    fileStoreId: "782cb570-4c52-46d6-8318-14d477bcef1d",
    label: "I",
  },
  {
    fileStoreId: "f4b120cc-1e29-46eb-83f8-6db029ec1b81",
    label: "II",
  },
  {
    fileStoreId: "e226901d-6adf-47ee-895b-011c0da99393",
    label: "III",
  },
  {
    fileStoreId: "efcdd360-ffd8-4f44-818b-010944d30f13",
    label: "IV",
  },
  {
    fileStoreId: "05aa40f7-cbe7-4401-94cd-26da8f31d547",
    label: "V",
  },
  {
    fileStoreId: "1140f8f5-31c3-4cc8-b3b0-f5fdbab3bbe4",
    label: "VI",
  },
  {
    fileStoreId: "3ca8b2d0-acd5-47d5-9b78-17b4b1140ebf",
    label: "VII",
  },
  {
    fileStoreId: "644a3897-746f-4142-a36d-0e04d3c07f9c",
    label: "VIII",
  },
  {
    fileStoreId: "d7756482-214d-4078-a259-f45b7d8f4543",
    label: "IX",
  },
  {
    fileStoreId: "f5dcf06b-5d88-46a3-a735-883a30cd6dc7",
    label: "X",
  },
  {
    fileStoreId: "c00e9985-bb4e-44fd-8492-b6388d336cd1",
    label: "XI",
  },
  {
    fileStoreId: "d2044d6a-7290-446d-a375-5384942ddd7e",
    label: "XII",
  },
  {
    fileStoreId: "0b4f3ac4-4d7d-450f-bcc3-86a358016f66",
    label: "XIII",
  },
  {
    fileStoreId: "5b9593d6-f545-4c18-9b04-e29ae7e450ab",
    label: "XIV",
  },
  {
    fileStoreId: "0dfda655-5f2f-4b24-8e7f-306fa69dfe23",
    label: "XV",
  },
  {
    fileStoreId: "fa572d32-8f52-4a18-8530-66cfe275c2b2",
    label: "XVI",
  },
];
export const CHVSDeptLeftMenuList = [
  {
    type: "link",
    to: "/CH_VS_Dept_Download_Forms",
    label: "Download Forms",
    active: true,
  },
  {
    type: "filestore",
    fileStoreId: "6cb33d38-2036-4cca-a573-9af1bc7a1f5b",
    label: "Rates & Charges",
  },
  { type: "redirect", label: "Online Smart Map" },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Make Online Payment",
    target: "_blank",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
    target: "_blank",
  },
  {
    type: "filestore",
    fileStoreId: "18022426-2a59-4f3c-8a94-891f18042026",
    label: "Public Notice Modification Cancellation of Alignment",
  },
];

export const EnvironmentHeritageLeftMenuList = [
  {
    type: "link",
    to: "/HeritageBuildingHome",
    label: "Heritage Home",
    activePaths: [
      "/HeritageBuildingHome",
      "/HeritageBuildingHome2",
      "/HeritageBuildingHome3",
      "/HeritageBuildingHome4",
    ],
  },
  { type: "link", to: "/Heritage_Exemption_of_Tax", label: "Exemption of Tax" },
  {
    type: "link",
    to: "/Heritage_Heritage_Buildings",
    label: "Heritage Buildings",
  },
  {
    type: "link",
    to: "/Heritage_Conservation_Architect",
    label: "Conservation Architect",
  },
  {
    type: "filestore",
    fileStoreId: "7eb350f2-0c68-454a-ab33-ce5334cec125",
    label: "Composition of the Heritage Conservation Committee",
  },
  {
    type: "link",
    to: "/Heritage_Proceedings_of_HCC",
    label: "Proceedings of HCC",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/withoutAuth/pmu/search/download`,
    label: "Proceedings of HCC(New)",
  },
  {
    type: "filestore",
    fileStoreId: "f13351d7-e7ac-4c98-86d1-f8cb44592d2a",
    label: "Action Plan",
  },
  {
    type: "filestore",
    fileStoreId: "449dca47-c7fa-4ce8-8358-29df3c49c02a",
    label: "Parking Policy",
  },
  {
    type: "filestore",
    fileStoreId: "0ff9df4e-6a67-4cbe-84c9-15999895b035",
    label: "Measures for prevention of landfill fire",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/withoutAuth/pmu/pond-details/search`,
    label: "Ward wise Pond",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/withoutAuth/pmu/heritage-details/search`,
    label: "Ward Wise Heritage Building",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
  },
  {
    type: "filestore",
    fileStoreId: "18092726-2a59-4f3c-8a94-891f18042026",
    label: "Activities Permitted under NCAP",
  },
  {
    type: "collapse",
    id: "demo2",
    label: "Swachh Vayu Survekshan",
    children: [
      {
        type: "filestore",
        fileStoreId: "4b63609e-a3e0-4c35-9b73-ddf88bb11b28",
        label: "1. Self assessed scores & CPCB scores",
      },
      {
        type: "filestore",
        fileStoreId: "18092926-2a59-4f3c-8a94-891f18042026",
        label: "2. Self assessment reports of Kolkata city2023",
      },
      {
        type: "filestore",
        fileStoreId: "31a111f2-c956-4d5e-af38-3dadeeb50de2",
        label: "3. Swachh Vayu Survekshan 2023 Rank",
      },
      {
        type: "filestore",
        fileStoreId: "b3554452-fb91-4c33-9ea9-75165448535d",
        label: "4. Swachh Vayu Survekshan",
      },
    ],
  },
  {
    type: "anchor",
    href: "http://emis.wbpcb.gov.in/airquality/citizenreport.do",
    target: "_blank",
    label: "Air quality status",
  },
  {
    type: "anchor",
    href: "http://emis.wbpcb.gov.in/emis/category.do",
    target: "_blank",
    label: "Industry categorisation",
  },
  // {
  //   type: "filestore",
  //   fileStoreId: "18092826-2a59-4f3c-8a94-891f18042026",
  //   label: "FINAL District Environment plan KMC 2021",
  // },
  {
    type: "filestore",
    fileStoreId: "",
    label: "FINAL District Environment Plan KMC 2026",
  },
  {
    type: "filestore",
    fileStoreId: "",
    label: "FINAL District Environment Plan KMC 2025",
  },
  {
    type: "filestore",
    fileStoreId: "",
    label: "A report on Air Pollutant Standards, AQI and its colour coads, Public advisory and Location details for CAAQMS",
  },

];

export const EngineeringLeftMenuList = [
  { type: "link", to: "/Engineering_Home", label: "Engineering (Civil) Home" },
  {
    type: "filestore",
    fileStoreId: "b53e01f7-07c0-432d-b6f8-18e0231f70ad",
    label: "Rates & Charges",
  },
  { type: "redirect", label: "KMC Road Development Scheme" },
  // {
  //   type: "link",
  //   to: "/Engineering_Manhole_Desilting_Programme",
  //   label: "Manhole Desilting Programme of Borough-1 to XVI under Civil Dept",
  //   active: true,
  // },
  {
    type: "link",
    to: "/Engi_Man_Desil_Prog_civil_Bro_30_6_2024",
    label: "Manh Desi Prog of Bor-1 to XVI under Civil Dept 30-6-24",
  },
  {
    type: "filestore",
    fileStoreId: "85d8c4c9-dce6-4ef7-826f-29934d3b4519",
    label: "Tender Form Format",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
  },
];
export const LightingLeftMenuList = [
  { type: "link", to: "/Lighting_Home", label: "Lighting Home", active: true },
  {
    type: "filestore",
    fileStoreId: "a76cff4c-331a-41ba-9fe4-d484a0ea9a99",
    label: "Fees",
  },
  {
    type: "filestore",
    fileStoreId: "be404e89-ee4f-4156-aef0-4a176cc5823b",
    label: "Urban Beautification Decorative Ornamental Street Light",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
  },
];

export const ParksSquaresLeftMenuList = [
  {
    type: "link",
    to: "/Parks_and_gardens",
    label: "Parks & Squares Home",
    active: true,
  },
  { type: "link", to: "/Office_Order", label: "Office Order" },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Noc Tree Cutting",
    target: "_blank",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Park Booking Request",
    target: "_blank",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Print Receipt",
    target: "_blank",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
  },
];

export const SocialWelfareLeftMenuList = [
  {
    type: "link",
    to: "/Social_welfare_Download_Forms",
    label: "Download Forms",
    active: true,
  },
  {
    type: "link",
    to: "/Govt_Sponsored_Schemes",
    label: "Govt Sponsored Schemes",
  },

  // { type: "link", to: "/Ward_Wise_BPL_List", label: "BPL List" },

  {
    type: "link",
    to: "/Housing_Urban_Poor_Form_and_Site_Plan",
    label: "Housing Urban Poor Form and Site Plan",
  },
  { type: "link", to: "/GR_Recipients", label: "GR Recipients" },
  {
    type: "filestore",
    fileStoreId: "18023726-2a59-4f3c-8a94-891f18042026",
    label: "National Urban Livelihoods Mission",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
  },
];

export const Building_Sanction_Circular_2011_12_List = [
  {
    fileStoreId: "90807f85-5429-425a-b3e0-cf78c08c016b",
    label: "DG(BLDG)'s Circular No. 24 of 2011-12",
    date: "24/01/2012",
    subject:
      "Observation of survey and KIT for vertical extension under sec 3942",
  },
];
export const Building_Sanction_Circular_2010_11_List = [
  {
    fileStoreId: "39a64964-2d2a-4e85-94b7-e1b07f07f915",
    label: "DG(BLDG)'s Circular No. 28 of 2010-11",
    date: "24/12/2010",
    subject: "DG(BLDG)'s Circular No. 28 of 2010-11",
  },
];

export const Building_Sanction_Circular_2013_14_List = [
  {
    date: "21/06/2013",
    subject: "Installation Solar system ur 147",
    fileStoreId: "c014e2f2-0041-49df-8aa8-1591ec1516ad",
    label: "DG(BLDG)'s Circular No. 6 of 2013-14",
  },
  {
    date: "01/11/2013",
    subject: "FAR in case of gifting of strip of land and corner splay",
    fileStoreId: "4665c42d-ca84-4a81-b14c-8de0d7fc0e8b",
    label: "DG(BLDG)'s Circular No. 8 of 2013-14",
  },
  {
    date: "01/11/2013",
    subject: "Floor to floor height",
    fileStoreId: "63257ba8-345a-4fd1-9ad3-dedc112d9ffe",
    label: "DG(BLDG)'s Circular No. 9 of 2013-14",
  },
  {
    date: "30/12/2013",
    subject: "15% 25% additional room etc (Circular 9)",
    fileStoreId: "deb3309f-8085-45be-b757-53077a43f7d0",
    label: "DG(BLDG)'s Circular No. 9 of 2013-14",
  },
  {
    date: "08/01/2014",
    subject: "Guideline for proposals under Rule 142",
    fileStoreId: "bd12af1a-8f50-472d-b1ae-e6479083ec04",
    label: "DG(BLDG)'s Circular No. 11 of 2013-14",
  },
  {
    date: "22/01/2014",
    subject: "Procedure of Sanction in JOKA",
    fileStoreId: "c6fd03a3-293d-4afe-bf65-f62b30e5a94e",
    label: "DG(BLDG)'s Circular No. 12 of 2013-14",
  },
];

export const Building_OfficeOreder_2010_List = [
  {
    fileStoreId: "2dc43fce-9276-41f7-9f43-99992691ae2c",
    label: "DG(BLDG)'s Office Order No. 08 of 2010-2011",
    date: "01/10/2010",
    subject: "Bridge approach us 406(3)",
  },
];

export const AboutKolkataLeftMenuList = [
  { type: "link", to: "/About_Kolkata", label: "About Kolkata", active: true },
  { type: "link", to: "/map", label: "Map" },
  { type: "link", to: "/History_Of_Kolkata", label: "History" },
  {
    type: "collapse",
    id: "demo",
    label: "Places of Interest",
    children: [
      { type: "link", to: "/Art_Galleries", label: "1. Art Galleries" },
      { type: "link", to: "/Amusement_Parks", label: "2. Amusement Park" },
      { type: "link", to: "/Architecture", label: "3. Architecture" },
      {
        type: "link",
        to: "/Other_Noteable_place",
        label: "4. Other Notable Places",
      },
    ],
  },
  { type: "link", to: "/Basic_statestics", label: "Basic Statistics" },
  { type: "link", to: "/UEVRP_Home", label: "UEVRP" },
];

export const HrSystemLeftMenuList = [
  {
    type: "filestore",
    fileStoreId: "063f9d96-5752-425b-b1a2-38fa823a80a5",
    label: "Notification",
  },
  { type: "link", to: "/OfficeOrderCircular", label: "Office Order/Circular" },
];

export const PublicationLeftMenuList = [
  { type: "link", to: "/E_News_Letter", label: "E-News Letter", active: true },
  { type: "link", to: "/E_Purashree", label: "E-Purashree" },
  { type: "link", to: "/Archive", label: "Archive" },
  { type: "link", to: "/Monsoon_Book", label: "Monsoon Book" },
];

export const headerHeight = 190;

export const Parks_and_gardens_Borough_DATA = {
  I: [
    {
      name: "C.I.T. Park at Rani Harashamukhi Rd.",
      ward: 4,
      area: "",
      mali: "",
      amenities: "Children's Park & Playground",
      remarks: "",
    },
    {
      name: "Bengal Gymkhana Ground",
      ward: 5,
      area: "NA",
      mali: "",
      amenities: "Nursery & Playground",
      remarks: "NA",
    },
    {
      name: "Children & Ladies Park at Tarasankar Sarani",
      ward: 5,
      area: "27,758.52",
      mali: "",
      amenities: "Nursery & Playground",
      remarks: "NA",
    },
    {
      name: "Jatindra Mohan Park (Tala Jheel Park)",
      ward: 5,
      area: "27,758.52",
      mali: "",
      amenities: "Nursery",
      remarks: "NA",
    },
    {
      name: "Sister Nivedita Uddyan",
      ward: 7,
      area: "NA",
      mali: "",
      amenities: "Playground & Children's Park",
      remarks: "NA",
    },
    {
      name: "Kumartully Park at 18 Abhoy Mitra St.",
      ward: 9,
      area: "NA",
      mali: "",
      amenities: "Playground & Children's Park",
      remarks: "NA",
    },
    {
      name: "Children's Park at Biswanath Colony South Sinthi Road",
      ward: 2,
      area: "1226.56",
      mali: "",
      amenities: "NA",
      remarks: "NA",
    },
    {
      name: "Children's Park at Panchanantala",
      ward: 2,
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Park at Sabji Bangan",
      ward: 2,
      area: "NA",
      mali: "",
      amenities: "Playground",
      remarks: "NA",
    },
    {
      name: "Children's Park at Northern Avenue",
      ward: 4,
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Biplobi Ganesh Ghosh Uddyan Northern Avenue",
      ward: 4,
      area: "NA",
      mali: "",
      amenities: "Children's Park & Playground",
      remarks: "NA",
    },
    {
      name: "Talapark Circus Maidan, Tara Sankar Sarani",
      ward: 5,
      area: "NA",
      mali: "",
      amenities: "Play Ground",
      remarks: "NA",
    },
    {
      name: "Maharaja Narendra K. Deb. Jatindra Mohan Avenue Park",
      ward: 9,
      area: "NA",
      mali: "",
      amenities: "NA",
      remarks: "NA",
    },
  ],
  II: [
    {
      name: "Gouribari C.I.T. Park",
      ward: 12,
      area: "1542.60",
      mali: "",
      amenities: "Children's Playground",
      remarks: "",
    },
    {
      name: "Deshbandhu Park at Raja Dinendra St.",
      ward: 12,
      area: "72310.94",
      mali: "",
      amenities: "Nursery, Ladies corner playground",
      remarks: "",
    },
    {
      name: "Goabagan C.I.T. Park",
      ward: 16,
      area: "3110.29",
      mali: "",
      amenities: "Playground",
      remarks: "",
    },
    {
      name: "B.K.Pal Park",
      ward: 19,
      area: "4433.19",
      mali: "",
      amenities: "Children's Park",
      remarks: "",
    },
  ],
  III: [
    {
      name: "Bagmari Park (At Maniktola Main Rd.), beside housing estate",
      ward: 29,
      area: "NA",
      mali: "",
      amenities: "Playground",
      remarks: "NA",
    },
    {
      name: "New Park at 106/C, Narkeldanga Rd. (Vivek Uddyan)",
      ward: 30,
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "A.P.C. Park at Ramkrishna Samadhi Rd.",
      ward: 31,
      area: "NA",
      mali: "",
      amenities: "Children's park, Nursery, Green house, Playground",
      remarks: "NA",
    },
    {
      name: "Prafulla Khudiram Uddyan at CIT Sect. VIII M",
      ward: 32,
      area: "NA",
      mali: "",
      amenities: "Children's corner, Landscape, Garden fountain, Lighting.",
      remarks: "NA",
    },
    {
      name: "Ramkrishna Mahila Sishu Uddyan",
      ward: 31,
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
  ],
  IV: [
    {
      name: "Jorabagan Park, 2, Baisnab Sett St.",
      ward: 21,
      area: "7549.98",
      mali: "",
      amenities: "Playground, Children's Park, Religious Function Club",
      remarks: "Water Reservoir",
    },
    {
      name: "Satyanarayan Park at the Junction of Kalakar St. & Cotton St.",
      ward: "23",
      area: "2846.45",
      mali: "",
      amenities: "Children's Park",
      remarks: "Under Ground Market",
    },
    {
      name: "Girish Park at the Junction of C.R.Avenue & Vivekanda Rd.",
      ward: "25",
      area: "3649.58",
      mali: "",
      amenities:
        "Children's Park, Landscape, Garden Fountain, Lilypool with over bridge.",
      remarks: "NA",
    },
    {
      name: "Kalisinghi Park",
      ward: "25",
      area: "2782.36",
      mali: "",
      amenities: "Playground",
      remarks: "NA",
    },
    {
      name: "Rabindra Kanan at 9, Beadon St.",
      ward: "26",
      area: "14,084.10",
      mali: "",
      amenities:
        "Playground, Children's Park, Religious Centre, CMC building, Club Temple",
      remarks: "NA",
    },
    {
      name: "Azad Hind Bag at 5, Bidhan Sarani",
      ward: "27",
      area: "15,785.57",
      mali: "",
      amenities:
        "Tank at the Centre for Swimming Practice, Children's park, Shelter Shed & Flower Garden",
      remarks: "NA",
    },
    {
      name: "Sadhana Sankar Uddyan at 204/2, APC Rd.",
      ward: "28",
      area: "3545.06",
      mali: "",
      amenities: "Mohila Yoga Kendra",
      remarks: "NA",
    },
    {
      name: "Vidyasagar Park at 26/1, Badur Bagan Lane",
      ward: "38",
      area: "3356.94",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Hrishikesh Park",
      ward: "38",
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Tarasundar Park, 56, Ratan Sankar Garden Lane",
      ward: "23",
      area: "1615.90",
      mali: "",
      amenities: " VAT CESC's Room",
      remarks: "NA",
    },
    {
      name: "Saroda Banerjee Park",
      ward: "25",
      area: " 2782.36",
      mali: "",
      amenities: "Playground",
      remarks: "NA",
    },
    {
      name: "Jhama Pukur Square at 36, Guru Prosad Chowdhury Lane",
      ward: "38",
      area: "1895.71",
      mali: "",
      amenities: "Playground",
      remarks: "NA",
    },
  ],
  V: [
    {
      name: "Vidyasagar Uddyan (College Square) 53/1, College St.",
      ward: "40",
      area: "17,792.21",
      mali: "",
      amenities: "Children's Corner & Swimming Tank",
      remarks: "Water Body",
    },
    {
      name: "Millenium Park from Babughat to Kadamtala",
      ward: "45",
      area: "NA",
      mali: "",
      amenities: "Garden",
      remarks: "NA",
    },
    {
      name: "Town Hall & Millenium Park",
      ward: "45",
      area: "NA",
      mali: "",
      amenities: "Landscape & Flower Bed",
      remarks: "NA",
    },
    {
      name: "Shradhananda Park at 34, Suyra Sen St.",
      ward: "49",
      area: "6613.55",
      mali: "",
      amenities: "Children's Playground, Nursery, Flower Bed, KMC Office",
      remarks: "NA",
    },
    {
      name: "Santosh Mitra Square (Lebutola Park), Ram Narayan Motilal Lane",
      ward: "50",
      area: "9832.53",
      mali: "",
      amenities: "Children's Playground, Nursery",
      remarks: "NA",
    },
  ],
  VI: [
    {
      name: "Chaplin Square & CMO Bldg. 5/2, Chowringhee Place, Kol-13",
      ward: "46",
      area: "NA",
      mali: "",
      amenities: "Children's Corner",
      remarks: "NA",
    },
    {
      name: "Girin Banerjee Park on Ganesh Ch. Avenue",
      ward: "47",
      area: "2742.41",
      mali: "",
      amenities: "Children's Corner & Nursery",
      remarks: "NA",
    },
    {
      name: "Convent Park at 13, Convent Rd.",
      ward: "55",
      area: "4297.55",
      mali: "",
      amenities: "Children's Corner, Nursery",
      remarks: "NA",
    },
    {
      name: "Ramlila Park",
      ward: "55",
      area: "NA",
      mali: "",
      amenities: "Playground & Children's Park",
      remarks: "NA",
    },
    {
      name: "C.I.T. Padyapukur Park",
      ward: "55",
      area: "NA",
      mali: "",
      amenities: "Playground",
      remarks: "NA",
    },
    {
      name: "Hazi Mohammed Mahasin Square",
      ward: "62",
      area: "16,588.22",
      mali: "",
      amenities: "Pond",
      remarks: "NA",
    },
    {
      name: "Mireea Elliod Square (Ripon Square)",
      ward: "62",
      area: "2325.02",
      mali: "",
      amenities: "Playground",
      remarks: "NA",
    },
    {
      name: "Triangular Park Jn. of Rafi Ahmed Kidwai St. & Ripon St.",
      ward: "62",
      area: "NA",
      mali: "",
      amenities: "NA",
      remarks: "NA",
    },
    {
      name: "Park opposite Pearless Inn",
      ward: "46",
      area: "NA",
      mali: "",
      amenities: "NA",
      remarks: "NA",
    },
  ],
  VII: [
    {
      name: "Rana Pratap Uddyan (Mc. Pherson Square) at 14/1, Loudon St.",
      ward: "63",
      area: "4180.50",
      mali: "",
      amenities: "Park & Nursery",
      remarks: "NA",
    },
    {
      name: "Loudon Square (Nature Park) at 4, Loudon St.",
      ward: "63",
      area: "7625.23",
      mali: "",
      amenities: "Nature Study Park",
      remarks: "NA",
    },
    {
      name: "Gopinath Saha Uddyan (Allen Park) at 28, Park St.",
      ward: "63",
      area: "5493.18",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Victoria Sq./Albent TRd.",
      ward: "63",
      area: "13,310.71",
      mali: "",
      amenities: "Park & Water Body",
      remarks: "NA",
    },
    {
      name: "Mintoo Park, 5/1, A.J.C. Bose Rd.",
      ward: "63",
      area: "14,782.25",
      mali: "",
      amenities: "Park & Water Body",
      remarks: "NA",
    },
    {
      name: "National Congress Park (Park Circus Maidan)",
      ward: "64",
      area: "36,954.40",
      mali: "",
      amenities: "NA",
      remarks: "NA",
    },
    {
      name: "Children Park on Ekdalia Rd.",
      ward: "68",
      area: "NA",
      mali: "",
      amenities: "Children's Corner",
      remarks: "NA",
    },
    {
      name: "Deshapriya Park",
      ward: "85",
      area: "27,628.65",
      mali: "",
      amenities: "Playground, Tennis Court, Children's Park",
      remarks: "NA",
    },
    {
      name: "Children's Park at 108, D.C.Dey Rd.",
      ward: "56",
      area: "3854.42",
      mali: "",
      amenities: "Childern's Park",
      remarks: "NA",
    },
    {
      name: "Park at 7, Carnfield Rd.",
      ward: "68",
      area: "NA",
      mali: "",
      amenities: "Children's Corner",
      remarks: "NA",
    },
  ],
  VIII: [
    {
      name: "Maddox Square at 9, Pankaj Mallik Sarani",
      ward: "69",
      area: "NA",
      mali: "",
      amenities: "Children's Playground",
      remarks: "NA",
    },
    {
      name: "Dwarkanath Mitra Square at 13, Ashutosh Mukherjee Rd., Kolkata-20",
      ward: "70",
      area: "NA",
      mali: "",
      amenities: "Children's Playground",
      remarks: "NA",
    },
    {
      name: "Northern Park at 48, Allenby Rd.",
      ward: "70",
      area: "NA",
      mali: "",
      amenities: "Children's Playground",
      remarks: "NA",
    },
    {
      name: "Woodburn Park at 28 Woodburn Rd.",
      ward: "70",
      area: "NA",
      mali: "",
      amenities: "Children's Corner & Playground",
      remarks: "NA",
    },
    {
      name: "Landsdown Square at 49, Padmapukur",
      ward: "72",
      area: "NA",
      mali: "",
      amenities: "Water Tank",
      remarks: "NA",
    },
    {
      name: "Harish Park at 16, Harish Mukherjee Rd. Kolkata-25",
      ward: "73",
      area: "NA",
      mali: "",
      amenities: "Children's Corner & Playground",
      remarks: "NA",
    },
    {
      name: "Jatin Das Park at 9/1, S.P.Mukherjee Rd. Kolkata-25",
      ward: "73",
      area: "NA",
      mali: "",
      amenities: "Children's Corner & Playground",
      remarks: "NA",
    },
    {
      name: "Kalighat Park at 125, S.P.Mukherjee Rd.",
      ward: "84",
      area: "NA",
      mali: "",
      amenities: "Children's Corner & Playground",
      remarks: "NA",
    },
    {
      name: "Sarat Chatterjee PArk (Triangular Park) at 172/2, R.B.Avenue. Kolkata-29",
      ward: "86",
      area: "NA",
      mali: "",
      amenities: "NA",
      remarks: "NA",
    },
  ],
  IX: [
    {
      name: "Padmapukur Square (Khidirpore)",
      ward: "76",
      area: "NA",
      mali: "",
      amenities: "Tank & Garden",
      remarks: "NA",
    },
    {
      name: "Nabab Ali Park (Ekbalpur)",
      ward: "78",
      area: "NA",
      mali: "",
      amenities: "NA",
      remarks: "NA",
    },
    {
      name: "Chetla Park at 30, Chetla Central Rd.",
      ward: "82",
      area: "8568.17",
      mali: "",
      amenities: "Children's Corner & Playground",
      remarks: "NA",
    },
    {
      name: "Mysore Garden (Tollygunge Rd.)",
      ward: "88",
      area: "3015.35",
      mali: "",
      amenities: "Flower Garden",
      remarks: "NA",
    },
    {
      name: "Triangular Park on Pratapaditya Rd.",
      ward: "88",
      area: "NA",
      mali: "",
      amenities: "Garden",
      remarks: "NA",
    },
    {
      name: "Alipore Office Garden",
      ward: "74",
      area: "NA",
      mali: "",
      amenities: "Nursery",
      remarks: "NA",
    },
    {
      name: "Mani Sannyal Uddyan",
      ward: "82",
      area: "NA",
      mali: "",
      amenities: "Garden",
      remarks: "NA",
    },
    {
      name: "Deshpran Sashmal Park at 10, Nepal Bhattacharjee St.",
      ward: "83",
      area: "4265.97",
      mali: "",
      amenities: "Playground & Children's Park",
      remarks: "NA",
    },
    {
      name: "Desh Bandhu C.R.Das Memorial. 111, Tollygunge Road",
      ward: "88",
      area: "NA",
      mali: "",
      amenities: "Flower Garden with memorial tomb of Deshbandhu C.R.Das",
      remarks: "NA",
    },
  ],
  X: [
    {
      name: "Datu Fadkar Memorial (New Alipur)",
      ward: "81",
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Tanupukur Park at Sarat Ghosh Garden Rd.",
      ward: "92",
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Jodhpur Children's Park",
      ward: "93",
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Tilak Nagar Park",
      ward: "95",
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Sishu Uddyan at Regent Estate Park",
      ward: "96",
      area: "NA",
      mali: "",
      amenities: "Children's Playground",
      remarks: "NA",
    },
    {
      name: "Regent Park in Govt. Estate at N.S.C.Bose RD.",
      ward: "97",
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Niranjan Sengupta Park",
      ward: "99",
      area: "NA",
      mali: "",
      amenities: "Children's Park & Playground",
      remarks: "NA",
    },
    {
      name: "Park at New Alipore 'O' Block",
      ward: "81",
      area: "2960.17",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Park at New Alipore 'H' Block",
      ward: "81",
      area: "1872.86",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Tarakeswar Sen Uddyan at Babu Bagan",
      ward: "92",
      area: "NA",
      mali: "",
      amenities: "Playground",
      remarks: "NA",
    },
    {
      name: "Bimal Ghosg Uddyan",
      ward: "92",
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Layalka Park (N.S.C. Bose Rd.)",
      ward: "96",
      area: "NA",
      mali: "",
      amenities: "Children's Park & Playground",
      remarks: "NA",
    },
    {
      name: "Bijoygarh Park (Bijoygarh Rd.)",
      ward: "96",
      area: "NA",
      mali: "",
      amenities: "Children's Park & Playground",
      remarks: "NA",
    },
    {
      name: "RABINDRA VIVEKANANDA SARDHA SATABARSHO SMARAK UDDAN",
      ward: "97",
      area: "NA",
      mali: "",
      amenities: "Playground & Nursery",
      remarks: "NA",
    },
    {
      name: "Jibananda Park",
      ward: "98",
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
    {
      name: "Park at Sree Colony Block, Block-1",
      ward: "99",
      area: "NA",
      mali: "",
      amenities: "Children's Park & Playground",
      remarks: "NA",
    },
    {
      name: "Lakshi Narayan Park",
      ward: "100",
      area: "NA",
      mali: "",
      amenities: "Children's Park",
      remarks: "NA",
    },
  ],
};



export const CitizenCharterLeftMenuList = [
  {
    type: "link",
    to: "/Citizen_charter_Home",
    label: "Citizen Charter's Home",
    active: true,
  },
  { type: "link", to: "/Citizen_Charter_Ads", label: "Citizen's Charter ads" },
];

export const DownloadableFormsDepartments = [
  {
    key: "advertisement",
    label: "Deparment: ADVERTISEMENT",
    files: [
      {
        fileStoreId: "73a27d6e-da1f-4956-9c6d-18f5dc4f8c09",
        label: "Application Form for Empanelment of Advertising Agencies",
      },
      {
        fileStoreId: "d003763e-f005-416d-9c58-e9d49393a430",
        label: "Form for Application for Erection of Hoarding",
      },
      {
        fileStoreId: "22f5550f-cd80-40a6-907e-3f23e7c11923",
        label: "Sample Affidavit Format",
      },
    ],
  },
  {
    key: "amusement",
    label: "Deparment: AMUSEMENT",
    files: [
      {
        fileStoreId: "edb6058b-a96b-4360-979d-73809f2b16e8",
        label: "Form for Permission under Section 422 of the C.M.C. Act,1980",
      },
    ],
  },
  {
    key: "assessment",
    label: "Deparment: ASSESSMENT",
    files: [
      {
        fileStoreId: "2dc92a2f-cf16-4b52-ac7e-bc5ff3eae60c",
        label: "Exemption Form",
      },
      {
        fileStoreId: "36acace5-f03e-4893-8fce-a959dd00dcb3",
        label: "Form No. A - 75 when tenant - lessee moves in",
      },
      {
        fileStoreId: "37e7172e-2060-4b27-b36a-65ad95fe8cd3",
        label: "Form No. A - 75 when tenant - lessee moves out",
      },
      {
        fileStoreId: "c31fb1a1-6d07-44bb-a8d8-30241f67ee52",
        label:
          "Form No.A-42 Application for Entry of Names in the Assessment Register U/S 183 and Separation/Amalgamation of numbers(s) U/S 178(4) and Apportionment U/S 178-2--II- Proviso of the Kolkata Municipal Act, 1980.]",
      },
      {
        fileStoreId: "08508f5f-1c30-46a9-92c6-5502442e3490",
        label: "Property Information form",
      },
      {
        fileStoreId: "4946ce1d-6c77-47de-97b1-7f8abfe48836",
        label: "SAF Form",
      },
    ],
  },
  {
    key: "bs-ssep",
    label: "Deparment: BS & SSEP",
    files: [
      {
        fileStoreId: "00748f61-2430-49a4-b3e3-21b0f47e4b05",
        label: "IGNDPS Form",
      },
      {
        fileStoreId: "8fe6ac81-fb77-4902-86c8-1264d193e0ca",
        label: "IGNOAPS Form",
      },
      {
        fileStoreId: "b87b5805-9ce0-4ed6-bd63-b62ea99e0b11",
        label: "IGNWPS Form",
      },
      {
        fileStoreId: "e2547f50-e50e-432f-bd41-6c1ca3052417",
        label: "III-U (NFSA/RKSY)  Form",
      },
      {
        fileStoreId: "46dc9e8f-771e-4d7b-b76c-6adf0b346b74",
        label: "IV-U (NFSA/RKSY) Form",
      },
      {
        fileStoreId: "273a6280-773c-4cc5-af8f-d32eb2effe9d",
        label: "N.F.B.S Application Form",
      },
      {
        fileStoreId: "7760e179-a44b-4428-b793-4c157d000afa",
        label: "V-U (NFSA/RKSY)  Form ",
      },
      {
        fileStoreId: "a1dc6531-45a1-42df-ac36-5346d68a4ad1",
        label: "VI-U (NFSA/RKSY) Form",
      },
    ],
  },
  {
    key: "building",
    label: "Deparment: BUILDING",
    files: [
      { fileStoreId: "b36dcf67-15a2-4b44-ad86-d3fa1c78c09c", label: "Annex G" },
      {
        fileStoreId: "14d99e5e-7348-4b00-b824-8ca9324e1346",
        label: "Building Application Form",
      },
      {
        fileStoreId: "ede81c55-ab15-40af-b1ef-cb588b219c87",
        label: "Composite Declaration Form",
      },
      {
        fileStoreId: "141512b1-61f4-4e22-b0f5-e63e7bb2946e",
        label: "Declaration Form",
      },
      {
        fileStoreId: "ef4ba4dd-67c7-45a9-92dd-8061355e61ed",
        label: "General Undertaking Form",
      },
      {
        fileStoreId: "0e8cb1ae-0881-47b6-b4a7-42fcbf379547",
        label: "Indemnity Form",
      },
      {
        fileStoreId: "ca2bb3c9-909c-46d8-ac7f-33d3e9e3e538",
        label: "Notice of Commencement Form ",
      },
      {
        fileStoreId: "44021b4b-434f-4b78-95c6-0409d73abc8f",
        label: "Notice of Completion",
      },
      {
        fileStoreId: "a3631ed1-4b71-487d-9a14-118cb66c846c",
        label: "Notice of Completion(Upto plinth level)",
      },
      {
        fileStoreId: "2ba0e315-a24b-4d62-a215-999d74d3938c",
        label: "Notice of Inspection of Drainage Form",
      },
    ],
  },
  {
    key: "chvs",
    label: "Deparment: CHVS DEPARTMENT",
    files: [
      {
        fileStoreId: "a1242559-5e4f-4169-9ca8-fe8b5f8a08f1",
        label: "Development Fees Application Form ",
      },
      {
        fileStoreId: "317fa143-7e34-4011-83fa-b4e02e8572e3",
        label: "Survey Observation Report (SOR) Application Form ",
      },
    ],
  },
  {
    key: "civil",
    label: "Deparment: CIVIL",
    files: [
      {
        fileStoreId: "fdf060ec-83a1-46ff-b30a-e19443b5c401",
        label: "Tender Form Format ",
      },
    ],
  },
  {
    key: "finance-accounts",
    label: "Deparment: Finance &  Accounts",
    files: [
      {
        fileStoreId: "47a2a6c9-0518-45d1-9eda-f96a6b4920db",
        label: "NEFT/RTGS/CBS MANDATE FORM ",
      },
    ],
  },
  {
    key: "heritage-buildings",
    label: "Deparment: HERITAGE BUILDINGS",
    files: [
      {
        fileStoreId: "9699f885-7aa9-42f2-afed-4af075472d5f",
        label:
          "Application form for exemption of property tax for Heritage Building u/s 425K of KMC Act, 1980 ",
      },
      {
        fileStoreId: "a697e1cf-0e56-44c6-bcb5-de2fd86ad503",
        label: "Composition of the Heritage Conservation Committee",
      },
    ],
  },
  {
    key: "license",
    label: "Deparment: LICENSE",
    files: [
      {
        fileStoreId: "ef3b9e56-ae10-409f-b276-658b82222a1e",
        label:
          "Application Form for Obtaining Of Enlistment (Trade Licence) For P/ Trades /Callings",
      },
      {
        fileStoreId: "41110620-be7a-4523-a299-c07a044be4a0",
        label: "Ceremonial House Application Form & Instruction",
      },
      {
        fileStoreId: "c441eb37-b312-42dc-a70e-730c8af7f4da",
        label: "Licence Self Declaration Format for Obtaining New C.E",
      },
    ],
  },
  {
    key: "municipal-secretarys",
    label: "Deparment: MUNICIPAL SECRETARY'S",
    files: [
      {
        fileStoreId: "09dba691-f76e-4743-b039-ee4fe32a933a",
        label: "Mediclaim Form",
      },
      {
        fileStoreId: "5a3928cf-83b6-4739-8ff9-da898863b877",
        label: "NEFT/RTGS/CBS Mandate Form",
      },
    ],
  },
  {
    key: "pension",
    label: "Deparment: PENSION",
    files: [
      {
        fileStoreId: "2127cf75-7066-4498-b860-497fa0004740",
        label: "ANNEXURE - III",
      },
    ],
  },
  {
    key: "personnel",
    label: "Deparment: PERSONNEL",
    files: [
      {
        fileStoreId: "31dc536a-bc00-460c-9ff1-a71d7c77fee6",
        label:
          "(Annexure 'B' ) Form for issuing 'N.O.C' to obtain VISA for travelling abroad. ",
      },
      {
        fileStoreId: "6ec71c4d-5151-46b8-9edf-1ff2dd5ad75b",
        label:
          "(Annexure 'E' ) Form to issue 'N.O.C' to obtaining International Passport ",
      },
      {
        fileStoreId: "64be9d46-a601-4721-ad52-0e9e71f84f36",
        label: "Format of Contractual Input Details",
      },
      {
        fileStoreId: "ccb0a0cc-71e2-4151-a0d0-be559f45eb63",
        label: "Prayer for issuance of NOC to apply for employment",
      },
    ],
  },
  {
    key: "pf",
    label: "Deparment: PF",
    files: [
      {
        fileStoreId: "6f3ed8b8-e86b-4ca2-a144-c060f4c15e58",
        label: "Application Form For Withdrawal/Advance from G.P.F",
      },
    ],
  },
  {
    key: "uevrp",
    label: "Deparment: UEVRP",
    files: [
      {
        fileStoreId: "bb01d4ea-ee4d-465d-ace1-bc5c41b10432",
        label: "FORM for Inventory of School for DM ",
      },
    ],
  },
  {
    key: "water-supply",
    label: "Deparment: WATER SUPPLY ",
    files: [
      {
        fileStoreId: "db474a1f-c80f-4a13-9904-d84ceaf6aed9",
        label: "Application Form For Obtaining Private Water Supply Connection",
      },
    ],
  },
];

export const GrievanceRedressalLeftMenuList = [
  {
    type: "link",
    to: "/Procedure",
    label: "Procedure",
    active: true,
  },
  { type: "redirect", label: "Search Grievances" },
  {
    type: "anchor",
    href: `https://www.kmcgov.in/KMCPortal/ComplaintFormAction.do`,
    label: "Download Complaint Form",
  },
  {
    type: "link",
    to: "/TERM_Cell",
    label: "TERM Cell",
  },
  {
    type: "link",
    to: "/Pollution_Control_Board",
    label: "Pollution Control Board",
  },
  {
    type: "filestore",
    fileStoreId: "",
    label: "Grievance Redressal Cell(PMU)",
  },

];

export const RecruitmentResultTrainingLeftMenuList = [
  {
    type: "link",
    to: "/KMC_Recruitments",
    label: "KMC Recruitments",
    active: true,
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Online Application",
  },
  {
    type: "filestore",
    fileStoreId: "83437ae9-0220-4c00-b251-8eed2a2402e1",
    label: "Recruitment Guideline",
  },
  {
    type: "link",
    to: "/KMC_Results",
    label: "KMC Results",
  },
  {
    type: "link",
    to: "/KMC_Training",
    label: "KMC Training",
  },
];

export const UEVRPLeftMenuList = [
  {
    type: "link",
    to: "/UEVRP_Home",
    label: "UEVRP Home",
    active: true,
  },
  {
    type: "link",
    to: "/UEVRP_Status",
    label: "UEVRP Status",
  },
  {
    type: "link",
    to: "/Earthquake_Leaflet",
    label: "Earthquake Leaflet",
  },
  {
    type: "link",
    to: "/EQ_Pocket_Guide",
    label: "EQ Pocket Guide",
  },
  {
    type: "link",
    to: "/Disaster_Mgmt",
    label: "School Safety",
  },
];

export const SchoolSafetyLeftMenuList = [
  {
    type: "link",
    to: "/Disaster_Mgmt",
    label: "Disaster Mgmt",
    active: true,
  },
  {
    type: "link",
    to: "/Concept_Note",
    label: "Concept Note",
  },
  {
    type: "link",
    to: "/Guidelines_for_Safety",
    label: "Guidelines for Safety",
  },
  {
    type: "link",
    to: "/Form_For_Inventory",
    label: "Form For Inventory",
  },
  {
    type: "link",
    to: "/School_Safety_Booklet",
    label: "School Safety Booklet",
  },
  {
    type: "link",
    to: "/Colouring_Activity_Book",
    label: "Colouring Activity Book",
  },
];

export const DrainageLeftMenuList = [
  {
    type: "link",
    to: "/Drainage_Home",
    label: "Drainage Home",
    active: true,
  },
  { type: "redirect", label: "Ward wise Drainage Network Map" },
  {
    type: "filestore",
    fileStoreId: "d912eaca-a139-441f-9d24-89256d6a782e",
    label: "Fees & Charges",
  },
  {
    type: "link",
    to: "/Drainage_Drainage_Pumping_station",
    label: "Drainage Pumping Station",
    active: true,
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Check Demands Payable",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Print Unpaid Bill",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Make Online Payment",
  },
  {
    type: "anchor",
    href: `${prodURL}/citizen/language-selection`,
    label: "Reprint e-Receipt",
  },
  { type: "redirect", label: "List of KMC Drainage Activity" },
  {
    type: "link",
    to: "/Drainage_Faqs",
    label: "FAQs",
    active: true,
  },
  {
    type: "filestore",
    fileStoreId: "3c27e3a5-f6f1-4de2-84ee-3d7f3cd41121",
    label: "Activity Chart for Desilting",
  },
  {
    type: "anchor",
    href: `${prodURL}/contact-us/departmentContacts`,
    label: "Contact Details",
  },
];

export const MunicipalHistoryLeftMenuList = [
  { type: "link", to: "/MunicipalHistory", label: "Municipal History" },
  { type: "link", to: "/MayorsOfKolkata", label: "Mayors of Kolkata" },
];
